import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  Optional,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "app/auth/auth.service";
import { SiteloaderComponent } from "app/auth/siteloader/siteloader.component";
import { DashboardService } from "app/dashboard/dashboard.service";
import { AppointmentListComponent } from "app/opdvisits/appointment-list/appointment-list.component";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { LanguageService } from "app/shared/language.service";
import { SearchDialogComponent } from "app/table-list/Searchdialog/SearchDialoag.component";
import { ShortRegistoreComponent } from "./short-registore/short-registore.component";
import { MatTableDataSource } from "@angular/material/table";
import { Observable, fromEvent, interval, of } from "rxjs";
import { AddServiceComponent } from "./add-service/add-service.component";
import { BillingSearchComponent } from "./billing-search/billing-search.component";
import { VisitComponent } from "./visit/visit.component";
import { PrintInvoiceComponent } from "./print-invoice/print-invoice.component";
import { ReciptComponent } from "./recipt/recipt.component";
import { BillingserviceService } from "./billingService.service";
import { ChatbotAutomationService, BillingAutomationPayload, BillSavedSummary } from "app/shared/chatbot-automation.service";
import {
  exhaustMap,
  map,
  startWith,
  take,
  takeUntil,
  tap,
} from "rxjs/operators";
import { Subject } from "rxjs";
import {
  BillingApprovalChange,
  DiscountApprovalChange,
  PartyTpaModel,
  RequestBillDiscountDetail,
  ServiceList,
  billCancelReuest,
} from "./Models/billing.Models";
import { BillingFormModel, ReciptFormModel } from "./Models/billdetail.model";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { AdvanceRecieptComponent } from "./advance-reciept/advance-reciept.component";
import { CorporateDetailComponent } from "./corporate-detail/corporate-detail.component";
import { IPDService } from "app/ipd/Services/ipdServices.service";
import { AddPackageComponent } from "./add-package/add-package.component";
import { BillRefundComponent } from "./bill-refund/bill-refund.component";
import { BillRecoveryManagerComponent } from "./bill-recovery-manager/bill-recovery-manager.component";
import { ReferredByComponent } from "./referred-by/referred-by.component";
import { HelpListPopupComponent } from "app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component";
import { DynamicHelpListComponent } from "app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { FormControl } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { GetApprovedModel } from "./Models/recoverymanager.model";
import { WaitingReasonComponent } from "app/dashboard/WaitingReason/WaitingReason.component";
import { PatientMoveDialogComponent } from "app/dashboard/patient-move-dialog/patient-move-dialog.component";
// import { PartyDetailModel } from './Models/corporatedetail.model';
@Component({
  selector: "app-billing",
  templateUrl: "./billing.component.html",
  styleUrls: ["./billing.component.scss"],
})
export class BillingComponent implements OnInit {
  format = "CODE39";
  lineColor = "#000000";
  width = 1;
  height = 15;
  displayValue = false;
  fontOptions = "";
  font = "monospace";
  textAlign = "center";
  textPosition = "bottom";
  textMargin = 2;
  fontSize = 10;
  background = "#ffffff";
  margin = 10;
  marginTop = 5;
  marginBottom = 5;
  marginLeft = 10;
  marginRight = 10;
  filterTerm: any;
  filterTerm1: any;
  filterTerm2: any = '';
  selectedRadio: any;

  requestDiscountAmount: RequestBillDiscountDetail = {};
  displayedColumns: string[] = [
    "serviceName",
    "rate",
    "qty",
    "maxDiscountLimit",
    "discount",
    "serviceCharge",
    "NetAmt",
    "serviceId",
    "Action",
  ];
  @ViewChild('doctorlistfocus') doctorlistfocus: ElementRef;
  @ViewChild('savebtnButtonn') savebtnButton: ElementRef;
  @ViewChild('doctorButton') doctorButton: ElementRef;
  @ViewChild('UhidButton') UhidButton: ElementRef;
  @ViewChild('refreshButton') refreshButton: ElementRef;
  @ViewChild('recepitCreateBtn') recepitCreateBtn: ElementRef;
  dataSource = new MatTableDataSource<ServiceList>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  BillingData: BillingFormModel = {};
  ReciptData: ReciptFormModel = {};
  public updatebill: any = {};
  public customBilNumbver: string = "0";
  public VisitDiffernce: any = -1;
  public checkNewReciept: boolean = false;
  walkin = true;
  withappointment = false;
  quantity = 1;
  totalpay: any;
  servicecharge: any;
  lessDiscount: any;
  netbillamount: any = 0;
  currentpayable: any;
  checktpa = 0;
  startdate: any;
  enddate: any;
  cuurentTime: any;
  BillDetailArray: any = [];
  BillingDebitDetail: any = [];
  partyAmount: any;
  copartyAmount: any;
  reporturl: any;
  copartyId: number;
  showspinner = false;
  display1 = "none";
  reciptmodelbox = "none";
  filterdoctor: any;
  RefoundModelBox = "none";
  getBillIdobj: any = {};
  getBillId: any;
  getpatientId: number;
  getBillDetailId: any;
  getBillTransId: any;
  BillListArray: any = [];
  interval;
  DipositeType: any = [];
  BnakType: any = [];
  PaymentType: any = [];
  private automationDefaultBankId: number | null = null;
  ReciptArray: any = [];
  getreciptobj: any[];
  getbillingReson: string = "";
  is_editalbe: boolean;
  partylistSecond: any = [];
  selectUsertypeid: number = 0;
  public RecieptDepositedAmmount: any;
  public reciptBlanceAmmount: any;
  public currentAmount: number;
  public BillingRemarkArray: any = [];
  public masterconfigurationDiscount: any;
  public isupdate: boolean;
  public patientLastServiceobj: any = {};
  public lastVistdate: any;
  public PageHeader: any = {};
  public QrCode: any = {};
  public billsericeName: string;
  public RefundAmount: number;
  GetSreviceArrayOne: any = [];
  GetSreviceArraytwo: any = [];
  GetSreviceArraythree: any = [];
  // screenPermissionobj: any = {};
  billApprovalobject: GetApprovedModel = {};
  approvalchange: BillingApprovalChange = {};
  RemoveServiceArray: any = [];
  totalrefundamount: number = 0;
  // checkConsultation:boolean;
  completeBillingObj: any;
  VisitColor: any;
  public stickerObj: any = {};
  filterdept: any;
  searchTxt: any;
  items: any = [];
  discountReason: any = [];
  ipdgestrationId: any = null;
  checkupgradePackageAmount: any = 0;
  headerflag: boolean = true;
  flag: any;
  //RemarkCtrl: FormControl;
  usercommingDashboard: number = 0;
  //filteredRemarkArray: Observable<any[]>;
  AllUserCtrl: FormControl;
  filteredAllUserArray: Observable<any[]>;
  ReasonCtrl: FormControl;
  filterreferd: any;
  searchValue02: any;
  receiptIddata: any;
  receiptprintdata: any;
  doctersSpecData: any;
  DRdata: any;
  docterName: any;
  selectspecId: any;
  approvebyName: string = "";
  mattabindex: number = 0;
  SelectpatientName: any;
  SelectpatientId: any;
  getPatientDetailData: any;
  categoryValidation: boolean;
  BillSerieseValidation: boolean;
  BillEntryValidation: boolean;
  DocterNameValidation: boolean;
  RefeeredBYValidation: boolean;
  PartyTpaValidation: boolean;
  rateTypeValidation: boolean;
  deptValidation: boolean;
  freeValidation: boolean;
  UHIDValidation: boolean;
  billcancelled: boolean = false;
  childevent: boolean = true;
  filteredItems: Observable<any[]>;
  filteredReasonArray: Observable<any[]>;
  inputControl = new FormControl();
  automationWorkflow: BillingAutomationPayload | null = null;
  automationRan: boolean = false;
  private chatAutomationHooked = false;
  /** Defer getlastBill until automation print finishes (avoids clearing patient before print). */
  private _automationPendingLastBillId: number | null = null;
  pendingServiceAutomation: string | null = null;
  pendingAutoSubmit: boolean = false;
  pendingServiceId: number | null = null;


  // refound section

  // RefundData:RefundFormModel={};
  // RefundDataArray:any =[];
  // RecieptIdForRefund:any;
  // partydetail: PartyDetailModel = {}
  @ViewChild('closebutton') closebutton;
  @HostListener("window:keydown", ["$event"])
  onKeyDown(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      document.getElementById("LastVisitModel").style.display = "none";
    }
  }

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private opdvisitService: OpdVisitService,
    private dialog: MatDialog,
    private router: Router,
    private translate: TranslateService,
    private langservice: LanguageService,
    private billingservice: BillingserviceService,
    private branchMatserService: BranchMatserService,
    private dialogRef: MatDialogRef<BillingComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private ipdService: IPDService,
    private chatbotAutomation: ChatbotAutomationService
  ) {
    this.flag = 0;
    dialogRef.disableClose = true;
    translate.addLangs(["en", "fr", "hi"]);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    } else {
      translate.setDefaultLang("en");
    }
    // console.log('current-language', this.langservice.setlang)
    localStorage.removeItem("ServiceOne");
    // this.getBillingPermission();
    // this.getscreenPermission();
    this.AllUserControll();
    this.dashboardService.moudletype
      .pipe(takeUntil(this.destroy$))
      .subscribe((quote) => {
        if (quote == 1) {
          // Don't wipe the form mid-automation when the module tab refreshes
          if (this.automationWorkflow) {
            return;
          }
          this.ngOnInit();
          this.dashboardService.getcategories();
        }
      });

    this.chatbotAutomation.automation$
      .pipe(takeUntil(this.destroy$))
      .subscribe((payload) => {
        console.log('Automation: In-place request from chatbot', payload);
        this.automationWorkflow = payload;
        this.automationRan = false;
        setTimeout(() => this.runChatAutomation(), 150);
      });
  }

  nextFocus() {
    setTimeout(() => this.savebtnButton.nativeElement.focus(), 0);
  }
  selectedRowIndex: number | null = null;

  onRowFocus(index: number) {
    this.selectedRowIndex = index;
  }
  indexvalue: number = -1;
  focusonrow() {
    this.indexvalue = 0;
  }

  selectRow(index: number) {
    this.selectedRowIndex = index;

  }
  referedbyControll() {
    this.inputControl = new FormControl();
    this.filteredItems = this.inputControl.valueChanges
      .pipe(
        startWith(""),
        map(cat => cat ? this.filter(cat) : this.opdvisitService.personmaster.slice())
      );
  }
  newPersonArray: any = [];
  filter(value: any) {
    if (value && (typeof value != 'number')) {
      const filterValue = value.toLowerCase();
      const returndata = this.opdvisitService.personmaster.filter(country =>
        country.personName?.toLowerCase().indexOf(filterValue) === 0);
      if (returndata.length == 0 && value.length >= 3) {
        this.opdvisitService.getpersonMasterSpecific('BILLING', value).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
          this.newPersonArray = [];
          this.newPersonArray = x;
          this.filteredItems = this.inputControl.valueChanges
            .pipe(
              startWith(""),
              map(cat => this.newPersonArray.slice())
            );
        })
      } else {
        return returndata;
      }
    }

  }
  //   filter1(value: any) {       
  //     if(value && (typeof value != 'number')){
  //       const filterValue = value.toLowerCase();
  //      return this.newPersonArray.filter(country =>
  //         country.personName?.toLowerCase().indexOf(filterValue) === 0);    
  //     }

  // }

  CheckinputRef(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.BillingData.FK_ReferredById = null;
      this.filterreferd = null;
      this.referedbyControll();
    } else {
      this.filterreferd = checkdata;
    }
  }

  disabledreceptbutton: boolean = false;
  ngAfterViewInit(): void {
    fromEvent(this.button.nativeElement, "click")
      .pipe(
        tap((x) => (this.disabledreceptbutton = true)),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());
  }
  @ViewChild("recepitCreateBtn", { static: true }) button;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));
  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.onSubmitReciept();
      },
      error: (err) => { },
    };
  }

  ngOnInit() {
    this.opdvisitService.getlastvisitid = 0;
    this.currentpayable = 0;
    this.netbillamount = 0;
    this.RecieptDepositedAmmount = 0;
    this.totalpay = 0;
    this.servicecharge = 0;
    this.lessDiscount = 0;
    this.partyAmount = 0;
    this.copartyAmount = 0;
    this.tpatotalreceved = 0;
    this.selftotalrecevered = 0;
    this.childevent = true;
    this.billcancelled = false;
    this.opdvisitService.callsepecificApi = "BILLING";
    this.UHIDValidation = false;
    this.categoryValidation = false;
    this.BillSerieseValidation = false;
    this.BillEntryValidation = false;
    this.DocterNameValidation = false;
    this.RefeeredBYValidation = false;
    this.PartyTpaValidation = false;
    this.rateTypeValidation = false;
    this.deptValidation = false;
    this.freeValidation = false;
    this.opdvisitService.opdvisitmodel.isEmergency = false;
    this.opdvisitService.apptdetail = {};
    this.billApprovalobject.pK_TranID = 0;
    this.flag = 0;
    this.tpaServicediable = true;
    this.discountflag = false;
    this.authService.getServertime();
    this.totalrefundamount = 0;
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.billingservice.savebilldetail.rateTypeId = 0;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.activevisit = 0;
    this.startdate = this.dashboardService.selecteddate;
    this.enddate = this.dashboardService.selecteddate;
    this.billingservice.selectedServiceRow = [];
    this.ReciptData = {};
    this.BillingData = {};
    this.BillingData.FK_RegId = "";


    this.dataSource.data = [];
    this.BillDetailArray = [];
    this.BillingData.BillNo = 0;
    this.opdvisitService.url = "";
    this.isupdate = false;
    this.billingservice.lastbillid = null;
    this.opdvisitService.patientdetails.pkRegId = null;
    this.opdvisitService.patientdetails = {};
    this.lastVistdate = null;
    this.VisitDiffernce = -1;
    this.opdvisitService.PatientisExpire = null;
    this.getBillId = 0;
    this.opdvisitService.BillingDoctorId = null;
    this.BillingRemarkArray = [];
    this.GetSreviceArrayOne = [];
    this.GetSreviceArraytwo = [];
    this.opdvisitService.PatientpartyId = null;
    this.billingservice.billingSticker = null;

    this.billingservice.AdjustedBillingAmount = 0;
    this.RefundAmount = null;
    // this.screenPermissionobj = null;
    this.copartyId = null;
    this.getbillingReson = "";
    this.completeBillingObj = null;
    this.reciptBlanceAmmount = 0;
    this.customBilNumbver = "0";
    this.patientLastServiceobj = null;
    this.BillingData.FK_IPDId = null;
    this.dataSource.data = [];
    this.RemoveServiceArray = [];
    this.opdvisitService.checkAdmissionId = false;
    this.opdvisitService.matclounwidth = 3;
    this.checkupgradePackageAmount = 0;
    // :boolean;
    // this.checkConsultation= false;

    // this.getdoctorlist();
    this.opdvisitService.getpersonmaster("BILLING", 0);
    this.getUserConfrigration();
    this.getBillMasterservice();
    // this.getBillservice();
    this.getPartTpa();
    this.GetRateType();
    this.GetBillType();
    this.getdoctorlistByspecId(0);

    this.getSpecilityData(0);
    //this.getsummary_url();
    // this.getbillingresonsHelplist();
    this.getproductmasterconfig();
    this.setbiilingdata();
    this.dicountReason();
    //  this.RemarkControll();
    // this.ReasonControll();
    // this.getscreenPermission();
    this.selectedRadio = "walkin";
    if (this.data.checkvisit == 1 && this.data.lastbillId > 0) {
      this.opdvisitService.checkshort = true;
      this.getlastBill(this.data.lastbillId);
      this.BillingData.PK_BillId = this.data.lastbillId;
    }
    this.getBranchDetail(this.authService.Loggeduser.branchid);
    this.docterName = "";
    this.selectspecId = "";
    setTimeout((x) => {
      this.getConfiglist();
      this.UhidButton.nativeElement.focus();
    }, 300);
    this.referedbyControll();

    this._loadAutomationReceiptMasters();

    if (!this.chatAutomationHooked) {
      this.chatAutomationHooked = true;
      this.initializeChatAutomation();
      setTimeout(() => this.runChatAutomation(), 900);
    }
  }

  private initializeChatAutomation(): void {
    const navigationState = this.router.getCurrentNavigation()?.extras?.state;
    const historyPayload = history.state?.billingAutomation;
    const payload = navigationState?.billingAutomation || historyPayload || null;

    if (payload) {
      this.automationWorkflow = payload;
      this.automationRan = false;
      // Consume router history so ngOnInit / module refresh won't re-run automation
      if (historyPayload) {
        this._clearNavigationAutomationState();
      }
    }
  }

  private _clearNavigationAutomationState(): void {
    try {
      const st = history.state || {};
      if (st.billingAutomation) {
        history.replaceState({ ...st, billingAutomation: null }, document.title);
      }
    } catch (_) { /* ignore */ }
  }

  private _clearAutomationWorkflow(): void {
    this.automationWorkflow = null;
    this.automationRan = true;
    this._clearNavigationAutomationState();
    this.chatbotAutomation.releasePrintWindow();
  }

  private _flushAutomationPendingLastBill(): void {
    if (this._automationPendingLastBillId) {
      const pendingBillId = this._automationPendingLastBillId;
      this._automationPendingLastBillId = null;
      this.getlastBill(pendingBillId, 0);
    }
  }

  private _openPrintWindow(forAutomation: boolean): Window | null {
    if (forAutomation) {
      const reserved = this.chatbotAutomation.consumePrintWindow();
      if (reserved) {
        return reserved;
      }
    }
    try {
      return window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    } catch (_) {
      return null;
    }
  }

  private _openPrintUrl(url: string, forAutomation: boolean): boolean {
    let popupWin: Window | null = null;
    if (forAutomation) {
      popupWin = this.chatbotAutomation.consumePrintWindow();
    }
    if (!popupWin) {
      try {
        popupWin = window.open(url, '_blank');
      } catch (_) {
        popupWin = null;
      }
    } else {
      try {
        popupWin.location.href = url;
      } catch (_) {
        popupWin = null;
      }
    }
    if (!popupWin) {
      this.dashboardService.openSnackBar(
        'Print popup was blocked. Please allow popups for this site and try again.',
        'OK'
      );
      return false;
    }
    return true;
  }

  private _showPrintHtml(html: string, autoPrint: boolean, forAutomation: boolean): boolean {
    const onload = autoPrint ? ' onload="window.print()"' : '';
    const docHtml = `<html><body${onload}>${html}</body></html>`;
    const popupWin = this._openPrintWindow(forAutomation);
    if (popupWin) {
      try {
        popupWin.document.open();
        popupWin.document.write(docHtml);
        popupWin.document.close();
        return true;
      } catch (_) { /* fall through to iframe */ }
    }

    let frame = document.getElementById('eli-automation-print-frame') as HTMLIFrameElement | null;
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = 'eli-automation-print-frame';
      frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
      document.body.appendChild(frame);
    }
    const doc = frame.contentDocument || frame.contentWindow?.document;
    if (!doc) {
      this.dashboardService.openSnackBar(
        'Print popup was blocked. Please allow popups for this site and try again.',
        'OK'
      );
      return false;
    }
    doc.open();
    doc.write(docHtml);
    doc.close();
    if (autoPrint) {
      setTimeout(() => {
        try {
          frame.contentWindow?.focus();
          frame.contentWindow?.print();
        } catch (_) { /* ignore */ }
      }, 300);
    }
    return true;
  }

  private runChatAutomation(): void {
    if (!this.automationWorkflow || this.automationRan) {
      console.log('Automation: Skipping - already ran or no workflow');
      return;
    }

    this.automationRan = true;
    console.log('Automation: Starting automation with workflow:', this.automationWorkflow);

    // Fresh bill row for this automation run
    this.BillDetailArray = [];
    this.dataSource.data = [];
    this.billingservice.selectedServiceRow = [];
    this.pendingServiceAutomation = null;
    this.pendingAutoSubmit = false;
    this.pendingServiceId = null;
    if (this.BillingData) {
      this.BillingData.PK_BillId = 0;
      this._ensureBillMasterDefaults();
    }

    // Set the visit mode
    if (this.automationWorkflow.mode === 'appointment') {
      this.selectedRadio = 'withappointment';
      this.withappointment = true;
      this.walkin = false;
    } else {
      this.selectedRadio = 'walkin';
      this.walkin = true;
      this.withappointment = false;
    }

    // Auto-lookup patient UHID (prefer verified patientId from chatbot lookup)
    if (this.automationWorkflow.uhid || this.automationWorkflow.patientId) {
      const uhidNumber = Number(
        this.automationWorkflow.patientId || this.automationWorkflow.uhid
      );
      console.log('Automation: Looking up UHID/RegId:', uhidNumber);
      this.getpatiendId(uhidNumber, 1);
    } else if (this.automationWorkflow.mode === 'appointment') {
      this.getapplist(2);
    }
  }

  private _automationPrintAndNotify(
    billId: number,
    billingData: any,
    receiptCreated?: boolean,
    payTypeId?: number
  ): void {
    this.billingservice.get_Bill_billId(billId).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.getBillIdobj = data;
        const master = data?.billMasterDtos?.[0];
        const wf = this.automationWorkflow;
        const regId =
          master?.fK_RegId ||
          this.opdvisitService.patientdetails?.pkRegId ||
          billingData?.FK_RegId ||
          wf?.patientId;

        const printType = receiptCreated ? 2 : 1;

        const runPrint = () => {
          this.printTimelineBill(printType, billId, regId, true, (printed) => {
            this._automationNotifySaved(billId, billingData, printed, data, receiptCreated, payTypeId);
          });
        };

        const patient = this.opdvisitService.patientdetails;
        const needsPatientLoad =
          regId &&
          (!patient?.pkRegId || patient.pkRegId !== regId || !patient?.firstName);

        if (needsPatientLoad) {
          this.opdvisitService.getpatientdetailsforReciept(regId).pipe(takeUntil(this.destroy$)).subscribe(
            (p) => {
              if (p?.pkRegId) {
                this.opdvisitService.successpatient_details(p, 1);
              }
              runPrint();
            },
            () => runPrint()
          );
        } else {
          runPrint();
        }
      },
      () => this._automationNotifySaved(billId, billingData, false, undefined, receiptCreated, payTypeId)
    );
  }

  private _automationNotifySaved(
    billId: number,
    billingData: any,
    printed: boolean,
    billData?: any,
    receiptCreated?: boolean,
    payTypeId?: number
  ): void {
    const wf = this.automationWorkflow;
    if (!wf) return;

    const master  = billData?.billMasterDtos?.[0];
    const details = billData?.billDetailDtos?.length
      ? billData.billDetailDtos
      : (this.BillDetailArray || []);
    const services = details
      .map((d: any) => d.serviceName || d.ServiceName)
      .filter(Boolean);

    const patient = this.opdvisitService.patientdetails;
    const patientName =
      wf.patientName ||
      [patient?.firstName, patient?.lastName].filter(Boolean).join(' ') ||
      'Patient';

    this.chatbotAutomation.notifyBillSaved({
      billId,
      billNo: master?.billNo || master?.customBillNo || this.customBilNumbver,
      uhid: wf.uhid || patient?.pkRegId || billingData?.FK_RegId,
      patientName,
      category: wf.category || '',
      department: wf.departmentName || '',
      doctor: wf.skipDoctor ? '(billing config default)' : (this.docterName || wf.doctor || '—'),
      services: services.length
        ? services
        : (wf.services?.length ? wf.services : (wf.service ? [wf.service] : [])),
      mode: wf.mode === 'appointment' ? 'With Appointment' : 'Walk-in',
      paymentMethod: wf.paymentMethod || '',
      remarks: wf.remarks || billingData?.Remarks || '',
      netAmount: master?.netBillAmt ?? this.netbillamount,
      totalAmount: master?.totalAmt ?? this.totalpay,
      paidAmount: master?.paidAmount,
      printed,
      receiptCreated: receiptCreated ?? false,
      paymentTypeId: payTypeId ?? wf.paymentTypeId ?? undefined,
    });
    this._clearAutomationWorkflow();
    this._flushAutomationPendingLastBill();
  }

  private _isIpdCategory(category?: string | null): boolean {
    if (!category) return false;
    const c = category.toLowerCase();
    return c.startsWith('ipd') || c.includes('retinal') || c.includes('cataract')
      || c.includes('minor') || c.includes('procedures');
  }

  /** Map chatbot category → bill series + entry type (OPD / IPD / Investigation). */
  private _applyAutomationBillSeriesFromCategory(category?: string | null): void {
    const list = this.billingservice.billService || [];
    if (!list.length || !category) return;

    const c = category.toLowerCase();
    let match: any = null;

    if (this._isIpdCategory(category)) {
      match = list.find((b: any) => b.isIPD == 1)
        || list.find((b: any) => (b.billSerieseName || '').toLowerCase().includes('ipd'));
    } else if (c === 'laboratory' || c.includes('investigation') || c.includes('diagnostic')) {
      match = list.find((b: any) => (b.billSerieseName || '').toLowerCase().includes('investigation'))
        || list.find((b: any) => (b.billSerieseName || '').toLowerCase().includes('lab'));
    } else {
      match = list.find((b: any) => b.isIPD != 1 && (b.billSerieseName || '').toLowerCase().includes('opd'))
        || list.find((b: any) => b.isIPD != 1);
    }

    if (match?.billSerieseId) {
      this.BillingData.FK_BillSerieseId = match.billSerieseId;
      this.onchnagebillService(match.billSerieseId);
      console.log('Automation: Bill series applied →', match.billSerieseName);
    }
  }

  private _automationSubmitFailed(reason: string): void {
    if (!this.automationWorkflow) return;
    console.warn('Automation failed:', reason);
    this.chatbotAutomation.notifyAutomationFailed(reason);
    this._clearAutomationWorkflow();
    this._flushAutomationPendingLastBill();
  }

  private _submitValidationFail(message: string): void {
    this._automationSubmitFailed(message);
  }

  /** Wait until rate list + category are ready, then add services and optionally save. */
  private _runAutomationServiceSelection(
    svcs: string[],
    autoSubmit: boolean,
    serviceId: number | null,
    attempt = 0
  ): void {
    const maxAttempts = 12;
    const ready = this.checktpa > 0
      && this.BillingData?.FK_CategoryId > 0
      && this.BillingData?.FK_BillSerieseId > 0;

    if (ready) {
      this._ensureBillMasterDefaults();
      this.newservice(undefined, autoSubmit, svcs, serviceId);
      return;
    }
    if (attempt >= maxAttempts) {
      this._automationSubmitFailed(
        'Billing form was not ready (rate list / category / bill series). Please save manually on the billing page.'
      );
      return;
    }
    setTimeout(
      () => this._runAutomationServiceSelection(svcs, autoSubmit, serviceId, attempt + 1),
      400
    );
  }

  /** Required BillMaster fields for Usp_Api_Billing_InserBillPro (automation may skip setbiilingdata). */
  private _ensureBillMasterDefaults(): void {
    if (!this.BillingData) this.BillingData = {};
    if (this.BillingData.IsActive == null) this.BillingData.IsActive = 1;
    if (this.BillingData.Iscancel == null) this.BillingData.Iscancel = 0;
    if (this.BillingData.IsMLC == null) this.BillingData.IsMLC = 0;
    if (this.BillingData.IsAcademic == null) this.BillingData.IsAcademic = 0;
    if (this.BillingData.PrintCount == null) this.BillingData.PrintCount = 0;
    if (this.BillingData.FK_OrganizerId == null) this.BillingData.FK_OrganizerId = 0;
    if (!this.BillingData.FK_CreatedById) {
      this.BillingData.FK_CreatedById = this.authService.Loggeduser.userid;
    }
    if (!this.BillingData.FK_BillingCompanyId) {
      this.BillingData.FK_BillingCompanyId = this.authService.selectedbillingcompany;
    }
    if (!this.BillingData.FK_FinYearId) {
      this.BillingData.FK_FinYearId = this.authService.Loggeduser.finyear;
    }
    if (!this.BillingData.FK_BranchId) {
      this.BillingData.FK_BranchId = this.authService.Loggeduser.branchid;
    }
  }

  private _loadAutomationReceiptMasters(): void {
    if (!this.PaymentType?.length) {
      this.billingservice.getpaymentType().pipe(takeUntil(this.destroy$)).subscribe(
        (data) => { this.PaymentType = data || []; }
      );
    }
    if (this.automationDefaultBankId == null) {
      this.billingservice.getbankType().pipe(takeUntil(this.destroy$)).subscribe(
        (data) => {
          const first = data?.[0];
          if (first) {
            this.automationDefaultBankId = first.pK_Id ?? first.pkBankId ?? null;
          }
        }
      );
    }
  }

  /** Map chatbot payment label → FK_PayTypeId using billing module's payment master. */
  private _resolveAutomationPayTypeId(): number {
    const wf = this.automationWorkflow;
    if (wf?.paymentTypeId) return wf.paymentTypeId;

    const method = (wf?.paymentMethod || 'Cash').toLowerCase();
    const types: any[] = this.PaymentType || [];

    for (const t of types) {
      const name = (t.name || '').toLowerCase();
      if (name === method || name.includes(method) || method.includes(name)) {
        return Number(t.pK_Id);
      }
    }

    const aliasToKeywords: Record<string, string[]> = {
      cash: ['cash'], card: ['card', 'credit', 'debit'],
      online: ['online', 'upi', 'net'], cheque: ['cheque', 'check', 'chq'],
      insurance: ['insurance', 'insur'],
    };
    const aliases = Object.keys(aliasToKeywords);
    for (let i = 0; i < aliases.length; i++) {
      const alias = aliases[i];
      const keys = aliasToKeywords[alias];
      if (keys.some(k => method.includes(k)) || method === alias) {
        const found = types.find((t: any) => {
          const name = (t.name || '').toLowerCase();
          return keys.some(k => name.includes(k)) || name.includes(alias);
        });
        if (found) return Number(found.pK_Id);
      }
    }

    if (method.includes('card')) return 2;
    if (method.includes('online') || method.includes('upi')) return 3;
    if (method.includes('cheque') || method.includes('check')) return 4;
    if (method.includes('insur')) return 7;
    return 1;
  }

  private _prepareAutomationReceiptData(billId: number, payTypeId: number): void {
    this.setfreshReciptdata();
    this.ReciptData.FK_PayTypeId = payTypeId;
    this.ReciptData.FK_AdjustedBillId = parseInt(String(billId), 10);
    this.ReciptData.FK_PartyId = parseInt(this.BillingData.FK_PartyId);
    this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, 'yyyy-MM-dd');

    if (payTypeId !== 1) {
      this.ReciptData.ChequeNo = `ELI-${billId}-${Date.now().toString().slice(-6)}`;
      this.ReciptData.ChequeDate = this.authService.getServerDate;
      // Pay type 7 = insurance-style (no bank required in UI)
      if (payTypeId !== 7 && this.automationDefaultBankId) {
        this.ReciptData.FK_ChqBankId = this.automationDefaultBankId;
      }
    }
  }

  private _automationAutoReceipt(billId: number, billingData: any): void {
    const wf = this.automationWorkflow!;
    const payTypeId = this._resolveAutomationPayTypeId();
    console.log('Automation: Creating receipt with FK_PayTypeId =', payTypeId, 'for', wf.paymentMethod);

    this._prepareAutomationReceiptData(billId, payTypeId);
    this.ReciptData.AgeYear = this.opdvisitService.patientdetails.ageYear;
    this.ReciptData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
    this.ReciptData.AgeDays = this.opdvisitService.patientdetails.ageDays;
    this.ReciptData.IsEdit = false;

    this.billingservice.addbilingrecipts(this.ReciptData).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        document.getElementById('ReciptModelBox').style.display = 'none';
        this.setfreshReciptdata();
        if (wf.autoPrint) {
          this._automationPrintAndNotify(billId, billingData, true, payTypeId);
        } else {
          this._automationNotifySaved(billId, billingData, false, undefined, true, payTypeId);
        }
      },
      (err) => {
        const msg = err?.error?.message || 'Receipt could not be created for the selected payment mode.';
        if (wf.autoPrint) {
          this._automationPrintAndNotify(billId, billingData, false, payTypeId);
        } else {
          this._automationNotifySaved(billId, billingData, false, undefined, false, payTypeId);
          this.chatbotAutomation.notifyAutomationFailed(msg);
          this._clearAutomationWorkflow();
          this._flushAutomationPendingLastBill();
        }
      }
    );
  }

  isselfrequest: boolean = false;
  AllUserControll() {

    this.AllUserCtrl = new FormControl();
    var userdatacheck = [];
    this.billingservice.GetApprovalUser('BILLING').subscribe((data) => {

      if (data.length > 1) {
        userdatacheck = data.filter(
          (item) => item.pkUserId != this.authService.Loggeduser.userid
        );
        this.isselfrequest = false;
      } else {
        userdatacheck = data;
        this.isselfrequest = true;
      }
      this.filteredAllUserArray = this.AllUserCtrl.valueChanges.pipe(
        startWith(""),
        map((cat) => userdatacheck.slice())
      );

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })



  }
  getTitle(bookId: number) {
    const personName = this.opdvisitService.personmaster.filter(item => item.pkPersonId == bookId);
    if (personName.length > 0) {
      return personName[0]?.personName;
    } else {
      return this.newPersonArray.filter(item => item.pkPersonId == bookId)[0]?.personName;
    }
  }
  // getTitleParty(partyId: number) {
  //   this.getRateList(partyId, 1);
  //   return this.opdvisitService.personmaster.filter(item => item.pkPersonId == partyId)[0]?.personName;
  // }
  getALlUserTypeobj(e: any) {

    var val = e.option.value;
    this.approvebyName = val.userName;
    this.AllUserCtrl.setValue(val.userName);
    this.billingservice.getUsertypemenuPermission(val.fkUserTypeId, val.pkUserId).pipe(takeUntil(this.destroy$)).subscribe(
      (item: any) => {
        if (item.length > 0) {
          let checkbillingAllow = item.filter(
            (x) =>
              x.menuDetailName == "mnuPatientBilling" && x.webIsMenu == true
          );
          if (checkbillingAllow.length > 0) {
            this.approvebyName = val.userName;
            this.requestDiscountAmount.FK_ApprovedByID = val.pkUserId;
          } else {
            this.approvebyName = '';
            this.dashboardService.openSnackBar(
              "Billing Module Not Allowed Selecting User.",
              "ok"
            );

            this.requestDiscountAmount.FK_ApprovedByID = 0;
          }
        } else {
          this.dashboardService.openSnackBar(
            "Billing Module Not Allowed Selecting User.",
            "ok"
          );
          this.requestDiscountAmount.FK_ApprovedByID = 0;
        }
      },
      (err) => {
        this.requestDiscountAmount.FK_ApprovedByID = 0;
        this.dashboardService.openSnackBar("API Failed", "ok");
      }
    );
  }
  CheckApprovedType(event) {
    if (event.target.value == "") {
      this.requestDiscountAmount.FK_ApprovedByID = 0;
    }
  }

  SendForDiscountApproval(event, type) {
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);

    if (!this.requestDiscountAmount.DiscountAmount && type == "Discount") {
      return this.dashboardService.openSnackBar(
        "Please Enter Discount Amount",
        "ok"
      );
    } else if (!this.requestDiscountAmount.RequestAmount && type == "BillRefund") {
      return this.dashboardService.openSnackBar(
        "Please Enter Request Amount",
        "ok"
      );
    } else if (
      !this.requestDiscountAmount.FK_ApprovedByID ||
      this.requestDiscountAmount.FK_ApprovedByID == 0 ||
      this.requestDiscountAmount.FK_ApprovedByID == undefined
    ) {
      return this.dashboardService.openSnackBar(
        "Please Select Approval By",
        "ok"
      );
    } else if (!this.requestDiscountAmount.Reason) {
      return this.dashboardService.openSnackBar("Please Enter Reason", "ok");
    } else {
      this.requestDiscountAmount.FK_RequestedByID =
        this.authService.Loggeduser.userid;
      this.requestDiscountAmount.IsEdit = false;
      this.requestDiscountAmount.ApprovalType = type;
      this.requestDiscountAmount.FK_BillID = this.getBillId;
      this.requestDiscountAmount.PK_TranID = 0;
      this.requestDiscountAmount.Status = "Pending";
      this.requestDiscountAmount.RequestedDate = this.authService.getServerDate;
      this.requestDiscountAmount.RequestedTime = new Date()
        .toTimeString()
        .split(" ")[0];
      let payload = {
        ApprovalDetail: this.requestDiscountAmount,
      };
      if (
        (this.requestDiscountAmount.DiscountAmount > this.netbillamount ||
          this.requestDiscountAmount.DiscountAmount >
          this.reciptBlanceAmmount ||
          this.requestDiscountAmount.DiscountAmount == 0) &&
        type == "Discount"
      ) {
        return this.dashboardService.openSnackBar(
          "You can not raise request more than limit",
          "ok"
        );
      }
      if (
        ((Number(this.requestDiscountAmount.RequestAmount) >
          this.netbillamount &&
          Number(this.requestDiscountAmount.RequestAmount) >
          this.reciptBlanceAmmount) ||
          Number(this.requestDiscountAmount.RequestAmount) == 0) &&
        type == "BillRefund"
      ) {
        return this.dashboardService.openSnackBar(
          "You can not raise request more than receipt Amount",
          "ok"
        );
      }
      this.billingservice.insertBillingApproval(payload).pipe(takeUntil(this.destroy$)).subscribe(
        (x) => {
          if (x.statusCode == 1) {
            this.requestDiscountAmount = {};
            this.approvebyName = "";
            this.closeApprovalsModal();
            this.closeRaiseApprovalRequestModal();
            this.closeRaiserefundApprovalRequestModal();
            this.billModificationRequestApprovedModal();
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }
  }
  subsepceialdata: any = [];
  getSpecilityData(id) {
    this.billingservice.getSpeciltiyData(id).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.subsepceialdata = [];
      this.subsepceialdata = x;
    });
  }
  getrequestdata: any = [];
  getALlreqestData(BranchId, FromDate, ToDate, TypeBy, Status, billid) {
    this.billingservice
      .getRequestStatusdata(BranchId, FromDate, ToDate, TypeBy, Status, billid).pipe(takeUntil(this.destroy$))
      .subscribe(
        (x: any) => {

          this.getrequestdata = [];

          if (x.length > 0) {
            if (this.checktyperequest == 0) {
              this.getrequestdata = x.filter(
                (item) =>
                  item.fK_RequestedByID == this.authService.Loggeduser.userid
              );
            } else {
              this.getrequestdata = x.filter(
                (item) =>
                  item.fK_ApprovedByID == this.authService.Loggeduser.userid
              );
            }

          }
          this.getApprovalCount(BranchId, FromDate, ToDate, 0, 0, 0);
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "ok");
        }
      );
  }

  getApprovalCount(BranchId, FromDate, ToDate, TypeBy, Status, billid) {
    this.approvalchange.discountcount = 0;
    this.approvalchange.modificationcount = 0;
    this.approvalchange.billRefundcount = 0;
    this.approvalchange.billcancelcount = 0;
    this.dashboardService.subscriptions = this.billingservice
      .getRequestStatusdata(BranchId, FromDate, ToDate, TypeBy, Status, billid).pipe(takeUntil(this.destroy$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            if (this.checktyperequest == 0) {
              var checkdata = x.filter(
                (item) =>
                  item.fK_RequestedByID == this.authService.Loggeduser.userid
              );
            } else {
              var checkdata = x.filter(
                (item) =>
                  item.fK_ApprovedByID == this.authService.Loggeduser.userid
              );
            }

            this.approvalchange.discountcount = checkdata.filter(
              (item) =>
                item.approvalType == "Discount" && item.status == "Pending"
            ).length;
            this.approvalchange.modificationcount = checkdata.filter(
              (item) =>
                item.approvalType == "Modification" && item.status == "Pending"
            ).length;
            this.approvalchange.billRefundcount = checkdata.filter(
              (item) =>
                item.approvalType == "BillRefund" && item.status == "Pending"
            ).length;
            this.approvalchange.billcancelcount = checkdata.filter(
              (item) =>
                item.approvalType == "Cancell" && item.status == "Pending"
            ).length;
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "ok");
        }
      );
  }

  checkdiscountperval(e) {
    if (e >= 0) {
      return 0;
    } else {
      return 0;
    }
  }

  // filterBillservice(items: any, event: any) {
  //   var foundValue = this.filterByValue(items, event);
  //   if (foundValue.length > 0 && event != "") {
  //     this.billingservice.billService = foundValue;
  //   } else {
  //     this.getBillservice();
  //   }
  // }
  filterpersonType(items: any, event: any) {
    var foundValue = this.filterByValue(items, event);
    if (foundValue.length > 0 && event != "") {
      this.opdvisitService.personmaster = foundValue;
    } else {
      this.opdvisitService.getpersonmaster("BILLING", 0);
    }
  }
  filterByValue(array, value) {
    return array.filter(
      (data) =>
        JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  // getscreenPermission() {
  //   this.showspinner = true;
  //   let userId = this.authService.Loggeduser.userid;
  //   this.billingservice.getbillingScreenPermission(userId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
  //     this.showspinner = false;
  //     for (let i = 0; i < data.length; i++) {
  //       const element = data[i];
  //       if (element.screenName.toLowerCase() === "billing") {
  //         this.screenPermissionobj = element;

  //         this.userAddPermission();
  //       }

  //     }
  //   }, err => {
  //     if (err.status == 403) {
  //       this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  //     }
  //     else if (err.error.statusCode == 422) {
  //       this.dashboardService.openSnackBar(err.error.message, "OK");
  //     }
  //     else {
  //       this.dashboardService.openSnackBar("API Failed", "OK");
  //     }
  //   });
  // }
  /* User Add Permission */
  // userAddPermission() {
  //   if (this.screenPermissionobj?.addPermission === false) {
  //     this.dashboardService.openSnackBar(
  //       "you don't have permission to access this resource",
  //       "OK"
  //     );
  //   }
  // }
  LastVisitAllow: string = "N";
  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.dashboardService.subscriptions = this.billingservice
      .getproductionConfrigration(BranchId).pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        //console.log('master confrigartion',data);
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          if (element.propertyName === "DiscountonBill") {
            this.masterconfigurationDiscount = element;
          }

          if (element.propertyName === "PageHeadWebReport") {
            this.PageHeader = element;
          }
          if (element.propertyName === "Patientsticker_barcode") {
            this.QrCode = element;
          }
          if (element.propertyName === "DoNotShowLastBillingDetails") {
            this.LastVisitAllow = element.propertyValue;
          }
          if (element.propertyName === "WebURL") {
            this.reporturl = element.propertyValue;
          } else {
            this.QrCode.propertyValue = "N";
          }

          // public PageHeader:any ={};
          // public :any={};
        }
      });
  }

  getbills(a, b) {
    this.dashboardService.subscriptions = this.billingservice.getallbills(a, b, this.authService.Loggeduser.branchid).subscribe(
      (data) => this.allbillsuccsess(data),
      (err) => this.allbillerrors(err)
    );
  }
  allbillsuccsess(data) {
    this.BillListArray = data;
    // console.log(data);
  }
  allbillerrors(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  // getbillingresonsHelplist() {
  //   this.billingservice.getbillingResionHelplist().subscribe(data => {
  //     this.BillingRemarkArray = data
  //     this.RemarkControll();
  //   })
  // }

  setbillgetdata() {
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
    // console.log(sdate,edate)
    this.getbills(sdate, edate);
  }

  // get doctor list
  // getdoctorlist() {
  //   this.dashboardService.getall_doctors().
  //     subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  // }

  // success_doctors(data) {
  //   if (this.authService.masterdata.isExternal === true) {

  //     this.opdvisitService.doctors = data?.filter(item => item.isExternal == false);
  //     if (this.billingservice.billserviceConfig?.fK_DoctorId > 0 && this.billingservice.billserviceConfig?.fK_DoctorId != null) {
  //       this.BillingData.FK_DoctorId = this.billingservice.billserviceConfig?.fK_DoctorId;
  //     } else {
  //       this.BillingData.FK_DoctorId = this.opdvisitService.doctors[1].userId;
  //     }
  //   }
  //   else {
  //     this.opdvisitService.doctors = data;
  //     this.BillingData.FK_DoctorId = this.billingservice.billserviceConfig?.fK_DoctorId;
  //   }

  // }
  // failed_doctors(err) {

  // }
  //config billing modul
  selectParty(e) {
    // this.copartyId =e.value;
  }

  getConfiglist() {
    // this.billingservice.billserviceConfig={};
    let BranchId = this.authService.Loggeduser.branchid;
    this.dashboardService.subscriptions = this.billingservice.get_Bill_Congigrationlist(BranchId).subscribe(
      (data) => this.success_config(data),
      (err) => this.failed_config(err)
    );
  }
  success_config(data) {

    this.billingservice.billserviceConfig = {};
    this.billingservice.billserviceConfig = data[0];
    if (this.billingservice.billserviceConfig?.fK_PartyId) {
      this.getRateList(
        this.billingservice.billserviceConfig?.fK_PartyId,
        1,
        this.billingservice.billserviceConfig?.fK_RatelistId
      );
    }

    if (this.billingservice.partytpa.length > 0) {
      this.partylistSecond = this.billingservice.partytpa.filter(
        (item) =>
          item.pkPartyId != this.billingservice.billserviceConfig?.fK_PartyId
      );
    }
    this.BillingData.FK_ReferredById =
      this.billingservice.billserviceConfig.fK_ReferredById;
    this.BillingData.Fk_RateListid = this.billingservice.billserviceConfig.fK_RatelistId ? this.billingservice.billserviceConfig.fK_RatelistId : null;
    this.BillingData.FK_PartyId =
      this.billingservice.billserviceConfig.fK_PartyId;
    this.BillingData.FK_BillTypeId =
      this.billingservice.billserviceConfig.fK_BillTypeId;
    let checkcategory = this.dashboardService.categories.filter(
      (item) =>
        item.pkCategoryId == this.billingservice.billserviceConfig.fK_CategoryId
    );
    if (checkcategory.length > 0) {
      this.BillingData.FK_CategoryId =
        this.billingservice.billserviceConfig.fK_CategoryId;
    } else {
      this.BillingData.FK_CategoryId = 0;
    }

    this.BillingData.FK_BillSerieseId =
      this.billingservice.billserviceConfig.fK_BillSerieseId;
    this.BillingData.RateType =
      this.billingservice.billserviceConfig.fK_RatelistId;
    this.BillingData.FK_DoctorId =
      this.billingservice.billserviceConfig?.fK_DoctorId;
    if (this.BillingData.FK_DoctorId > 0) {
      var doctername = this.doctersSpecData.filter(
        (item) => item.userId == this.BillingData.FK_DoctorId
      );
      this.docterName = doctername[0]?.userName;
      if (doctername.length > 0) {
        this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
      }

    }


    this.ReciptData.FK_DoctorId =
      this.billingservice.billserviceConfig?.fK_DoctorId;
    this.opdvisitService.BillingDoctorId =
      this.billingservice.billserviceConfig?.fK_DoctorId;
    this.ReciptData.FK_PartyId =
      this.billingservice.billserviceConfig.fK_PartyId;
    if (this.billingservice.billserviceConfig.fK_CategoryId != null) {
      var CategoryId = this.billingservice.billserviceConfig.fK_CategoryId;
    } else {
      var CategoryId = 1;
    }
    if (this.billingservice.billserviceConfig.fK_RatelistId != null) {
      var RateListId = this.billingservice.billserviceConfig.fK_RatelistId;
    } else {
      var RateListId = 1;
    }

    let RateTypeId = 1;
    // if(this.BillingData.FK_CategoryId >0){
    //   this.CallDefaultServies(CategoryId, RateListId, RateTypeId);
    // }else{
    //   this.dashboardService.openSnackBar("Please select Category or enable from Masters", "OK");
    // }
    this.billingservice.servicelist = [];
    this.GetSreviceArrayOne = [];
    this.GetSreviceArraytwo = [];
    this.GetSreviceArraythree = [];

    if (this.BillDetailArray.length == 0) {
      this.BillDetailArray.push({
        PK_BillDetailId: 0,
        FK_BillId: 0,
        serviceName: "",
        maxDiscountLimit: "",
        FK_ServiceId: 0,
        isRateEditable: false,
        Rate: "",
        Amount: "",
        Unit: "",
        NetAmt: "",
        ServiceCharges: "",
        scPer: "",
        DiscountPercent: null,
        Discount: null,
        FK_PackageId: 0,
        IsPerformed: 0,
        IsDelete: 0,
        Remarks: null,
        currentAmount: "",
      });
      this.dataSource.data = this.BillDetailArray;
    }
  }

  failed_config(err) {
    this.billingservice.billserviceConfig.fK_BillSerieseId = 0;
    this.billingservice.billserviceConfig.fK_BillTypeId = 0;
    this.billingservice.billserviceConfig.fK_CategoryId = 0;
    this.billingservice.billserviceConfig.fK_DoctorId = 0;
    this.billingservice.billserviceConfig.fk_DrDeptID = 0;
    this.billingservice.billserviceConfig.fK_ReferredById = 0;
    this.billingservice.billserviceConfig.fK_PartyId = 0;
    this.billingservice.billserviceConfig.fK_RatelistId = 0;
    this.billingservice.billserviceConfig.approvalSystem = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  // get Bill service
  //   getBillservice() {
  //     this.billingservice.get_BillService().subscribe(data => this.success_bill(data), err => this.failed_billservice(err));
  //   }
  //   success_bill(data) {
  //  this.billingservice.billService = data;
  //     console.log(this.billingservice.billService)
  //     this.items = data;
  //   }
  //   failed_billservice(err) {

  //   }
  getBillMasterservice() {
    this.dashboardService.subscriptions = this.billingservice
      .get_BillMasterService(
        this.authService.selectedbillingcompany,
        this.authService.Loggeduser.branchid
      )
      .subscribe(
        (data) => this.success_billmaster(data),
        (err) => this.failed_billmasterservice(err)
      );
  }
  success_billmaster(data) {
    this.billingservice.billService = data;
    this.items = data;
  }
  failed_billmasterservice(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //get party tpa
  getPartTpa() {
    this.dashboardService.subscriptions = this.billingservice.get_partytpa().subscribe(
      (data) => this.success_partytpa(data),
      (err) => this.failed_partytpa(err)
    );
  }
  success_partytpa(data) {
    this.billingservice.partytpa = data;
    let checkcopay = data.filter((item) => item.pkPartyId == this.copartyId);
    if (checkcopay.length == 0) {
      this.copartyId = 0;
    }
  }
  failed_partytpa(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  // get rate typelist

  GetRateType() {
    this.dashboardService.subscriptions = this.billingservice
      .get_rate_typelist()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any[]) => {
        this.billingservice.ratetype = data;
        // console.log('billingservice.ratetype',data)
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  GetBillType() {
    this.dashboardService.subscriptions = this.billingservice
      .get_typelist()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any[]) => {
        this.billingservice.billtype = data;
        // console.log('biil type', this.billingservice.billtype)
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  //get rate list
  getRateList(event, configid?: any, ratelist?: any) {

    this.copartyId = 0;
    if (event.value != 0) {
      let BranchId = this.authService.Loggeduser.branchid;
      if (configid == 1 || configid == 2) {
        var PartyId = event;
      } else {
        var PartyId = event.value;
      }

      this.partylistSecond = this.billingservice.partytpa.filter(
        (item) => item.pkPartyId != PartyId
      );
      this.dashboardService.subscriptions = this.billingservice
        .get_rate_list(BranchId, PartyId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any[]) => {

          //console.log('biil rate list', data)
          if (data.length > 0 && configid == 1) {
            const [checkdatabyratelist] = data.filter(
              (item) => item.rateListId == ratelist
            );
            if ([checkdatabyratelist].length > 0 && checkdatabyratelist != undefined) {
              this.billingservice.ratelist = checkdatabyratelist;
            } else {
              this.billingservice.ratelist = data[0];
            }
          } else {
            if (this.getBillId == 0) {
              this.dataSource.data = [];
              this.BillDetailArray = [];
              this.paymentDetail(this.BillDetailArray);
            }
            this.billingservice.ratelist = data[0];
          }
          if (data.length > 0) {
            this.checktpa = 1;
            this.BillingData.Fk_RateListid = data[0]?.rateListId;
            console.log('Automation: RateList loaded, checktpa set to 1');
            
            // Trigger pending service automation after getRateList completes
            if (this.pendingServiceAutomation) {
              console.log('Automation: Triggering service selection for:', this.pendingServiceAutomation);
              setTimeout(() => {
                let automationServices: string[] = [];
                try {
                  // Try to parse as JSON (multiple services)
                  automationServices = JSON.parse(this.pendingServiceAutomation);
                  if (!Array.isArray(automationServices)) {
                    automationServices = [this.pendingServiceAutomation];
                  }
                } catch (e) {
                  // Fall back to single service string
                  automationServices = [this.pendingServiceAutomation];
                }
                
                console.log('Automation: Calling newservice with', automationServices.length, 'services:', automationServices, 'serviceId:', this.pendingServiceId);
                console.log('Automation: autoSubmit =', this.pendingAutoSubmit);
                this.newservice(undefined, this.pendingAutoSubmit, automationServices, this.pendingServiceId);
                this.pendingServiceAutomation = null;
                this.pendingAutoSubmit = false;
                this.pendingServiceId = null;
              }, 500);
            }

          }
          // this.billingservice.ratelist[0].rateListId
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    } else {
      this.billingservice.ratelist.rateList = "";
      this.checktpa = 0;
    }
  }
  ngOnDestroy() {

    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.billingservice.selectedServiceRow = [];
    this.opdvisitService.getlastvisitid = null;
    this.isselfrequest = null;
    this.dashboardService.docterEmr.locationId = null;
    this.opdvisitService.opdvisitmodel.isEmergency = null;
  }
  showOptions(event: MatCheckboxChange): void {
    this.opdvisitService.opdvisitmodel.isEmergency = event.checked;
  }
  getapplist(status: number) {
    if (status == 2) {
      this.startloading();
      this.dashboardService.subscriptions = this.billingservice
        .getappointment(
          this.dashboardService.selecteddate,
          this.authService.Loggeduser.branchid
        )
        .subscribe(
          (data) => this.success_appointments(data),
          (err) => this.failedpatient_appointments(err)
        );
    } else {
      this.clearfields();
    }
  }

  getwalkin() {
    this.opdvisitService.apptdetail = {};
    this.ngOnInit();
  }
  clearfields() {
    this.walkin = true;
    this.withappointment = false;
    // this.ngOnInit();
  }
  success_appointments(data) {
    this.finishloading();
    this.opdvisitService.appointments = data;
    // this.ngOnInit();
    this.open_appointments_dialog();
  }
  failedpatient_appointments(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  open_loader_Dialog(): void {
    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: "300px",
      data: {},
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.walkin = true;
      this.withappointment = false;
    });
  }
  checkwithappoitnment: boolean = false;
  open_appointments_dialog(): void {
    // this.ngOnInit();
    // this.opdvisitService.checkpatient =null;
    const dialogRef = this.dialog.open(AppointmentListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "90%",
      width: "90%",
      data: {},
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {

      this.walkin = true;
      this.withappointment = false;
      if (result.appId > 0) {
        this.opdvisitService.getappointmentbyId(result.appId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
          this.opdvisitService.apptdetail = data;
          var checkempty = this.isEmptyObject(this.opdvisitService.apptdetail);
          if (checkempty != true) {
            this.checkwithappoitnment = true;
            // this.getpatientlastvisit(this.opdvisitService.checkpatient);
            this.setbiilingdata();
            this.getpatiendId(this.opdvisitService.checkpatient, 0);
            if (this.opdvisitService.apptdetail.fkRegId != null) {
              this.opdvisitService.get_old_photo();
            }
            if (this.opdvisitService.apptdetail.fkRefById > 0) {
              let payload = {
                personName: this.opdvisitService.apptdetail.fkRefBy,
                pkPersonId: this.opdvisitService.apptdetail.fkRefById
              }
              this.newPersonArray.push(payload);
              this.filteredItems = this.inputControl.valueChanges
                .pipe(
                  startWith(""),
                  map(cat => this.newPersonArray.slice())
                );
            }
          }
        });
      }
    });
  }
  isEmptyObject(obj) {
    return obj && Object.keys(obj).length === 0;
  }

  UpdateAppointmentByRegIdApptId(regId: any, apptId: any) {
    this.billingservice.get_Update_OPDVisit(regId, apptId).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => this.success_updateOpdvisit(data),
      (err) => this.failed_updateOpdvisit(err)
    );
  }
  success_updateOpdvisit(data) {
    //console.log(data);
  }
  failed_updateOpdvisit(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  startloading() {
    this.open_loader_Dialog();
  }
  finishloading() {
    this.dialog.closeAll();
  }

  removeRow(x, element) {
    //console.log(x, element)
    //  var newelement = element.isDelete =1;
    ////console.log('newelement',newelement);
    this.RemoveServiceArray.push(element);
    //console.log('remove',this.RemoveServiceArray);

    // this.BillDetailArray.splice(x)
    this.BillDetailArray.splice(x, 1);
    this.dataSource.data = this.BillDetailArray;
    this.paymentDetail(this.BillDetailArray);
  }

  clearallServices() {
    this.BillDetailArray = [];
    this.dataSource.data = this.BillDetailArray;
    this.paymentDetail(this.BillDetailArray);
    document.getElementById("ServicecheckPopUp").style.display = "none";
  }

  openshortregistordialog() {
    this.ngOnInit();
    this.opdvisitService.checkshort = true;
    const dialogRef = this.dialog.open(ShortRegistoreComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "80vw",
      // height: '80%',
      width: "80%",
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {

      setTimeout(() => this.UhidButton.nativeElement.focus(), 0);
      if (this.opdvisitService.RefreshCount >= 1) {
        this.opdvisitService.RefreshCount = 0;
        // console.log('The dialog was closed');
        //  this.showRec();
      }
      this.ReciptData.FK_DoctorId =
        this.billingservice.billserviceConfig?.fK_DoctorId;
      // this.opdvisitService.set_age(this.opdvisitService.patientdetails.pkRegId);
      if (this.opdvisitService.patientdetails.pkRegId) {
        //console.log(this.opdvisitService.patientdetails.pkRegId)
        this.childevent = false;
        this.getpatientlastvisit(
          this.opdvisitService.patientdetails.pkRegId,
          1
        );
        this.opdvisitService.checkshort = false;
        this.setbiilingdata();
        //console.log("patient PatientpartyId" +  this.opdvisitService.PatientpartyId);
        if (this.opdvisitService.PatientpartyId != null) {
          this.BillingData.FK_PartyId = this.opdvisitService.PatientpartyId;
          if (this.billingservice.partytpa.length > 0) {
            this.partylistSecond = this.billingservice.partytpa.filter(
              (item) => item.pkPartyId != this.BillingData?.FK_PartyId
            );
          }
        } else {
          if (
            this.opdvisitService.patientdetails.fkPartyId != undefined &&
            this.opdvisitService.patientdetails.fkPartyId != null
          ) {
            this.BillingData.FK_PartyId =
              this.opdvisitService.patientdetails.fkPartyId;
          }

          if (this.billingservice.partytpa.length > 0) {
            this.partylistSecond = this.billingservice.partytpa.filter(
              (item) => item.pkPartyId != this.BillingData?.FK_PartyId
            );
          }
        }

        // Only apply config default if chatbot automation hasn't specified a doctor
        const chatbotDoctor = this.automationWorkflow?.doctor && !this.automationWorkflow?.skipDoctor;
        if (!chatbotDoctor) {
          this.BillingData.FK_DoctorId = this.billingservice.billserviceConfig?.fK_DoctorId;
          if (this.BillingData.FK_DoctorId > 0) {
            this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
          }
        }

      }
    });
  }

  setage(year: number, months: number, days: number, gender, dob) {
    // if (year > 0) {
    //   return year + "(Y)/" + gender;
    // }
    // else if (months > 0) {
    //   return months + "(M)/" + gender;
    // }
    // else if (days > 0) {
    //   return days + "(D)/" + gender;
    // }
    // else {
    //   return "";
    // }
    if (year > 0) {
      return (
        "(" +
        gender +
        "|" +
        year +
        "|" +
        this.datePipe.transform(dob, "MMM d, y") +
        ")"
      );
    } else if (months > 0) {
      return (
        "(" +
        gender +
        "|" +
        months +
        "|" +
        this.datePipe.transform(dob, "MMM d, y") +
        ")"
      );
    } else if (days > 0) {
      return (
        "(" +
        gender +
        "|" +
        days +
        "|" +
        this.datePipe.transform(dob, "MMM d, y") +
        ")"
      );
    } else {
      return "";
    }
  }
  setage1(year: number, months: number, days: number, gender) {
    var combine;
    if (year > 0 && months == 0 && days == 0) {
      return year + " Yrs |" + gender;
    } else if (months > 0 && year == 0 && days == 0) {
      return months + " Month |" + gender;
    } else if (days > 0 && months == 0 && year == 0) {
      return days + " Days |" + gender;
    } else if (year > 0 && months > 0 && days == 0) {
      return year + "Yrs " + months + " Month |" + gender;
    } else if (months > 0 && days > 0 && year == 0) {
      return months + " Month " + days + " Days |" + gender;
    } else if (year > 0 && days > 0 && months == 0) {
      return year + " Yrs " + days + " Days |" + gender;
    } else if (year > 0 && months > 0 && days > 0) {
      return year + " Yrs " + months + " Month " + days + " Days |" + gender;
    } else {
      return "";
    }
  }
  getfinyearstring(finyearid: number) {
    return this.authService.FinYears.find((fy) => fy.pkFinYearId == finyearid)
      .displayFinYear;
  }

  opensearchD(id): void {
    // this.showspinner =true;

    if (!id) {
      this.opdvisitService.checkpatient == null;

      const dialogRef = this.dialog.open(SearchDialogComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "80%",
        width: "90%",
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
        setTimeout(() => this.UhidButton.nativeElement.focus(), 0);
        if (this.opdvisitService.patientdetails.fkReferredbyId > 0) {
          this.BillingData.FK_ReferredById =
            this.opdvisitService.patientdetails.fkReferredbyId;

        } else {
          this.BillingData.FK_ReferredById = null;
          this.filterreferd = null;
        }

        if (this.opdvisitService.patientdetails.fK_DoctorId != 0) {
          this.BillingData.FK_DoctorId =
            this.opdvisitService.patientdetails.fK_DoctorId;
          var doctername = this.doctersSpecData.filter(
            (item) => item.userId == this.BillingData.FK_DoctorId
          );
          this.docterName = doctername[0]?.userName;
          this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
        }
        if (result != 0) {
          this.childevent = false;
          this.BillingData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;
          this.getpatientlastvisit(this.opdvisitService.patientdetails.pkRegId, 1);
        }
      });
    }
  }

  // success_top_200_patients(data) {
  //   this.showspinner =false;
  //   this.opdvisitService.patients = data;
  //   const dialogRef = this.dialog.open(SearchDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if(this.opdvisitService.patientdetails.fkReferredbyId != 0){
  //       this.BillingData.FK_ReferredById = this.opdvisitService.patientdetails.fkReferredbyId;
  //     }
  //     if (result != 0) {
  //       this.getpatientlastvisit(this.opdvisitService.checkpatient);
  //     }

  //   });
  // }

  newserviceData = [];
  newservice(serviceQuery?: string, autoSubmit: boolean = false, automationServices?: string[], automationServiceId?: number | null) {
    console.log('newservice: Called with serviceQuery:', serviceQuery, 'autoSubmit:', autoSubmit, 'automationServices:', automationServices, 'automationServiceId:', automationServiceId);
    this.BillingData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;
    if (
      this.BillingData.FK_RegId === null ||
      this.BillingData.FK_RegId === " " ||
      this.BillingData.FK_RegId === undefined
    ) {
      this.dashboardService.openSnackBar("Please Select UHID", "OK");
      console.log('newservice: UHID not set');
    } else {
      console.log('newservice: UHID is set, checktpa =', this.checktpa);
      if (this.checktpa > 0) {
        console.log('newservice: Opening service dialog');
        const dialogRef = this.dialog.open(AddServiceComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "90%",
          width: "80%",
          data: {
            RateType: this.BillingData.RateType,
            BillEntryId: this.BillingData.FK_BillTypeId,
            Category_id: this.BillingData.FK_CategoryId,
            serviceQuery,
            service: serviceQuery,
            automationServices: automationServices || (serviceQuery ? [serviceQuery] : []),
            automationServiceId: automationServiceId || null,
          },
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
          console.log('newservice: Dialog closed');
          console.log('newservice: billingservice.selectedServiceRow length:', this.billingservice.selectedServiceRow?.length || 0);
          console.log('newservice: autoSubmit =', autoSubmit);
          
          var result = this.billingservice.selectedServiceRow?.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.serviceName === o.serviceName &&
                    (obj.FK_ServiceId === o.FK_ServiceId || obj.serviceId === o.serviceId)
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          ) || [];
          
          console.log('newservice: Deduplicated result count:', result.length);
          if (result.length > 0) {
            console.log('newservice: Selected service names:', result.map(r => r.serviceName).join(', '));
          }
          if (result.length > 0) {

            result.forEach((element, index) => {
              this.BillDetailArray.push({
                PK_BillDetailId: 0,
                FK_BillId: 0,
                serviceName: element.serviceName,
                maxDiscountLimit: element.maxDiscountLimit,
                FK_ServiceId: element.serviceId,
                Rate: element.rate,
                Amount: element.rate,
                Unit: 1,
                NetAmt: element.rate,
                ServiceCharges: this.returnSericeChage(
                  element.rate,
                  element.serviceCharge
                ),
                scPer: element.serviceCharge ? element.serviceCharge : 0,
                isRateEditable: element.isRateEditable,
                DiscountPercent: element.discount,
                Discount: 0,
                FK_PackageId: 0,
                IsPerformed: 0,
                IsDelete: 0,
                Remarks: "",
                currentAmount: element.rate,
              });
              if (
                element.discount > 0 &&
                (this.BillingData.FreeReason == "" ||
                  this.BillingData.FreeReason == null)
              ) {
                this.BillingData.FreeReason = "as per management";
              }
              //
            });
            this.BillDetailArray = this.BillDetailArray.reduce((unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.serviceName === o.serviceName &&
                    obj.FK_ServiceId === o.FK_ServiceId
                )
              ) {
                unique.push(o);
              }
              return unique;
            }, []);

            const index = this.BillDetailArray.filter(
              (list) => list.FK_ServiceId == 0
            );
            if (index.length > 0) {
              this.BillDetailArray.splice(index, 1);
            }

            this.dataSource.data = this.BillDetailArray;

            this.BillDetailArray.forEach((elem, index) => {
              if (elem.DiscountPercent > 0) {
                this.ondiscountPercentage(elem.DiscountPercent, index, 0);
              }
              if (elem.ServiceCharges > 0) {
                this.onserviceChnage(elem.ServiceCharges, index);
              }
            });

            this.paymentDetail(this.BillDetailArray);
            
            // Trigger auto-submit AFTER services are fully added and payment totals calculated
            if (autoSubmit) {
              console.log('newservice: Triggering auto-submit after', this.BillDetailArray.length, 'services added');
              setTimeout(() => {
                if (this.BillDetailArray.length === 0) {
                  this._automationSubmitFailed(
                    'Service could not be added automatically. Please add the service manually and save.'
                  );
                  return;
                }
                console.log('newservice: Executing auto-submit now');
                this.onSubmitBill();
              }, 1200);
            }
          } else if (autoSubmit) {
            this._automationSubmitFailed(
              'No service was selected. Please add a service on the billing page and save.'
            );
          }
        });
      } else {
        this.dashboardService.openSnackBar("Please Select Party/Tpa", "OK");
        if (autoSubmit) {
          this._automationSubmitFailed('Party/TPA is not configured. Please select Party on the billing page.');
        }
      }
    }
  }

  applyFilter_grid(filterValue) {
    this.BillListArray.filter = filterValue.trim().toLowerCase();
  }

  searchallbills() {
    //  if (this.screenPermissionobj?.searchPermission === true) {
    // this.ngOnInit();
    this.opdvisitService.BillingDoctorId = "";
    const dialogRef = this.dialog.open(BillingSearchComponent, {
      panelClass: "full-width-dialog",
      // height: '100%',
      width: "100%",
      data: {},
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      //console.log(`Dialog closed`, this.billingservice.billingSticker);
      if (this.billingservice.lastbillid != null) {
        this.getlastBill(this.billingservice.lastbillid);
        this.BillingData.PK_BillId = this.billingservice.lastbillid;
      }
    });
    // } else {
    //   this.dashboardService.openSnackBar(
    //     "you don't have permission to access this resource",
    //     "OK"
    //   );
    // }
  }


  checkDiscount(dicount: any) {
    if (
      (this.BillingData.FreeReason === null ||
        this.BillingData.FreeReason == "" ||
        this.BillingData.FreeReason === undefined) &&
      dicount != null
    ) {
      if (
        this.authService.masterdata.billDiscount > 0 &&
        this.BillingData.PK_BillId == 0
      ) {
        var d = (document.getElementById("DiscountModel").style.display =
          "block");
        if (d) {
          this.is_editalbe = true;
        }
      } else {
        var e = (document.getElementById(
          "userDiscountRequestModal"
        ).style.display = "block");
        if (e) {
          this.is_editalbe = true;
        }
      }
    } else {
      this.is_editalbe = false;
    }
  }

  getResone() {

    //console.log(this.getbillingReson);
    if (
      this.BillingData.FreeReason === null ||
      this.BillingData.FreeReason === "" ||
      this.BillingData.FreeReason === undefined
    ) {
      this.is_editalbe = true;
      // this.is_editalbe =true;
    } else {
      this.is_editalbe = false;
    }
  }

  discountflag: boolean = false;
  ondiscountPercentage(e: any, index: number, type) {
    if (e > 100) {
      this.discountflag = false;
      this.BillDetailArray[index].DiscountPercent = 0;
      this.dashboardService.openSnackBar(
        "Discount Percent Not more than 100 ",
        "OK"
      );
    } else if (
      e === null ||
      e === undefined ||
      e == "" ||
      (Number(e) > Number(this.authService.masterdata.billDiscount) &&
        type == 1)
    ) {
      this.discountflag = false;
      this.BillDetailArray[index].DiscountPercent = 0;
      this.BillDetailArray[index].Discount = 0;
      this.BillDetailArray[index].currentAmount = (
        this.BillDetailArray[index].Amount -
        parseFloat(this.BillDetailArray[index].Discount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges)
      ).toFixed(2);
      this.dataSource.data = this.BillDetailArray;
      this.paymentDetail(this.BillDetailArray);
      if (
        Number(e) > Number(this.authService.masterdata.billDiscount) &&
        type == 1
      ) {
        document.getElementById("userDiscountRequestModal").style.display =
          "block";
      }
    } else {
      this.discountflag = true;
      var Newdiscount = (this.BillDetailArray[index].Amount * e) / 100;

      this.BillDetailArray[index].Discount = Newdiscount;
      this.BillDetailArray[index].currentAmount = (
        this.BillDetailArray[index].Amount -
        parseFloat(this.BillDetailArray[index].Discount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges)
      ).toFixed(2);
      //  this.BillDetailArray[index].currentAmount = this.BillDetailArray[index].NetAmt - parseFloat(this.BillDetailArray[index].Discount)  + parseFloat(this.BillDetailArray[index].ServiceCharges);
      this.dataSource.data = this.BillDetailArray;
      //console.log(this.BillDetailArray);
      this.paymentDetail(this.BillDetailArray);
    }
  }

  ondiscount(e: any, index: number) {
    if (e > this.BillDetailArray[index].Amount) {
      this.discountflag = false;
      this.BillDetailArray[index].Discount = 0;
      this.BillDetailArray[index].DiscountPercent = 0;
      this.BillDetailArray[index].currentAmount =
        this.BillDetailArray[index].Amount;
      this.dashboardService.openSnackBar(
        "Discount Amount Not more than Current Amount ",
        "OK"
      );
    } else if (e === null || e === undefined || e == "") {
      this.discountflag = false;
      this.BillDetailArray[index].Discount = 0;
      this.BillDetailArray[index].DiscountPercent = 0;
      this.BillDetailArray[index].currentAmount = (
        parseFloat(this.BillDetailArray[index].Amount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges)
      ).toFixed(2);
      this.dataSource.data = this.BillDetailArray;
      this.paymentDetail(this.BillDetailArray);
    } else {
      this.discountflag = true;
      this.BillDetailArray[index].Discount = parseFloat(e);
      this.BillDetailArray[index].currentAmount = (
        parseFloat(this.BillDetailArray[index].Amount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges) -
        parseFloat(e)
      ).toFixed(2);
      this.dataSource.data = this.BillDetailArray;
      const discountper =
        (this.BillDetailArray[index].Discount * 100) /
        this.BillDetailArray[index].Amount;
      this.BillDetailArray[index].DiscountPercent = discountper.toFixed(2);
      this.paymentDetail(this.BillDetailArray);

      var disPer =
        (parseFloat(this.BillDetailArray[index].Discount) /
          parseFloat(this.BillDetailArray[index].NetAmt)) *
        100;
      var newNum = Math.round((disPer + Number.EPSILON) * 100) / 100;
      this.BillDetailArray[index].maxDiscountLimit = newNum;
      if (
        this.BillDetailArray[index].DiscountPercent >
        Number(this.authService.masterdata.billDiscount)
      ) {
        this.discountflag = false;
        this.BillDetailArray[index].Discount = 0;
        this.BillDetailArray[index].DiscountPercent = 0;
        this.BillDetailArray[index].currentAmount = (
          parseFloat(this.BillDetailArray[index].Amount) +
          parseFloat(this.BillDetailArray[index].ServiceCharges)
        ).toFixed(2);
        this.dataSource.data = this.BillDetailArray;
        this.paymentDetail(this.BillDetailArray);
        document.getElementById("userDiscountRequestModal").style.display =
          "block";
      }
    }
  }
  returnSericeChage(amount, percetage) {
    if (amount > 0 && percetage > 0) {
      let calchage = (amount * percetage) / 100;
      return calchage.toFixed(2);
    } else {
      return 0;
    }
  }
  onserviceChnage(e: any, index: number) {
    if (e === null || e === undefined || e == "") {
      this.BillDetailArray[index].ServiceCharges = 0;
      // this.BillDetailArray[index].Discount = 0;
      // this.BillDetailArray[index].DiscountPercent = 0;
      this.BillDetailArray[index].currentAmount =
        this.BillDetailArray[index].Amount;
      this.paymentDetail(this.BillDetailArray);
    } else {
      this.BillDetailArray[index].ServiceCharges = 0;
      this.BillDetailArray[index].currentAmount = 0;
      this.BillDetailArray[index].ServiceCharges = parseFloat(e);
      // this.BillDetailArray[index].currentAmount = parseFloat(this.BillDetailArray[index].Amount) - parseFloat(this.BillDetailArray[index].Discount);
      this.BillDetailArray[index].currentAmount =
        parseFloat(
          this.BillDetailArray[index].Amount +
          this.BillDetailArray[index].ServiceCharges
        ) - parseFloat(this.BillDetailArray[index].Discount);
      this.paymentDetail(this.BillDetailArray);
    }
  }

  checkQuantity(qty: any) {
    if (qty == "") {
      return 1;
    }
  }
  onQuantity(e: any, index: number) {
    if (e <= 0) {
      var NewRate = this.BillDetailArray[index].Rate * 1;
      this.BillDetailArray[index].Unit = 1;
      if (NewRate > 0 && this.BillDetailArray[index].scPer > 0) {
        this.BillDetailArray[index].ServiceCharges = this.returnSericeChage(
          NewRate,
          this.BillDetailArray[index].scPer
        );
      }
      this.BillDetailArray[index].Amount = NewRate;
      this.BillDetailArray[index].NetAmt = NewRate;
      if (
        this.BillDetailArray[index].DiscountPercent != undefined &&
        this.BillDetailArray[index].DiscountPercent != null
      ) {
        this.BillDetailArray[index].Discount =
          (NewRate * this.BillDetailArray[index].DiscountPercent) / 100;
      } else {
        this.BillDetailArray[index].DiscountPercent = 0;
      }
      this.BillDetailArray[index].currentAmount = (
        parseFloat(this.BillDetailArray[index].Amount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges) -
        parseFloat(this.BillDetailArray[index].Discount)
      ).toFixed(2);
      this.paymentDetail(this.BillDetailArray);
      this.dashboardService.openSnackBar(
        "Qty should be greater than 0(Zero)",
        "OK"
      );
    } else if (e === null || e === undefined || e == "") {
      this.BillDetailArray[index].Discount = 0;
      this.BillDetailArray[index].Unit = 1;
      this.BillDetailArray[index].Amount = 0;
      this.BillDetailArray[index].NetAmt = 0;
      this.BillDetailArray[index].ServiceCharges = 0;
      this.BillDetailArray[index].currentAmount = 0;
      this.paymentDetail(this.BillDetailArray);
    } else {
      var NewRate = this.BillDetailArray[index].Rate * parseFloat(e);
      if (NewRate > 0 && this.BillDetailArray[index].scPer > 0) {
        this.BillDetailArray[index].ServiceCharges = this.returnSericeChage(
          NewRate,
          this.BillDetailArray[index].scPer
        );
      }
      this.BillDetailArray[index].Unit = parseFloat(e);
      this.BillDetailArray[index].Amount = NewRate;
      this.BillDetailArray[index].NetAmt = NewRate;
      if (
        this.BillDetailArray[index].DiscountPercent != undefined &&
        this.BillDetailArray[index].DiscountPercent != null
      ) {
        this.BillDetailArray[index].Discount =
          (NewRate * this.BillDetailArray[index].DiscountPercent) / 100;
      } else {
        this.BillDetailArray[index].DiscountPercent = 0;
      }
      this.BillDetailArray[index].currentAmount = (
        parseFloat(this.BillDetailArray[index].Amount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges) -
        parseFloat(this.BillDetailArray[index].Discount)
      ).toFixed(2);
      this.paymentDetail(this.BillDetailArray);
    }
  }

  onRemarkChnage(e: string, index: number) {
    this.BillDetailArray[index].Remarks = e;
    this.dataSource.data = this.BillDetailArray;
    this.paymentDetail(this.BillDetailArray);
  }

  onchangeRate(e: number, index: number) {
    if (e === null || e === undefined || e == 0) {
      this.BillDetailArray[index].Discount = 0;
      this.BillDetailArray[index].Amount = 0;
      this.BillDetailArray[index].NetAmt = 0;
      this.BillDetailArray[index].DiscountPercent = 0;
      this.BillDetailArray[index].currentAmount = 0;
      this.BillDetailArray[index].Rate = 0;
      this.paymentDetail(this.BillDetailArray);
    } else {
      this.BillDetailArray[index].Rate = e;
      this.BillDetailArray[index].NetAmt =
        e * parseFloat(this.BillDetailArray[index].Unit);
      this.BillDetailArray[index].Amount = parseFloat(
        this.BillDetailArray[index].NetAmt
      );
      if (
        this.BillDetailArray[index].DiscountPercent != undefined &&
        this.BillDetailArray[index].DiscountPercent != null
      ) {
        this.BillDetailArray[index].Discount =
          (this.BillDetailArray[index].NetAmt *
            this.BillDetailArray[index].DiscountPercent) /
          100;
      } else {
        this.BillDetailArray[index].DiscountPercent = 0;
      }
      this.BillDetailArray[index].currentAmount = (
        parseFloat(this.BillDetailArray[index].Amount) +
        parseFloat(this.BillDetailArray[index].ServiceCharges) -
        parseFloat(this.BillDetailArray[index].Discount)
      ).toFixed(2);
      this.paymentDetail(this.BillDetailArray);
    }
  }

  getoverallDiscount(e: number) {
    if (e >= 0) {
      this.lessDiscount = 0;
      this.lessDiscount = e;
      //console.log( this.lessDiscount)
      var disPer =
        (parseFloat(this.lessDiscount) / parseFloat(this.totalpay)) * 100;
      var newNum = Math.round((disPer + Number.EPSILON) * 100) / 100;

      for (let i = 0; i < this.BillDetailArray.length; i++) {
        this.BillDetailArray[i].currentAmount = this.BillDetailArray[i].Amount;
        this.BillDetailArray[i].currentAmount =
          Math.round((this.BillDetailArray[i].Amount + Number.EPSILON) * 100) /
          100;
        this.BillDetailArray[i].maxDiscountLimit = newNum;
        var Newdiscount = (this.BillDetailArray[i].Amount * newNum) / 100;
        Newdiscount = Math.round((Newdiscount + Number.EPSILON) * 100) / 100;
        this.BillDetailArray[i].currentAmount = (
          this.BillDetailArray[i].Amount - Newdiscount
        ).toFixed(2);
        //  this.BillDetailArray[i].currentAmount = this.BillDetailArray[i].currentAmount - Newdiscount;
        this.BillDetailArray[i].Discount = Newdiscount;
      }

      this.dataSource.data = this.BillDetailArray;
      this.paymentDetail(this.BillDetailArray);
    } else {
      this.dashboardService.openSnackBar("Amount will greater the zero", "OK");
    }
  }

  getoverallnetAmmount(e: number) {
    this.netbillamount = e;
    this.currentpayable = this.netbillamount;
    this.partyAmount = this.netbillamount;
  }
  getoverallCurrentPaybleAmonut(e: number) {
    this.netbillamount = e;
    this.currentpayable = this.netbillamount;
    this.partyAmount = this.netbillamount;
  }

  paymentDetail(data: any, type?: any) {

    this.tpatotalreceved = 0;
    this.selftotalrecevered = 0;
    this.totalpay = 0;
    this.servicecharge = 0;
    this.lessDiscount = 0;
    this.netbillamount = 0;
    this.currentpayable = 0;
    this.partyAmount = 0;
    this.copartyAmount = 0;
    var DiscountAmount: number = 0;

    if (data.length > 0) {
      data?.forEach((element) => {
        this.totalpay = this.totalpay + element.Amount;
        this.servicecharge =
          parseFloat(this.servicecharge) + parseFloat(element.ServiceCharges);
        this.lessDiscount = this.lessDiscount + element.Discount;

      });
      this.lessDiscount = Math.round(this.lessDiscount);
      this.netbillamount =
        this.totalpay - this.lessDiscount + parseFloat(this.servicecharge);
      this.currentpayable = Math.round(this.netbillamount);
      this.partyAmount = this.netbillamount;
    }

    this.reciptBlanceAmmount = this.currentpayable;

    this.dashboardService.subscriptions = this.billingservice
      .getbillingrecipt(
        this.opdvisitService.patientdetails.pkRegId,
        this.BillingData.PK_BillId,
        0
      )
      .subscribe((data) => {

        this.billingservice.ipdID = this.BillingData.FK_IPDId;
        this.ReciptArray = data.filter(item => item.iscancelled != true && item.isAdjusted != true);
        var NewAmount = 0;
        var billRefoundAmount = 0;
        var AdvanceRefoundAmount = 0;
        var adjustedAmount = 0;
        // var tparecevived = 0;
        //  var selfrecevied = 0;
        if (this.ReciptArray.length == 0) {
          this.dashboardService.subscriptions = this.billingservice
            .getAdustedDetails(0, this.BillingData.PK_BillId)
            .subscribe((res) => {

              this.RecieptDepositedAmmount = 0;
              if (res.length > 0) {

                res?.forEach((element) => {
                  this.RecieptDepositedAmmount =
                    this.RecieptDepositedAmmount +
                    element.adjustedAmount +
                    element.amountTDS +
                    element.amountDiscount +
                    element.amountDisAllow +
                    element.amountST;
                  // if (element.fK_PartyId == 1) {
                  //   selfrecevied = selfrecevied + element.adjustedAmount;
                  // } else {
                  //   tparecevived = tparecevived + element.adjustedAmount;
                  // }
                  this.currentpayable =
                    this.netbillamount - this.RecieptDepositedAmmount;
                  this.reciptBlanceAmmount = this.currentpayable;
                });
                //  this.tpatotalreceved = tparecevived;
                // this.selftotalrecevered = selfrecevied;
                if (type == 0 && this.BillingData.PK_BillId > 0) {
                  // var filedata =
                  //   this.reporturl +
                  //   "OPDBill.aspx?BillId=" + this.BillingData.PK_BillId + "&BranchId=" + this.authService.Loggeduser.branchid + "&BillingCompanyName=" + this.authService.Loggeduser.billingcompanyname + "&PageHeadWebReport=" + this.PageHeader.propertyValue + "&QRCode=" + this.QrCode.propertyValue;
                  // this.sendWhatAPPmsg(this.BillingData.PK_BillId, filedata, this.reciptBlanceAmmount);

                }
              }
            }, (err) => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
        }
        this.ReciptArray?.forEach((element) => {

          NewAmount = NewAmount + parseInt(element.netAmt);
          billRefoundAmount = billRefoundAmount + parseInt(element.billRefund);
          AdvanceRefoundAmount =
            AdvanceRefoundAmount + parseInt(element.refunded);

          if (this.BillingData.PK_BillId > 0) {
            this.dashboardService.subscriptions = this.billingservice
              .getAdustedDetails(0, this.BillingData.PK_BillId)
              .subscribe((res) => {

                this.RecieptDepositedAmmount = 0;
                if (res.length > 0) {

                  res?.forEach((element) => {
                    this.RecieptDepositedAmmount =
                      this.RecieptDepositedAmmount +
                      element.adjustedAmount +
                      element.amountTDS +
                      element.amountDiscount +
                      element.amountDisAllow +
                      element.amountST;
                    // if (element.fK_PartyId == 1) {
                    //   selfrecevied = selfrecevied + element.adjustedAmount;
                    // } else {
                    //   tparecevived = tparecevived + element.adjustedAmount;
                    // }
                    this.currentpayable =
                      this.netbillamount - this.RecieptDepositedAmmount;
                    this.reciptBlanceAmmount = this.currentpayable;
                  });
                  //  this.tpatotalreceved = tparecevived;
                  // this.selftotalrecevered = selfrecevied;
                  if (type == 0 && this.BillingData.PK_BillId > 0) {
                    // var filedata =
                    //   this.reporturl +
                    //   "OPDBill.aspx?BillId=" + this.BillingData.PK_BillId + "&BranchId=" + this.authService.Loggeduser.branchid + "&BillingCompanyName=" + this.authService.Loggeduser.billingcompanyname + "&PageHeadWebReport=" + this.PageHeader.propertyValue + "&QRCode=" + this.QrCode.propertyValue;
                    // this.sendWhatAPPmsg(this.BillingData.PK_BillId, filedata, this.reciptBlanceAmmount);

                  }
                }
              }, (err) => {
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                }
                else if (err.error.statusCode == 422) {
                  this.dashboardService.openSnackBar(err.error.message, "OK");
                }
                else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              });

          }
        });
      });


  }
  getpayment(e: any) {
    if (this.netbillamount - e >= 0) {
      this.partyAmount = e;
      this.copartyAmount = this.netbillamount - this.partyAmount;
    } else {
      this.partyAmount = this.netbillamount;
      this.copartyAmount = 0;
      this.dashboardService.openSnackBar(
        "Please enter correct amount not more than net amount",
        "OK"
      );
    }
  }

  getcopayment(e: any) {
    if (this.netbillamount - e >= 0) {
      this.copartyAmount = e;
      this.partyAmount = this.netbillamount - this.copartyAmount;
    } else {
      this.copartyAmount = this.netbillamount;
      this.partyAmount = 0;
      this.dashboardService.openSnackBar(
        "Please enter correct amount not more than net amount",
        "OK"
      );
    }
  }

  getUserConfrigration() {
    this.authService.get_master_Config();
  }

  visitDialog() {
    if (this.opdvisitService.patientdetails.pkRegId) {
      const dialogRef = this.dialog.open(VisitComponent, {
        // panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        // height: "100%",
        width: "85%",
        data: {
          pid: this.opdvisitService.patientdetails.pkRegId,
        },
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
        // this.get_All_surgeries();
      });
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  printInvoice() {
    const dialogRef = this.dialog.open(PrintInvoiceComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "70%",
      data: {},
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      // this.get_All_surgeries();
    });
  }
  receiptdailog() {
    if (this.authService.masterdata.isGenarateReceipt === true) {
      if (
        this.BillingData.PK_BillId === null ||
        this.BillingData.PK_BillId === undefined ||
        this.BillingData.PK_BillId === 0
      ) {
        this.dashboardService.openSnackBar("Please Save Bill", "OK");
      } else {
        this.setfreshReciptdata();
        this.setbiilingdata();
        if (this.getpatientId) {
          var repData = {
            pid: this.getpatientId,
            billId: this.getBillId,
            recipobj: this.ReciptData,
            checkAmount: this.checkNewReciept,
            PartyPay: this.partyAmount,
            Copay: this.copartyAmount,
            Billdetail: this.BillingDebitDetail,
            balanceAmount: this.reciptBlanceAmmount,
            ResionDiscount: this.getBillIdobj.billMasterDtos[0]?.freeReason,
            discount: this.getBillIdobj.billMasterDtos[0]?.discountAmt,
            totalAmount: this.getBillIdobj.billMasterDtos[0]?.totalAmt,
            NetAmount: this.getBillIdobj.billMasterDtos[0]?.netBillAmt,
            PYear: this.opdvisitService.patientdetails.ageYear,
            PMonth: this.opdvisitService.patientdetails.ageMonth,
            PDays: this.opdvisitService.patientdetails.ageDays,
          };
        } else {
          var repData = {
            pid: this.opdvisitService.patientdetails.pkRegId,
            billId: this.getBillId,
            recipobj: this.ReciptData,
            checkAmount: this.checkNewReciept,
            PartyPay: this.partyAmount,
            Copay: this.copartyAmount,
            Billdetail: this.BillingDebitDetail,
            balanceAmount: this.reciptBlanceAmmount,
            ResionDiscount: this.getBillIdobj.billMasterDtos[0]?.freeReason,
            discount: this.getBillIdobj.billMasterDtos[0]?.discountAmt,
            totalAmount: this.getBillIdobj.billMasterDtos[0]?.totalAmt,
            NetAmount: this.getBillIdobj.billMasterDtos[0]?.netBillAmt,
            PYear: this.opdvisitService.patientdetails.ageYear,
            PMonth: this.opdvisitService.patientdetails.ageMonth,
            PDays: this.opdvisitService.patientdetails.ageDays,
          };
        }

        const dialogRef = this.dialog.open(ReciptComponent, {

          maxWidth: "100vw !important",
          height: "95%",
          width: "90%",
          data: repData,
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
          this.getlastBill(this.getBillId);
          this.getbills(
            this.dashboardService.selecteddate,
            this.dashboardService.selecteddate
          );
        });
      }
    } else {
      this.dashboardService.openSnackBar(
        "you don't have permission to access this resource",
        "OK"
      );
    }
  }

  // getCurrentBalancedAmount(a, b, c) {
  //   this.billingservice.getrecipt(a, b, c).subscribe(data => {
  //     this.ReciptArray = data;
  //     var NewAmount = 0;
  //     var billRefoundAmount = 0;
  //     var AdvanceRefoundAmount = 0;
  //     var adjustedAmount = 0;
  //     this.ReciptArray?.forEach(element => {
  //       NewAmount = NewAmount + parseInt(element.netAmt);
  //       billRefoundAmount = billRefoundAmount + parseInt(element.billRefund);
  //       AdvanceRefoundAmount = AdvanceRefoundAmount + parseInt(element.refunded);

  //     if (element.pK_ReceiptId != undefined && element.pK_ReceiptId != null) {
  //       this.billingservice.getAdustedDetails(element.pK_ReceiptId, 0).subscribe(resp => {
  //         console.log("adjustedt data" + resp);
  //         resp?.forEach(element => {
  //           adjustedAmount = adjustedAmount + element.adjustedAmount;

  //         });

  //         this.RecieptDepositedAmmount = this.RecieptDepositedAmmount - adjustedAmount;
  //       })
  //     }
  //     else {
  //       this.RecieptDepositedAmmount = NewAmount - AdvanceRefoundAmount - billRefoundAmount;
  //       this.currentpayable = this.netbillamount;
  //     }
  //   });

  //     if (this.RecieptDepositedAmmount == 0 && adjustedAmount > 0) {
  //       this.RecieptDepositedAmmount = adjustedAmount;
  //     }

  //   });

  // }

  receiptdailognew(billid) {
    if (this.authService.masterdata.isGenarateReceipt === true) {
      if (billid > 0 && this.opdvisitService.patientdetails.pkRegId > 0) {
        // this.setfreshReciptdata();
        // this.setbiilingdata();
        const dialogRef = this.dialog.open(ReciptComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "100%",
          width: "100%",
          data: { patientId: this.opdvisitService.patientdetails.pkRegId },
        });
        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
          //  this.ngOnInit();
          this.getlastBill(this.getBillId);
          this.getbills(
            this.dashboardService.selecteddate,
            this.dashboardService.selecteddate
          );
        });
      } else {
        // this.setfreshReciptdata();
        // this.setbiilingdata();

        const dialogRef = this.dialog.open(AdvanceRecieptComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "95%",
          width: "90%",
          data: {
            patientId: this.opdvisitService.patientdetails.pkRegId,
            showheader: true,
          },
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
          // this.opdvisitService.getpatientdetails(this.opdvisitService.patientdetails.pkRegId);
          this.ngOnInit();
        });
      }
    } else {
      this.dashboardService.openSnackBar(
        "you don't have permission to access this resource",
        "OK"
      );
    }
  }

  closeReciept() {
    this.reciptmodelbox = "none";
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  checkConsulation() {
    if (
      parseInt(this.VisitDiffernce) === 0 &&
      this.BillingData.FK_BillSerieseId === 1
    ) {
      //  this.checkConsultation=false;
      document.getElementById("SameBillConsultasion").style.display = "block";
      //  this.submitConsultationBil();
    } else {
      // this.checkConsultation= true;
    }
  }
  // getTime(){
  //   this.authService.serverDateTime().subscribe(data =>{
  //     this.cuurentTime = data.serverTime;
  //   })
  // }

  onSubmitBill() {

    console.log('onSubmitBill: Starting bill submission');
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    // if (this.screenPermissionobj?.addPermission === true) {
    if (this.opdvisitService.PatientisExpire === true) {
      this.dashboardService.openSnackBar("This Patient is Expired  ", "OK");
      return;
    } else {
      this.BillingData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;

      //console.log(this.BillingData.FK_RegId);
      this.BillingData.FK_DoctorId = this.BillingData.FK_DoctorId;
      var latestTime = new Date().toTimeString().split(" ")[0];
      if (
        this.BillingData.FK_RegId === null ||
        this.BillingData.FK_RegId === " " ||
        this.BillingData.FK_RegId === undefined
      ) {
        this.UHIDValidation = true;
        this.dashboardService.openSnackBar("Please Enter UHID", "OK");
        console.log('onSubmitBill: UHID validation failed');
        return;
      } else if (
        this.BillingData.FK_BillSerieseId == null ||
        this.BillingData.FK_BillSerieseId == ""
      ) {
        this.BillSerieseValidation = true;
        this.dashboardService.openSnackBar(
          "Please Select Bill Series Name",
          "OK"
        );
        console.log('onSubmitBill: Bill Series validation failed');
        this._submitValidationFail('Please Select Bill Series Name');
        return;
      } else if (
        this.BillingData.FK_BillTypeId == null ||
        this.BillingData.FK_BillTypeId == ""
      ) {
        this.BillEntryValidation = true;
        this.dashboardService.openSnackBar(
          "Please Select Bill Entry Type",
          "OK"
        );
        console.log('onSubmitBill: Bill Type validation failed');
        this._submitValidationFail('Please Select Bill Entry Type');
        return;
      } else if (
        this.BillingData.FK_CategoryId == 0 ||
        this.BillingData.FK_CategoryId == null
      ) {
        this.categoryValidation = true;
        this.dashboardService.openSnackBar(
          "Please select Category or enable from Masters",
          "OK"
        );
        console.log('onSubmitBill: Category validation failed');
        this._submitValidationFail('Please select Category');
        return;
      } else if (
        this.BillingData.FK_DoctorId === null ||
        this.BillingData.FK_DoctorId === undefined ||
        this.BillingData.FK_DoctorId.toString() == ""
      ) {
        this.DocterNameValidation = true;
        this.dashboardService.openSnackBar("Please Select Doctor", "OK");
        console.log('onSubmitBill: Doctor validation failed');
        this._submitValidationFail('Please Select Doctor');
        return;
      } else if (
        this.BillingData.FK_ReferredById === null ||
        this.BillingData.FK_ReferredById === undefined || (typeof this.BillingData.FK_ReferredById === 'string')
      ) {
        this.RefeeredBYValidation = true;
        this.dashboardService.openSnackBar("Please Select Referred By", "OK");
        console.log('onSubmitBill: Referred By validation failed');
        this._submitValidationFail('Please Select Referred By');
        return;
      } else if (
        this.BillingData.FK_PartyId === null ||
        this.BillingData.FK_PartyId === " " ||
        this.BillingData.FK_PartyId === undefined ||
        this.BillingData.FK_PartyId == 0
      ) {
        this.PartyTpaValidation = true;
        this.dashboardService.openSnackBar("Please Select Party Name", "OK");
        return;
      } else if (
        this.BillingData.RateType === null ||
        this.BillingData.RateType === " " ||
        this.BillingData.RateType === undefined ||
        this.BillingData.RateType == 0
      ) {
        this.rateTypeValidation = true;
        this.dashboardService.openSnackBar("Please Select Rate Type", "OK");
        return;
      } else if (
        this.BillingData.Fk_DrDeptID === null ||
        this.BillingData.Fk_DrDeptID === undefined ||
        this.BillingData.Fk_DrDeptID.toString() == ""
      ) {
        this.deptValidation = true;
        this.dashboardService.openSnackBar("Please Select Department", "OK");
        this._submitValidationFail('Please Select Department');
        return;
      } else if (
        this.BillDetailArray.length === 0 ||
        this.BillDetailArray[0].FK_ServiceId == 0
      ) {
        this.dashboardService.openSnackBar("Please Select Service", "OK");
        this._submitValidationFail('Please Select Service');
        return;
      } else if (
        (this.BillingData.FreeReason === null ||
          this.BillingData.FreeReason == "" ||
          this.BillingData.FreeReason === undefined) &&
        this.is_editalbe == true &&
        this.discountflag == true
      ) {
        this.freeValidation = true;
        this.dashboardService.openSnackBar(
          "Please Select Discount Reason",
          "OK"
        );
        return;
      } else {
        this.UHIDValidation = false;
        this.BillSerieseValidation = false;
        this.BillEntryValidation = false;
        this.categoryValidation = false;
        this.DocterNameValidation = false;
        this.RefeeredBYValidation = false;
        this.PartyTpaValidation = false;
        this.rateTypeValidation = false;
        this.deptValidation = false;
        this.freeValidation = false;
        this.showspinner = true;

        this._ensureBillMasterDefaults();

        this.BillingData.BillTime = latestTime;
        const newdate = this.authService.getServerDate;
        this.BillingData.BillDate = newdate;
        this.BillingData.FK_RegId =
          this.opdvisitService.patientdetails.pkRegId;

        // if (
        //   this.opdvisitService.patientdetails.ageYear == null ||
        //   this.opdvisitService.patientdetails.ageMonth == null ||
        //   this.opdvisitService.patientdetails.ageDays == null
        // ) {
        //   this.BillingData.AgeYear = 0;
        //   this.BillingData.AgeMonth = 0;
        //   this.BillingData.AgeDays = 0;
        // } else {
        //   this.BillingData.AgeYear =
        //     this.opdvisitService.patientdetails.ageYear;
        //   this.BillingData.AgeMonth =
        //     this.opdvisitService.patientdetails.ageMonth;
        //   this.BillingData.AgeDays =
        //     this.opdvisitService.patientdetails.ageDays;
        // }
        //  this.BillingData.AgeYear = this.opdvisitService.patientdetails.ageYear;
        //  this.BillingData.AgeMonth  = this.opdvisitService.patientdetails.ageMonth;
        //  this.BillingData.AgeDays  = this.opdvisitService.patientdetails.ageDays;
        if (
          this.BillingData.FK_IPDId != null &&
          this.BillingData.FK_IPDId != undefined
        ) {
          this.BillingData.FK_IPDId = this.BillingData.FK_IPDId;
        }
        this.BillingData.TotalAmt = this.totalpay;
        this.BillingData.ServiceChargeAmt = this.servicecharge;
        this.BillingData.DiscountAmt = this.lessDiscount;
        this.BillingData.NetBillAmt = this.netbillamount;
        this.BillingData.FK_ReferredById = this.BillingData.FK_ReferredById;
        this.BillingData.Fk_RateListid = this.billingservice.ratelist.rateListId;
        this.BillingData.FK_PartyId = parseInt(this.BillingData.FK_PartyId);
        this.BillingData.FK_BillTypeId = parseInt(
          this.BillingData.FK_BillTypeId
        );
        this.BillingData.FK_CategoryId = parseInt(
          this.BillingData.FK_CategoryId
        );
        this.BillingData.FK_BillSerieseId = parseInt(
          this.BillingData.FK_BillSerieseId
        );
        this.ReciptData.FK_RegId =
          this.opdvisitService.patientdetails.pkRegId;
        this.ReciptData.PaymentDate = newdate;
        this.ReciptData.PaymentTime = this.cuurentTime;
        this.ReciptData.CurrencyAmount = this.netbillamount;
        this.ReciptData.FK_PartyId = parseInt(this.BillingData.FK_PartyId);
        this.ReciptData.AmountINR = this.netbillamount;

        this.BillingData.RateType = parseInt(this.BillingData.RateType);
        this.BillingData.FK_DoctorId = this.BillingData.FK_DoctorId;
        this.BillingData.FK_BillingCompanyId =
          this.authService.selectedbillingcompany;
        this.BillingData.Fk_SpecialityIdModule = this.authService.Loggeduser.specialityId;
        this.BillingDebitDetail = [];
        var obj = {
          PK_TranId: 0,
          FK_Billd: 0,
          FK_PartyId: this.BillingData.FK_PartyId,
          Amount: parseFloat(this.partyAmount),
          IsDelete: 0,
        };
        var obj2 = {
          PK_TranId: 0,
          FK_Billd: 0,
          FK_PartyId: this.copartyId,
          Amount: parseFloat(this.copartyAmount),
          IsDelete: 0,
        };

        this.BillingDebitDetail.push(obj);
        if (this.copartyAmount != 0) {
          this.BillingDebitDetail.push(obj2);
        }

        var NewBillDetail = [];
        var BillDetailobj = {};
        if (this.BillDetailArray.length > 0) {
          for (let i = 0; i < this.BillDetailArray.length; i++) {
            const element = this.BillDetailArray[i];
            BillDetailobj = {
              PK_BillDetailId: element.PK_BillDetailId,
              FK_BillId: element.FK_BillId,
              FK_ServiceId: element.FK_ServiceId,
              Rate: element.Rate,
              Unit: element.Unit,
              Amount: element.Amount,
              Discount: element.Discount,
              ServiceCharges: element.ServiceCharges,
              NetAmt: element.currentAmount,
              FK_PackageId: element.FK_PackageId
                ? element.FK_PackageId
                : null,
              IsPerformed: element.IsPerformed,
              Remarks: element.Remarks,
              IsDelete: element.IsDelete,
            };

            NewBillDetail.push(BillDetailobj);
          }
        } else {
          this.showspinner = false;
          this.dashboardService.openSnackBar("Please Select Service", "OK");
          return;
        }
        //discussion required for duplicate services
        // var result = NewBillDetail.reduce((unique, o) => {
        //   if (!unique.some((obj) => obj.FK_ServiceId === o.FK_ServiceId)) {
        //     unique.push(o);
        //   }
        //   return unique;
        // }, []);
        let visitdate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
        // add visit data
        var visitObj = {}
        if (this.BillingData.FK_BillSerieseId === 1) {
          visitObj = {
            PK_VisitId: 0,
            FK_BranchId: this.authService.Loggeduser.branchid,
            FK_RegID: this.opdvisitService.patientdetails.pkRegId,
            VisitDate: visitdate,
            VisitTime: this.cuurentTime,
            // AgeYear: this.opdvisitService.patientdetails.ageYear,
            // AgeMonth: this.opdvisitService.patientdetails.ageMonth,
            // AgeDays: this.opdvisitService.patientdetails.ageDays,
            FK_BillCategoryId: parseInt(this.BillingData.FK_CategoryId),
            FK_PatientLocationId: 1,
            FK_PrevLocationId: 1,
            FK_DoctorId: this.BillingData.FK_DoctorId,
            FK_AppointmentId: this.opdvisitService.apptdetail.pkAppointmentId ? this.opdvisitService.apptdetail.pkAppointmentId : null,
            IsReview: 0,
            FK_CreatedById: this.authService.Loggeduser.userid,
            Fk_ReferredbyID: this.BillingData.FK_ReferredById,
            Fk_PrimaryDoctorID: this.BillingData.FK_DoctorId,
            FK_PartyId: this.BillingData.FK_PartyId,
            Remarks: this.BillingData.Remarks,
            Fk_SpecialityIdModule: this.authService.Loggeduser.specialityId,
            IsEmergency: this.opdvisitService.opdvisitmodel.isEmergency
          };
        }

        // console.log('newservices',result)

        var billFinalData = {
          BillMaster: this.BillingData,
          BillDetail: NewBillDetail,
          BillDebitDetail: this.BillingDebitDetail,
          OPDVisit: visitObj
        };
        //console.log('billing',billFinalData);
        this.completeBillingObj = billFinalData;

        if (this.copartyId === 0 && this.copartyAmount > 1) {
          this.showspinner = false;
          this.dashboardService.openSnackBar(
            "Please Select Co-Party Name",
            "OK"
          );
          return;
        } else {
          if (NewBillDetail.length === 0) {
            this.showspinner = false;
            this.dashboardService.openSnackBar("Please Select Service", "OK");
            return;
          } else {
            // this.billingservice.addbillingdata(billFinalData).subscribe(data => this.success_bill_response(data), err => this.err_billing_response(err));

            if (
              this.BillingData.FreeReason == null &&
              this.netbillamount === 0
            ) {
              this.showspinner = false;
              this.dashboardService.openSnackBar(
                "Please enter free reason in case of zero or any Discount",
                "OK"
              );
              return;
            } else {

              if (
                parseInt(this.VisitDiffernce) === 0 &&
                this.BillingData.FK_BillSerieseId === 1
              ) {
                this.showspinner = false;
                document.getElementById(
                  "SameBillConsultasion"
                ).style.display = "block";
                return;
              } else {
                this.billingservice.addbillingdata(billFinalData).pipe(takeUntil(this.destroy$)).subscribe(
                  (data) => this.success_bill_response(data, this.BillingData),
                  (err) => this.err_billing_response(err)
                );
              }
            }
          }
        }
      }
    }
    // } else {
    //   this.dashboardService.openSnackBar(
    //     "you don't have permission to access this resource",
    //     "OK"
    //   );
    // }
  }

  success_bill_response(data, BillingData: any) {

    console.log('success_bill_response: Bill created successfully, ID:', data.id?.id);
    this.showspinner = false;
    this.completeBillingObj = null;
    this.getpatientId = null;
    setTimeout(() => this.recepitCreateBtn.nativeElement.focus(), 0);
    this.setbillgetdata();
    if (data.statusCode) {
      if (this.checkwithappoitnment == true) {
        this.UpdateAppointmentByRegIdApptId(
          this.opdvisitService.patientdetails.pkRegId,
          this.opdvisitService.apptdetail.pkAppointmentId
        );
        this.checkwithappoitnment = false;
      } else {
        this.checkwithappoitnment = false;
      }
      //Send Email to Patient
      // var filedata =
      //   this.reporturl +
      //   "OPDBill.aspx?BillId=" +
      //   data.statusCode +
      //   "&BranchId=" +
      //   this.authService.Loggeduser.branchid +
      //   "&BillingCompanyName=" +
      //   this.authService.Loggeduser.billingcompanyname +
      //   "&PageHeadWebReport=" +
      //   this.PageHeader.propertyValue +
      //   "&QRCode=" +
      //   this.QrCode.propertyValue;
      // if (
      //   this.opdvisitService.patientdetails.emailAddress != "" &&
      //   this.opdvisitService.patientdetails.emailAddress != null &&
      //   this.opdvisitService.patientdetails.emailAddress != undefined
      // ) {
      //   const formData = new FormData();
      //   formData.append("file", filedata);
      //   formData.append("EmailType", "BILL");
      //   formData.append(
      //     "ToEmail",
      //     this.opdvisitService.patientdetails.emailAddress
      //   );
      //   this.opdvisitService.sendEmailtoPatient(formData);
      // }

      this.getBillId = data.id.id;

      BillingData.PK_BillId = this.getBillId;
      this.opdvisitService.getlastvisitid = data.id.fkVisitId;
      this.ReciptData.FK_AdjustedBillId = parseInt(this.getBillId);

      if (!this.opdvisitService.apptdetail.pkAppointmentId) {
        this.opdvisitService.apptdetail.pkAppointmentId = null;
      }


      ////console.log('visitObj',visitObj)
      this.dashboardService.openSnackBar(
        "Your Bill Created successfully",
        "OK"
      );

      let skipFreshReceiptForAuto = false;

      if (this.automationWorkflow) {
        const wf = this.automationWorkflow;
        const needAutoReceipt = wf.autoReceipt !== false
          && BillingData.FK_PartyId === 1
          && this.netbillamount != 0
          && this.authService.masterdata?.isGenarateReceipt === true;

        skipFreshReceiptForAuto = needAutoReceipt;

        if (needAutoReceipt) {
          this._automationAutoReceipt(this.getBillId, BillingData);
        } else if (wf.autoPrint) {
          console.log('Automation: Triggering auto-print for bill', this.getBillId);
          this._automationPrintAndNotify(this.getBillId, BillingData);
        } else {
          this._automationNotifySaved(this.getBillId, BillingData, false);
        }
      }
      if (BillingData.FK_BillSerieseId === 1) {
        setTimeout(() => {
          var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
          var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
          var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
          if (queueproty[0]?.propertyValue == 'Y' && queueurl[0]?.propertyValue != null && queueurl[0]?.propertyValue != undefined && queuetoken[0]?.propertyValue != null && queuetoken[0]?.propertyValue != undefined) {
            this.opdvisitService.getlastvisit(this.opdvisitService.patientdetails.pkRegId).pipe(takeUntil(this.destroy$)).subscribe(data => {

              if (Date.parse(this.datePipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(data.billDate, "yyyy-MM-dd").toString())) {
                let visiid = data.fk_VisitId

                const bindname = this.opdvisitService?.patientdetails?.initial != null ? this.opdvisitService?.patientdetails?.initial + ' ' + this.opdvisitService?.patientdetails?.firstName : this.opdvisitService?.patientdetails?.firstName;
                var queuevisitObj = {
                  PK_VisitId: 0,
                  FK_BranchId: this.authService.Loggeduser.branchid,
                  FK_RegID: this.opdvisitService.patientdetails.pkRegId,
                  VisitDate: this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd"),
                  VisitTime: this.cuurentTime,
                  AgeYear: this.opdvisitService.patientdetails.ageYear,
                  AgeMonth: this.opdvisitService.patientdetails.ageMonth,
                  AgeDays: this.opdvisitService.patientdetails.ageDays,
                  FK_BillCategoryId: parseInt(BillingData.FK_CategoryId),
                  FK_PatientLocationId: 1,
                  FK_DoctorId: BillingData.FK_DoctorId,
                  FK_AppointmentId: this.opdvisitService.apptdetail.pkAppointmentId,
                  IsReview: 1,
                  fk_visitid: visiid,
                  PatientName: bindname + ' ' + this.opdvisitService?.patientdetails?.lastName,
                  CategoryName: this.dashboardService.categories.filter(item => item.pkCategoryId == BillingData.FK_CategoryId)[0]?.categoryName,
                  Remarks: '',
                  Fk_CreatedById: this.authService.Loggeduser.userid,
                  Fk_RoomId: this.authService.Loggeduser.roomid,
                  RoomName: this.authService.Loggeduser.room

                };
                const headers = new HttpHeaders().set('X-API-KEY', `${queuetoken[0]?.propertyValue}`);
                this.http.post<any>(queueurl[0]?.propertyValue + "Interface/InsertOpdVisit", queuevisitObj, { headers }).subscribe((resp) => {

                })
              }
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
          }

        }, 300)
      }
      if (!this.automationWorkflow && BillingData.FK_PartyId === 1 && this.netbillamount != 0) {
        this.openModalDialog();
      } else if (this.automationWorkflow) {
        document.getElementById('ReciptModelBox').style.display = 'none';
      }
      if (!skipFreshReceiptForAuto) {
        this.setfreshReciptdata();
      }
      this.billingservice.lastbillid = data.id.id;
      if (this.automationWorkflow) {
        this._automationPendingLastBillId = data.id.id;
      } else {
        this.getlastBill(data.id.id);
      }
      this.completeBillingObj = null;
      this.isupdate = true;
    }
    //  this.BillDetailArray =[];
    //  this.BillingData.FK_RegId  = null;
    //   this.BillingDebitDetail=[];
    //  this.dataSource.data= [];
    //  this.BillingData.PK_BillId = 0;
    //  this.partyAmount =0;
    //  this.copartyAmount =0;
  }
  // sendWhatAPPmsg(billid, fileurl, bamount) {
  //   if (this.opdvisitService.patientdetails.mobileNo) {
  //     let payload = {
  //       "MrdNo": this.opdvisitService.patientdetails.pkRegId,
  //       "PatientName": this.opdvisitService.patientdetails.firstName + ' ' + this.opdvisitService.patientdetails.lastName,
  //       "HospitalName": this.authService.Loggeduser.billingcompanyname,
  //       "TransID": billid,
  //       "AmountTotal": this.netbillamount,
  //       "AmountTotalDue": bamount,
  //       "TransDate": this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
  //       "MOP": "Cash",
  //       "AmountConsultation": this.netbillamount,
  //       "AmountLabTests": "0",
  //       "AmountMedications": 0,
  //       "AmountOthers": "0",
  //       "PayMode": "CASH",
  //       "HelpLineNo": this.dashboardService.branchmansterObj.line3,
  //       "FileName": "BillInvoice_" + billid,
  //       "Type": "document",
  //       "FileURL": fileurl,
  //       "MobileNo": this.opdvisitService.patientdetails.mobileNo,
  //       "BranchId": this.authService.Loggeduser.branchid,
  //       "DocumentURL": "",
  //       "SMSType": "BILLING"
  //     }
  //     this.opdvisitService.sendwhatsApp(payload);
  //   }
  // }
  err_billing_response(err) {
    if (err) {
      this.showspinner = false;
      this.checkwithappoitnment = false;
      const apiMsg = err.error?.message || err.message || 'API Failed';
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        this._submitValidationFail("You Don't have Permission");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(apiMsg, "OK");
        this._submitValidationFail(apiMsg);
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
        this._submitValidationFail(apiMsg);
      }
    }
  }
  openModalDialog() {
    // this.display='block'; //Set block css
    if (this.authService.masterdata.isGenarateReceipt === true) {
      document.getElementById("ReciptModelBox").style.display = "block";
    } else {
      // this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }

    // this.getlastBill( this.getBillId);
  }

  closeModalDialog() {
    // this.display='none';
    document.getElementById("ReciptModelBox").style.display = "none";
    this.setbiilingdata();
    this.getlastBill(this.getBillId);
    // this.BillingData = {};
  }

  closeDiscountModalDialog() {
    // this.display3='none';
    document.getElementById("DiscountModel").style.display = "none";
    // this.BillingData = {};
    document.getElementById("BillingResonModel").style.display = "none";
  }

  closeModificationModalDialog() {
    document.getElementById("BillingResonModel").style.display = "none";
  }

  onSubmitReciept() {
    // console.log('recipt' ,this.ReciptData);
    this.ReciptData.FK_AdjustedBillId = parseInt(
      this.ReciptData.FK_AdjustedBillId
    );
    this.ReciptData.AgeYear = this.opdvisitService.patientdetails.ageYear;
    this.ReciptData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
    this.ReciptData.AgeDays = this.opdvisitService.patientdetails.ageDays;
    this.ReciptData.IsEdit = false;
    this.dashboardService.subscriptions = this.billingservice.addbilingrecipts(this.ReciptData).subscribe(
      (data) => this.add_recipt_Succsess(data),
      (err) => this.add_recipt_failed(err)
    );
  }
  add_recipt_Succsess(data) {
    if (
      this.opdvisitService.patientdetails.emailAddress != "" &&
      this.opdvisitService.patientdetails.emailAddress != null &&
      this.opdvisitService.patientdetails.emailAddress != undefined
    ) {
      const filedata = null;
      const formData = new FormData();
      formData.append("file", filedata);
      formData.append("EmailType", "BILLRECEIPT");
      formData.append(
        "ToEmail",
        this.opdvisitService.patientdetails.emailAddress
      );
      this.opdvisitService.sendEmailtoPatient(formData);
    }
    // this.get_recipt(this.opdvisitService.patientdetails.pkRegId, this.BillingData.PK_BillId,);
    document.getElementById("ReciptModelBox").style.display = "none";
    this.setbiilingdata();
    this.getlastBill(this.getBillId, 0);
    this.checkNewReciept = true;
    this.disabledreceptbutton = false;
    this.printTimelineBill(1, this.getBillId, this.opdvisitService.patientdetails.pkRegId);
  }

  add_recipt_failed(err) {
    this.checkNewReciept = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  popupdynamicData: string = "";

  editbillingform(type) {

    // if (
    //   this.screenPermissionobj?.modifyPermission === true ||
    //   type == "BillRefund"
    // ) {
    if (this.billingservice.billserviceConfig.approvalSystem == true) {
      this.dashboardService.subscriptions = this.billingservice
        .getRequestStatusdata(
          this.authService.Loggeduser.branchid,
          this.authService.getServerDate,
          this.authService.getServerDate,
          type,
          0,
          this.getBillId
        )
        .subscribe(
          (x: any) => {

            if (x.length > 0) {
              const checkstatus = x.filter(
                (item) => item.status == "Pending"
              );
              const rejectestatus = x.filter(
                (item) => item.status == "Reject"
              );
              const checkapprovedagain = x.filter(
                (item) =>
                  item.status == "Approved" && item.requestUsed == null
              );
              if (checkstatus.length > 0) {
                if (type == "Modification") {
                  this.popupdynamicData =
                    "Bill Modification Pending for Approval.";
                } else if (type == 'Cancell') {
                  this.popupdynamicData = "Bill cancellation request is pending for approval.";
                } else {
                  this.popupdynamicData = "Bill Refund Pending for Approval.";
                }

                document.getElementById(
                  "billModificationRequestpending"
                ).style.display = "block";
              } else if (
                rejectestatus.length > 0 &&
                checkapprovedagain.length == 0
              ) {
                if (type == "Modification") {
                  this.popupdynamicData =
                    "Bill Modification Request is Rejected.";
                } else if (type == 'Cancell') {
                  this.popupdynamicData = "Bill Cancel Request is Rejected.";
                } else {
                  this.popupdynamicData = "Bill Refund Request is Rejected.";
                }

                document.getElementById(
                  "billModificationRequestpending"
                ).style.display = "block";
              } else if (checkapprovedagain.length > 0) {
                const checkapproved = x.filter(
                  (item) => item.status == "Approved"
                );
                this.getbillingReson =
                  checkapproved.length > 0
                    ? checkapproved[0].approverNotes
                    : "N/A";
                if (type == "Modification") {
                  this.billupdateresons();
                } else if (type == 'Cancell') {
                  this.billCancelobject = {};
                  this.billCancelobject.Fk_BillId = checkapproved[0].fK_BillID;
                  this.billCancelobject.Fk_RegId = checkapproved[0].patientID;
                  this.billCancelobject.CancelType = 'Cancel';
                  this.billCancelobject.RequestUsed = 1;
                  this.billCancelobject.Iscancel = true;
                  this.billCancelobject.FK_CancelledById = this.authService.Loggeduser.userid;
                  this.billCancelobject.PK_TranID_Approval = checkapproved[0].pK_TranID
                  this.billCancelobject.CancelledDateTime = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd") + ' ' + new Date().toTimeString().split(" ")[0];
                  this.approvalRequestCommentModal();
                } else {
                  this.BillRefund(
                    this.opdvisitService.patientdetails.pkRegId,
                    this.BillingData.PK_BillId
                  );
                }

                this.billApprovalobject = checkapprovedagain[0];
              } else {
                //  document.getElementById("BillingResonModel").style.display = "block";
                if (type == "Modification") {
                  this.mattabindex = 3;
                  this.raiseApprovalRequestModal();

                } else if (type == "Cancell") {
                  this.mattabindex = 0;
                  this.raiseApprovalRequestModal();
                } else {
                  this.raiserefundApprovalRequestModal();
                }
              }
            } else {
              if (type == "Modification") {
                this.mattabindex = 3;
                this.raiseApprovalRequestModal();
              } else if (type == "Cancell") {
                this.mattabindex = 0;
                this.raiseApprovalRequestModal();
              } else {
                this.raiserefundApprovalRequestModal();
              }
            }
          },
          (err) => {
            this.dashboardService.openSnackBar("API Failed", "ok");
          }
        );
    } else {
      // document.getElementById("BillingResonModel").style.display = "block";
      // this.billupdateresons();
      if (type == "BillRefund") {
        this.BillRefund(
          this.opdvisitService.patientdetails.pkRegId,
          this.BillingData.PK_BillId
        );

      } else if (type == "Cancell") {
        this.billCancelobject = {};
        this.billCancelobject.Fk_BillId = this.BillingData.PK_BillId;
        this.billCancelobject.Fk_RegId = this.opdvisitService.patientdetails.pkRegId,
          this.billCancelobject.CancelType = 'Cancel';
        this.billCancelobject.Iscancel = true;
        this.billCancelobject.FK_CancelledById = this.authService.Loggeduser.userid;
        this.billCancelobject.CancelledDateTime = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd") + ' ' + new Date().toTimeString().split(" ")[0];
        this.approvalRequestCommentModal();
      } else {
        document.getElementById("BillingResonModel").style.display = "block";
      }
    }
    // } else {
    //   this.dashboardService.openSnackBar(
    //     "you don't have permission to access this resource",
    //     "OK"
    //   );
    // }
  }
  closeBillModificationRequestPending() {
    document.getElementById("billModificationRequestpending").style.display =
      "none";
  }

  getlastBill(id: number, type?: any) {
    this.BillingData = {};
    this.getBillIdobj = [];
    // this.display1='none';
    this.billingservice.get_Bill_billId(id).pipe(takeUntil(this.destroy$)).subscribe((data) => {

      this.getBillIdobj = data;
      if (
        this.getBillIdobj.billMasterDtos[0]?.refundAmount != null &&
        this.getBillIdobj.billMasterDtos[0]?.refundAmount != undefined
      ) {
        this.totalrefundamount =
          this.getBillIdobj.billMasterDtos[0]?.refundAmount;
      } else {
        this.totalrefundamount = 0;
      }
      this.billcancelled = this.getBillIdobj.billMasterDtos[0]?.iscancel
        ? this.getBillIdobj.billMasterDtos[0]?.iscancel
        : false;
      this.opdvisitService.getpatientdetails(
        this.getBillIdobj.billMasterDtos[0].fK_RegId
      );

      this.setbillingData(id, type);
    }, (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  setNetAmountonUpdateBill(data) {
    for (let i = 0; i < data.length; i++) {
      var Amount: number = 0;
      data[i].currentAmount =
        Math.round(data[i].Amount + data[i].ServiceCharges) -
        Math.round(data[i].Discount);
    }
  }

  getvisitcolorbyPatientid(id) {
    this.billingservice.getVisitColorById(id).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.VisitColor = data;

    });
    this.colorfun();
  }

  colorfun() {
    return this.VisitColor;
  }

  setbillingData(id, type) {
    this.BillDetailArray = [];
    this.getBillIdobj.billDetailDtos.forEach((element) => {
      if (element.discount > 0) {
        var DiscountPercent = (
          (element.discount * 100) /
          element.amount
        ).toFixed(2);
      } else {
        DiscountPercent = "0";
      }
      const caldiscount = this.BillDetailArray.push({
        PK_BillDetailId: element.pK_BillDetailId,
        FK_BillId: element.fK_BillId,
        serviceName: element.serviceName,
        isRateEditable: element.isRateEditable,
        maxDiscountLimit: element.maxDiscountLimit,
        FK_ServiceId: element.fK_ServiceId,
        Rate: element.rate,
        Amount: element.amount,
        currentAmount: element.netAmt,
        Unit: element.unit,
        NetAmt: element.netAmt,
        ServiceCharges: element.serviceCharges,
        Discount: element.discount,
        DiscountPercent: DiscountPercent,
        FK_PackageId: element.fK_PackageId,
        IsPerformed: element.isPerformed,
        IsDelete: element.isDelete,
        Remarks: element.remarks,
      });
    });
    this.setNetAmountonUpdateBill(this.BillDetailArray);

    var billobj: any = {};
    billobj = this.getBillIdobj.billMasterDtos[0];
    //console.log(billobj);
    if (billobj) {
      this.getBillId = parseInt(billobj?.pK_BillId);
      this.getpatientId = billobj.fK_RegId;

      this.ReciptData.FK_AdjustedBillId = parseInt(billobj?.pK_BillId);

      this.ReciptData.FK_RegId = billobj?.fK_RegId;
    }

    if (billobj.pK_BillId > 0) {
      this.isupdate = true;
    }

    if (this.billingservice.billService.length > 0) {
      let billSName = this.billingservice.billService.filter(
        (item) => item.billSerieseId == billobj.fK_BillSerieseId
      );
      this.billsericeName = billSName[0]?.billSerieseCode;
    }

    (this.opdvisitService.patientdetails.pkRegId = billobj.fK_RegId),
      (this.BillingData.PK_BillId = billobj.pK_BillId),
      (this.BillingData.FK_BillingCompanyId = billobj.fK_BillingCompanyId),
      (this.BillingData.FK_FinYearId = billobj.fK_FinYearId),
      (this.BillingData.FK_BranchId = billobj.fK_BranchId),
      (this.BillingData.FK_BillTypeId = billobj.fK_BillTypeId),
      (this.BillingData.FK_CategoryId = billobj.fK_CategoryId),
      (this.BillingData.FK_BillSerieseId = billobj.fK_BillSerieseId),
      (this.customBilNumbver = billobj.billNoRpt),
      (this.BillingData.BillNo = billobj.billNo),
      (this.BillingData.BillDate = billobj.billDate),
      (this.BillingData.BillTime = billobj.billTime),
      (this.BillingData.FK_RegId = billobj.fK_RegId),
      (this.BillingData.Fk_RateListid = billobj.fk_RateListid),
      //console.log( this.BillingData.FK_RegId);

      (this.BillingData.FK_IPDId = billobj.fK_IPDId),
      (this.BillingData.FK_ReferredById = billobj.fK_ReferredById),
      (this.BillingData.FK_PartyId = billobj.fK_PartyId),
      (this.BillingData.IsAcademic = billobj.isAcademic),
      (this.BillingData.IsMLC = billobj.isMLC);
    if (this.BillingData.FK_ReferredById > 0) {
      const checkdata = this.opdvisitService.personmaster.filter(item => item.pkPersonId == this.BillingData.FK_ReferredById);
      if (checkdata.length == 0 && this.newPersonArray.length == 0) {
        let payload = {
          personName: billobj.referredByDoctorName,
          pkPersonId: this.BillingData.FK_ReferredById
        }
        this.newPersonArray.push(payload);
        this.filteredItems = this.inputControl.valueChanges
          .pipe(
            startWith(''),
            map(cat => this.newPersonArray.slice())
          );
      }
    }
    if (billobj.fK_IPDId != null && billobj.fK_IPDId != 0) {
      this.opdvisitService.matclounwidth = 2;
      this.opdvisitService.checkAdmissionId = true;
    }
    if (
      billobj.ageYear == null ||
      billobj.ageMonth == null ||
      billobj.ageDays == null
    ) {
      //  alert('gg')
      this.BillingData.AgeYear = 0;
      this.BillingData.AgeMonth = 0;
      this.BillingData.AgeDays = 0;
    } else {
      this.BillingData.AgeYear = billobj.ageYear;
      this.BillingData.AgeMonth = billobj.ageMonth;
      this.BillingData.AgeDays = billobj.ageDays;
    }
    if (
      this.BillingData.FK_PartyId != null &&
      this.BillingData.FK_PartyId != undefined
    ) {
      var checkpartyid = this.BillingData.FK_PartyId;
      this.getRateList(this.BillingData.FK_PartyId, 2);
    } else {
      checkpartyid = this.billingservice.billserviceConfig.fK_PartyId;
    }
    if (this.billingservice.partytpa.length > 0) {
      this.partylistSecond = this.billingservice.partytpa.filter(
        (item) => item.pkPartyId != checkpartyid
      );
    }
    (this.BillingData.TotalAmt = billobj.totalAmt),
      (this.BillingData.ServiceChargeAmt = billobj.serviceChargeAmt),
      (this.BillingData.DiscountAmt = billobj.discountAmt),
      (this.BillingData.NetBillAmt = billobj.netBillAmt),
      (this.BillingData.RateType = billobj.rateType),
      (this.BillingData.Remarks = billobj.remarks),
      (this.BillingData.Iscancel = billobj.iscancel),
      (this.BillingData.FK_CreatedById = billobj.fK_CreatedById),
      (this.BillingData.FK_CancelledById = billobj.fK_CancelledById),
      (this.BillingData.CancelledDateTime = billobj.cancelledDateTime),
      (this.BillingData.PrintCount = billobj.printCount),
      (this.BillingData.FreeReason = billobj.freeReason),
      (this.BillingData.IsActive = billobj.isActive),
      (this.BillingData.PK_SynchId = billobj.pK_SynchId),
      (this.BillingData.FK_OrganizerId = billobj.fK_OrganizerId),
      (this.BillingData.FK_DoctorId = billobj.fK_DoctorId),
      (this.docterName = billobj.doctorName),
      this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
    (this.BillingData.Fk_DrDeptID = billobj.fk_DrDeptID),
      (this.BillingData.BillDate = billobj.billDate);
    this.BillingData.BillTime = billobj.billTime;
    this.BillingData.AgeYear = this.opdvisitService.patientdetails.ageYear;
    this.BillingData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
    this.BillingData.AgeDays = this.opdvisitService.patientdetails.ageDays;

    this.ReciptData.FK_DoctorId = this.BillingData.FK_DoctorId;
    this.ReciptData.FK_PartyId = parseInt(billobj.fK_PartyId);
    this.BillingDebitDetail = this.getBillIdobj.billDebitDetailDtos;
    this.dataSource.data = this.BillDetailArray;
    this.paymentDetail(this.BillDetailArray, type);
    this.partyAmount = this.BillingDebitDetail[0].amount;
    this.selftotalrecevered = this.BillingDebitDetail[0].totalRecovered ? this.BillingDebitDetail[0].totalRecovered : 0;
    this.copartyId = this.BillingDebitDetail[1]?.fK_PartyId;
    if (
      this.BillingDebitDetail[1]?.amount != undefined &&
      this.BillingDebitDetail[1]?.amount != null
    ) {
      this.copartyAmount = this.BillingDebitDetail[1]?.amount;
      this.tpatotalreceved = this.BillingDebitDetail[1]?.totalRecovered ? this.BillingDebitDetail[1]?.totalRecovered : 0;
    } else {
      this.copartyAmount = 0;
    }

    //console.log('partypay',   this.partyAmount,this.BillingDebitDetail[0].amount)
    // if(this.BillingDebitDetail[1]){

    // }
    // this.RecieptDepositedAmmount =0;

    //console.log('partypay1', this.partyAmount)
    //console.log('partypay2', this.copartyAmount)
    // console.log('partypay',this.BillingDebitDetail)

    this.addDrEmrService(0);

  }
  tpatotalreceved: number = 0;
  selftotalrecevered: number = 0;
  setbiilingdata() {
    this.BillingData = {};
    this.getbillingReson = "";
    this.BillingData.FK_RegId = "";
    this.tpatotalreceved = 0;
    this.selftotalrecevered = 0;
    this.totalpay = 0;
    this.servicecharge = 0;
    this.lessDiscount = 0;
    this.netbillamount = 0;
    this.currentpayable = 0;
    this.RecieptDepositedAmmount = 0;
    this.dataSource.data = [];
    this.BillDetailArray = [];
    this.BillingRemarkArray = [];
    this.BillDetailArray = [];
    this.copartyId = 0;
    // this.BillingData.FK_DoctorId=this.opdvisitService.apptdetail.fkConsultantId;
    //    this.GetSreviceArrayOne =[];
    //    this.GetSreviceArraytwo =[];
    //    this.opdvisitService.doctors =null;
    //    this.BillingData.FK_DoctorId  = null;
    //    this.opdvisitService.BillingDoctorId = null;
    //    this.billingservice.billserviceConfig =null;
    //    this.RefundAmount =null;
    //    this.screenPermissionobj=null;

    //  this.RecieptDepositedAmmount=0
    //  this.reciptBlanceAmmount = 0;
    //  this.customBilNumbver = '0';
    //  this.opdvisitService.url=null;
    //  this.patientLastServiceobj =null;
    //  this.VisitDiffernce = null;

    const newdate = this.authService.getServerDate;

    this.partylistSecond = [];

    this.BillingData.PK_BillId = 0;
    this.BillingData.BillTime = this.cuurentTime;
    this.BillingData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;
    this.BillingData.AgeYear = this.opdvisitService.patientdetails.ageYear;
    this.BillingData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
    this.BillingData.AgeDays = this.opdvisitService.patientdetails.ageDays;
    var checkempty = this.isEmptyObject(this.opdvisitService.apptdetail);

    if (checkempty != true) {
      if (this.billingservice.partytpa.length > 0) {
        this.partylistSecond = this.billingservice.partytpa.filter(
          (item) =>
            item.pkPartyId != this.billingservice.billserviceConfig?.fK_PartyId
        );
      }
      if (this.opdvisitService.apptdetail.fkRefById != undefined) {
        this.BillingData.FK_ReferredById =
          this.opdvisitService.apptdetail.fkRefById;
      } else if (
        this.opdvisitService.patientdetails.fkReferredbyId != null &&
        this.opdvisitService.patientdetails.fkReferredbyId != undefined
      ) {
        this.BillingData.FK_ReferredById =
          this.opdvisitService.patientdetails.fkReferredbyId;
      } else {
        this.BillingData.FK_ReferredById =
          this.billingservice.billserviceConfig?.fK_ReferredById;
        this.inputControl.patchValue(this.BillingData.FK_ReferredById);
      }
      if (this.opdvisitService.apptdetail.fkConsultantId != undefined) {
        this.BillingData.FK_DoctorId =
          this.opdvisitService.apptdetail.fkConsultantId;
      }
      if (this.opdvisitService.apptdetail.fK_PartyId != undefined) {
        this.BillingData.FK_PartyId =
          this.opdvisitService.apptdetail.fK_PartyId;
      } else {
        this.BillingData.FK_PartyId =
          this.billingservice.billserviceConfig?.fK_PartyId;
      }
      this.BillingData.BillDate = newdate;
      this.getbills(newdate, newdate);
    } else {
      this.BillingData.FK_ReferredById =
        this.billingservice.billserviceConfig?.fK_ReferredById;
      this.BillingData.FK_PartyId =
        this.billingservice.billserviceConfig?.fK_PartyId;
      this.BillingData.BillDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      var a = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      var b = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.getbills(a, b);
    }

    this.BillingData.FK_BillTypeId =
      this.billingservice.billserviceConfig?.fK_BillTypeId;
    this.BillingData.FK_CategoryId =
      this.billingservice.billserviceConfig?.fK_CategoryId;
    this.BillingData.FK_BillSerieseId =
      this.billingservice.billserviceConfig?.fK_BillSerieseId;
    this.BillingData.RateType =
      this.billingservice.billserviceConfig?.fK_RatelistId;
    this.BillingData.FreeReason = null;
    //  this.opdvisitService.patientdetails.pkRegId =null;

    this.BillingData.BillNo = 0;
    this.BillingData.FK_IPDId = 0;
    this.BillingData.IsAcademic = 0;
    this.BillingData.IsMLC = 0;
    this.BillingData.Iscancel = 0;
    this.BillingData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.BillingData.FK_CancelledById = null;
    this.BillingData.CancelledDateTime = null;
    this.BillingData.PrintCount = 0;
    this.BillingData.IsActive = 1;
    this.BillingData.PK_SynchId = null;
    this.BillingData.FK_OrganizerId = 0;
    this.BillingData.FK_BillingCompanyId =
      this.authService.selectedbillingcompany;
    this.BillingData.FK_FinYearId = this.authService.Loggeduser.finyear;
    this.BillingData.FK_BranchId = this.authService.Loggeduser.branchid;

    // console.log(this.BillingData.PK_BillId)
    //  this.setfreshReciptdata();

  }

  onSubmitupdateBill() {

    if (
      (this.BillingData.FreeReason === null ||
        this.BillingData.FreeReason == "" ||
        this.BillingData.FreeReason === undefined) &&
      this.is_editalbe == true
    ) {
      this.dashboardService.openSnackBar("Please Select Discount Reason", "OK");
      return;
    }
    //  if (this.screenPermissionobj?.modifyPermission === true) {
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.BillingData.FK_DoctorId = this.BillingData.FK_DoctorId;
    this.updatebill = {
      PK_TranId: this.BillingDebitDetail[0].pK_TranId,
      FK_BillId: this.getBillIdobj.billMasterDtos[0].pK_BillId,
      OLDTotalAmt: this.getBillIdobj.billMasterDtos[0].totalAmt,
      OLDServiceChargeAmt:
        this.getBillIdobj.billMasterDtos[0].serviceChargeAmt,
      OLDDiscountAmt: this.getBillIdobj.billMasterDtos[0].discountAmt,
      OLDNetBillAmt: this.getBillIdobj.billMasterDtos[0].netBillAmt,
      OLD_FK_DoctorId: this.getBillIdobj.billMasterDtos[0].fK_DoctorId,
      OLD_PartyId: this.getBillIdobj.billMasterDtos[0].fK_PartyId,
      PK_SynchId: this.getBillIdobj.billMasterDtos[0].pK_SynchId,
      FK_ModifiedbyId: this.authService.Loggeduser.userid,
      ModifiedDate: this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd"),
      ModifiedTime: this.cuurentTime,
      NEWTotalAmt: parseInt(this.netbillamount),
      NEWServiceChargeAmt: parseInt(this.servicecharge),
      NEWDiscountAmt: parseInt(this.lessDiscount),
      NEWNetBillAmt: parseInt(this.netbillamount),
      ModifyReason: this.getbillingReson,
      New_FK_DoctorId: this.BillingData.FK_DoctorId,
      Fk_DrDeptID: this.BillingData.Fk_DrDeptID,
      New_PartyId: parseInt(this.BillingData.FK_PartyId),
      IsActive: 1,
    };
    if (this.billApprovalobject.pK_TranID > 0) {
      this.updatebill.PK_TranID_Approval = this.billApprovalobject.pK_TranID;
      this.updatebill.requestUsed = 1;
    }

    //console.log(this.updatebill);

    if (
      this.BillingData.FK_IPDId != null &&
      this.BillingData.FK_IPDId != undefined &&
      this.BillingData.FK_IPDId > 0
    ) {
      this.BillingData.FK_IPDId = this.BillingData.FK_IPDId;
    }
    // this.BillingData.AgeYear = this.opdvisitService.patientdetails.ageYear;
    // this.BillingData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
    // this.BillingData.AgeDays = this.opdvisitService.patientdetails.ageDays;
    this.BillingData.TotalAmt = parseInt(this.totalpay);
    this.BillingData.ServiceChargeAmt = parseInt(this.servicecharge);
    this.BillingData.DiscountAmt = parseInt(this.lessDiscount);
    this.BillingData.NetBillAmt = parseInt(this.netbillamount);
    this.BillingData.IsActive = 1;
    this.BillingData.Fk_SpecialityIdModule = this.authService.Loggeduser.specialityId;
    this.BillingData.FK_ReferredById = this.BillingData.FK_ReferredById;
    this.BillingData.FK_PartyId = parseInt(this.BillingData.FK_PartyId);
    if (
      this.BillingData.FK_BillTypeId != null ||
      this.BillingData.FK_BillTypeId != ""
    ) {
      this.BillingData.FK_BillTypeId = parseInt(
        this.BillingData.FK_BillTypeId
      );
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Bill Entry Type",
        "OK"
      );
    }

    this.BillingData.FK_CategoryId = parseInt(this.BillingData.FK_CategoryId);
    this.BillingData.FK_BillSerieseId = parseInt(
      this.BillingData.FK_BillSerieseId
    );
    this.BillingData.RateType = parseInt(this.BillingData.RateType);
    this.ReciptData.FK_DoctorId = this.BillingData.FK_DoctorId;
    this.ReciptData.FK_PartyId = parseInt(this.BillingData.FK_PartyId);

    var NewBillDebitDetail: any = [];

    var debitobj = {
      PK_TranId: this.BillingDebitDetail[0].pK_TranId,
      FK_Billd: this.BillingDebitDetail[0].fK_Billd,
      FK_PartyId: parseInt(this.BillingData.FK_PartyId),
      Amount: parseFloat(this.partyAmount),
      IsDelete: this.BillingData.FK_PartyId == 0 ? 1 : 0,
    };
    NewBillDebitDetail.push(debitobj);
    //console.log(this.copartyId);

    if (this.BillingDebitDetail[1]) {
      this.BillingDebitDetail[1].amount = parseFloat(this.copartyAmount);
      var debitobj1 = {
        PK_TranId: this.BillingDebitDetail[1].pK_TranId,
        FK_Billd: this.BillingDebitDetail[1].fK_Billd,
        FK_PartyId:
          this.copartyId == 0
            ? this.BillingDebitDetail[1].fK_PartyId
            : this.copartyId,
        Amount:
          parseFloat(this.copartyAmount) > 0
            ? parseFloat(this.copartyAmount)
            : 0,
        IsDelete: this.copartyId == 0 ? 1 : 0,
      };
      NewBillDebitDetail.push(debitobj1);
    } else if (!this.BillingDebitDetail[1] && this.copartyAmount > 0) {
      var debitobj2 = {
        PK_TranId: 0,
        FK_Billd: this.BillingDebitDetail[0].fK_Billd,
        FK_PartyId: this.copartyId,
        Amount:
          parseFloat(this.copartyAmount) > 0
            ? parseFloat(this.copartyAmount)
            : 0,
        IsDelete: this.copartyId == 0 ? 1 : 0,
      };
      NewBillDebitDetail.push(debitobj2);
    }

    var NewBillDetail = [];
    var BillDetailobj = {};
    if (this.BillDetailArray.length > 0) {
      for (let i = 0; i < this.BillDetailArray.length; i++) {
        const element = this.BillDetailArray[i];
        BillDetailobj = {
          PK_BillDetailId: element.PK_BillDetailId,
          FK_BillId: this.getBillIdobj.billMasterDtos[0].pK_BillId,
          FK_ServiceId: element.FK_ServiceId,
          Rate: parseFloat(element.Rate),
          Unit: parseFloat(element.Unit),
          Amount: parseFloat(element.Amount),
          Discount: parseFloat(element.Discount),
          ServiceCharges: parseFloat(element.ServiceCharges),
          NetAmt: parseFloat(element.currentAmount),
          FK_PackageId:
            element.FK_PackageId == 0 ? null : element.FK_PackageId,
          IsPerformed: element.IsPerformed,
          Remarks: element.Remarks,
          IsDelete: element.IsDelete,
        };
        NewBillDetail.push(BillDetailobj);
      }
    }

    if (this.RemoveServiceArray.length > 0) {
      var BillDetailobj1 = {};
      for (let i = 0; i < this.RemoveServiceArray.length; i++) {
        const element = this.RemoveServiceArray[i];
        if (element.PK_BillDetailId > 0) {
          BillDetailobj1 = {
            PK_BillDetailId: element.PK_BillDetailId,
            FK_BillId: this.getBillIdobj.billMasterDtos[0].pK_BillId,
            FK_ServiceId: element.FK_ServiceId,
            Rate: parseFloat(element.Rate),
            Unit: parseFloat(element.Unit),
            Amount: parseFloat(element.Amount),
            Discount: parseFloat(element.Discount),
            ServiceCharges: parseFloat(element.ServiceCharges),
            NetAmt: parseFloat(element.NetAmt),
            FK_PackageId:
              element.FK_PackageId == 0 ? null : element.FK_PackageId,
            IsPerformed: element.IsPerformed,
            Remarks: element.Remarks,
            IsDelete: 1,
          };
          NewBillDetail.push(BillDetailobj1);
        }

      }
    }

    var billFinalData = {
      BillMaster: this.BillingData,
      BillDetail: NewBillDetail,
      BillDebitDetail: NewBillDebitDetail,
      OPDVisit: {}
    };

    const checkdat = NewBillDetail.filter(item => item.IsDelete == 0);
    ////console.log('updateobjold', this.BillingData)
    //console.log('finall',billFinalData)
    ////console.log('billupdateobjnew',this.updatebill)
    if (checkdat.length === 0) {
      this.dashboardService.openSnackBar("Please Select Service", "OK");
    } else {
      if (this.copartyId === 0 && this.copartyAmount > 1) {
        this.dashboardService.openSnackBar("Please Select Co-party", "OK");
      } else {
        //console.log('update data',billFinalData, 'new obj',this.updatebill,'this.RemoveServiceArray',this.RemoveServiceArray)

        this.billingservice
          .addbillingdata(billFinalData).pipe(takeUntil(this.destroy$))
          .subscribe((data) => {
            this.billingservice
              .addbillingmodificatins(this.updatebill).pipe(takeUntil(this.destroy$))
              .subscribe((res) => {
                if (data) {
                  this.getbillingReson = "";
                  this.getBillId = data.id.id;
                  this.ReciptData.FK_AdjustedBillId = parseInt(
                    this.getBillId
                  );
                  this.getlastBill(data.id.id);
                  //console.log(res);
                  this.isupdate = true;
                  this.dashboardService.openSnackBar(
                    "Your Bill Updated successfully",
                    "OK"
                  );
                }
              }, err => {
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                }
                else if (err.error.statusCode == 422) {
                  this.dashboardService.openSnackBar(err.error.message, "OK");
                }
                else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              });
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
      }
    }
    // } else {
    //   this.dashboardService.openSnackBar(
    //     "you don't have permission to access this resource",
    //     "OK"
    //   );
    // }
  }

  billupdateresons() {
    if (this.getbillingReson != "" && this.getbillingReson != null) {
      this.isupdate = false;
      this.getPartTpa();
      document.getElementById("BillingResonModel").style.display = "none";
    } else {
      this.dashboardService.openSnackBar("Please enter reason", "OK");
    }

    // if (this.getbillingReson) {
    //   this.isupdate = false;
    //   this.getPartTpa();
    // }
  }

  // submitRecipt() {
  //   this.ReciptData.PaymentTime = this.cuurentTime;
  //   this.ReciptData.AmountINR = this.ReciptData.CurrencyAmount;
  //   this.RecieptDepositedAmmount = this.ReciptData.CurrencyAmount;
  //   this.ReciptData.AgeYear = this.opdvisitService.patientdetails.ageYear;
  //   this.ReciptData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
  //   this.ReciptData.AgeDays = this.opdvisitService.patientdetails.ageDays;
  //   this.ReciptData.FK_AdjustedBillId = parseInt(
  //     this.ReciptData.FK_AdjustedBillId
  //   );
  //   if (
  //     this.ReciptData.FK_AdjustedBillId === null ||
  //     this.ReciptData.FK_AdjustedBillId === " " ||
  //     this.ReciptData.FK_AdjustedBillId === undefined ||
  //     this.ReciptData.FK_AdjustedBillId === 0
  //   ) {
  //     this.dashboardService.openSnackBar("Please Save Bill", "OK");
  //   } else {
  //     this.billingservice.addbilingrecipts(this.ReciptData).pipe(takeUntil(this.destroy$)).subscribe(
  //       (data) => this.recipt_Succsess(data),
  //       (err) => this.recipt_failed(err)
  //     );
  //   }
  // }

  // recipt_Succsess(data) {

  //   if (
  //     parseFloat(this.RecieptDepositedAmmount) < parseFloat(this.netbillamount)
  //   ) {
  //     this.currentpayable = this.netbillamount - this.RecieptDepositedAmmount;

  //   } else {
  //     this.currentpayable = 0;
  //   }
  //   if (
  //     parseFloat(this.RecieptDepositedAmmount) > parseFloat(this.netbillamount)
  //   ) {
  //     this.reciptBlanceAmmount =
  //       parseFloat(this.RecieptDepositedAmmount) -
  //       parseFloat(this.netbillamount);
  //   } else {
  //     this.reciptBlanceAmmount = 0;
  //   }
  //   this.get_recipt(
  //     this.opdvisitService.patientdetails.pkRegId,
  //     this.BillingData.PK_BillId,
  //     0
  //   );
  //   this.dashboardService.openSnackBar("Receipt Created Successfully", "OK");
  // }
  // recipt_failed(err) {
  //   if (err.status == 403) {
  //     this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  //   }
  //   else if (err.error.statusCode == 422) {
  //     this.dashboardService.openSnackBar(err.error.message, "OK");
  //   }
  //   else {
  //     this.dashboardService.openSnackBar("API Failed", "OK");
  //   }
  // }

  get_recipt(p, b, c) {

    this.billingservice.GetBalanceAmountByRegId(p).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.RecieptDepositedAmmount = data.balanceAmount;
      this.currentpayable = this.netbillamount;
      this.reciptBlanceAmmount = this.currentpayable;
    });
    // this.billingservice.getbillingrecipt(p, b, c).pipe(takeUntil(this.destroy$)).subscribe((data) => {
    //   this.ReciptArray = data.filter(item => item.iscancelled != true && item.isAdjusted !=true);
    //   var Amonut: number = 0;
    //   var refund: number = 0;
    //   var brefund:number =0;
    //   this.ReciptArray?.forEach((element) => {
    //     Amonut = Amonut + element.netAmt;
    //     refund = refund + element.refunded;
    //     brefund =brefund + element.billRefund;
    //   });

    //   this.RecieptDepositedAmmount = Amonut - (refund + brefund);
    //   this.currentpayable = this.netbillamount;
    //   this.reciptBlanceAmmount = this.currentpayable;
    // });
  }

  getpatientlastvisit(id, wtype) {

    this.patientLastServiceobj = {};
    this.BillDetailArray = [];
    this.dataSource.data = [];
    this.VisitDiffernce = -1;
    this.getvisitcolorbyPatientid(id);
    //  this.getConfiglist();
    if (this.LastVisitAllow == "N") {
      this.opdvisitService.getlastvisit(id).pipe(takeUntil(this.destroy$)).subscribe(
        (data) => this.lastvisit_succsess(data, wtype),
        (err) => this.lastvisit_failed(err)
      );
    }
  }

  lastvisit_succsess(data, wtype) {

    if (data.isEmergency != null) {
      this.opdvisitService.opdvisitmodel.isEmergency = data.isEmergency;
    }

    if (data.fK_DoctorId != null && wtype == 1) {
      this.BillingData.FK_DoctorId = data.fK_DoctorId;
      this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
    }
    if (data.fK_CategoryId != null) {
      this.BillingData.FK_CategoryId = data.fK_CategoryId;
    }
    if (data.fK_PartyId != null) {
      this.BillingData.FK_PartyId = data.fK_PartyId;
      this.getRateList(this.BillingData.FK_PartyId, 2);
    }

    if (
      this.billingservice.billserviceConfig.consultationConfigType == 1 &&
      data.fK_RegId != null
    ) {
      this.getdefaultservicebydoctoridcategoryid(data.fK_RegId, 0, 0, 0);

    } else if (this.billingservice.billserviceConfig.consultationConfigType == 2 &&
      data.fK_RegId != null && data.fK_DoctorId != null) {
      this.getdefaultservicebydoctoridcategoryid(data.fK_RegId, data.fK_DoctorId, 0, 0);
    } else if (this.billingservice.billserviceConfig.consultationConfigType == 3 &&
      data.fK_RegId != null && data.fK_CategoryId != null) {
      this.getdefaultservicebydoctoridcategoryid(data.fK_RegId, 0, data.fK_CategoryId, 0);
    }
    else if (this.billingservice.billserviceConfig.consultationConfigType >= 1 &&
      this.billingservice.billserviceConfig.fK_CategoryId != null &&
      this.billingservice.billserviceConfig.fK_RatelistId != null && data.fK_RegId == null) {
      this.CallDefaultServies(
        this.billingservice.billserviceConfig.fK_FreshServiceId,
        this.billingservice.billserviceConfig.fK_RatelistId,
        this.BillingData.RateType,
        'F'
      );
    }
    // this.setdefaultservicebyconfigration();
    // setTimeout(function () {
    //   document.getElementById("LastVisitModel").style.display = "none";
    // }, 1500);
  }
  getdefaultservicebydoctoridcategoryid(pateindid, docid, categoryid, ctype) {
    this.billingservice.getlastvisitwith(pateindid, docid, categoryid).subscribe((data1: any) => {
      if (data1.length > 0) {
        if (data1[0].billDate != null && data1[0].billDate != undefined) {
          const newdate = this.authService.getServerDate;
          var date1 = moment(newdate);
          var date2 = moment(data1[0].billDate);
          this.lastVistdate = date2;
          const diffDays = Math.abs(date1.diff(date2, "days"));
          this.VisitDiffernce = diffDays;
          var Vadte = moment(this.lastVistdate);
          // document.getElementById("LastVisitModel").style.display = "block";
          //with discuss in meeting remove popup NET-1457
        }
        if (
          this.billingservice.billserviceConfig.limitDays < parseInt(this.VisitDiffernce)) {
          this.CallDefaultServies(
            this.billingservice.billserviceConfig.fK_ReviewServiceId,
            this.billingservice.ratelist.rateListId,
            this.BillingData.RateType,
            'R'
          );
        } else {
          this.CallDefaultServies(
            this.billingservice.billserviceConfig.fK_FollowupServiceId,
            this.billingservice.ratelist.rateListId,
            this.BillingData.RateType,
            'FUP'
          );
        }
      } else if (data1.length == 0 && ctype == 0 && this.billingservice.billserviceConfig.fK_ReviewServiceId > 0) {
        this.CallDefaultServies(
          this.billingservice.billserviceConfig.fK_ReviewServiceId,
          this.billingservice.ratelist.rateListId,
          this.BillingData.RateType,
          'R'
        );
      } else if (data1.length == 0 && (ctype == 1 || ctype == 2) && this.billingservice.billserviceConfig.fK_FreshServiceId > 0) {
        this.CallDefaultServies(
          this.billingservice.billserviceConfig.fK_FreshServiceId,
          this.billingservice.ratelist.rateListId,
          this.BillingData.RateType,
          'F'
        );
      }
    });
  }

  ChangeHeader(event: any) {
    if (event == true) {
      this.PageHeader.propertyValue = "N";
      this.headerflag = false;
    } else {
      this.PageHeader.propertyValue = "Y";
      this.headerflag = true;
    }
  }
  CallDefaultServies(ServiceId: any, RateListId: any, RateTypeId: any, Stype: any) {
    this.billingservice.servicelist = [];
    this.GetSreviceArrayOne = [];
    this.GetSreviceArraytwo = [];
    this.GetSreviceArraythree = [];
    this.billingservice
      .get_service_list(ServiceId, RateListId, RateTypeId).pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => this.successDefaultService(data, Stype),
        (err) => this.lastvisit_failed(err)
      );
  }

  successDefaultService(data, Stype) {
    this.billingservice.servicelist = data;

    if (this.billingservice.servicelist.length > 0) {
      for (let i = 0; i < this.billingservice.servicelist.length; i++) {
        if (Stype == 'F' && Stype != 'R' && Stype != 'FUP') {
          if (
            this.billingservice.billserviceConfig.fK_FreshServiceId ===
            this.billingservice.servicelist[i].serviceId
          ) {

            this.GetSreviceArraythree.push(this.billingservice.servicelist[i]);
            this.GetSreviceArraythree = this.GetSreviceArraythree.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.FK_ServiceId === o.FK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          }

        } else if (Stype != 'F' && Stype == 'R' && Stype != 'FUP') {
          if (
            this.billingservice.billserviceConfig.fK_ReviewServiceId ===
            this.billingservice.servicelist[i].serviceId
          ) {
            this.GetSreviceArrayOne.push(this.billingservice.servicelist[i]);
            this.GetSreviceArrayOne = this.GetSreviceArrayOne.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.FK_ServiceId === o.FK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          }

        } else if (Stype != 'F' && Stype != 'R' && Stype == 'FUP') {
          if (
            this.billingservice.billserviceConfig.fK_FollowupServiceId ===
            this.billingservice.servicelist[i].serviceId
          ) {
            this.GetSreviceArraytwo?.push(this.billingservice.servicelist[i]);
            this.GetSreviceArraytwo = this.GetSreviceArraytwo.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.FK_ServiceId === o.FK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          }

        }

      }
      this.setdefaultservicebyconfigration(Stype);
      localStorage.setItem(
        "ServiceOne",
        JSON.stringify(this.GetSreviceArraythree)
      );
    }

  }
  lastvisit_failed(err) {
    //console.log('rtrt')
    var setService = JSON.parse(localStorage.getItem("ServiceOne"));
    //console.log('tttttt',setService);
    setService.forEach((element) => {
      //console.log('db source' ,  this.GetSreviceArrayOne)
      this.BillDetailArray.push({
        PK_BillDetailId: 0,
        FK_BillId: 0,
        serviceName: element.serviceName,
        maxDiscountLimit: element.maxDiscountLimit,
        FK_ServiceId: element.serviceId,
        isRateEditable: element.isRateEditable,
        Rate: element.rate,
        Amount: element.rate,
        Unit: 1,
        NetAmt: element.rate,
        ServiceCharges: this.returnSericeChage(
          element.rate,
          element.serviceCharge
        ),
        scPer: element.serviceCharge ? element.serviceCharge : 0,
        DiscountPercent: element.discount,
        Discount: 0,
        FK_PackageId: 0,
        IsPerformed: 0,
        IsDelete: 0,
        Remarks: "",
        currentAmount: element.rate,
      });
    });

    this.BillDetailArray.forEach((elem, index) => {
      if (elem.DiscountPercent > 0) {
        this.ondiscountPercentage(elem.DiscountPercent, index, 0);
      }
      if (elem.ServiceCharges > 0) {
        this.onserviceChnage(elem.ServiceCharges, index);
      }
      //  else{
      //   elem.DiscountPercent =0;
      //   elem.ServiceCharges =0;

      //  }
    });
    this.dataSource.data = this.BillDetailArray;
    this.paymentDetail(this.BillDetailArray);
    //console.log('db source' ,this.dataSource.data)
    //  }

    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  closedLastVisitModel() {
    document.getElementById("LastVisitModel").style.display = "none";
  }
  clickoutside() {
    document.getElementById("LastVisitModel").style.display = "none";
  }

  setdefaultservicebyconfigration(Stype: any) {
    //  this.getConfiglist();
    if (Stype != 'F' && Stype == 'R' && Stype != 'FUP'
    ) {
      this.GetSreviceArrayOne.forEach((element) => {
        this.BillDetailArray.push({
          PK_BillDetailId: 0,
          FK_BillId: 0,
          serviceName: element.serviceName,
          maxDiscountLimit: element.maxDiscountLimit,
          FK_ServiceId: element.serviceId,
          isRateEditable: element.isRateEditable,
          Rate: element.rate,
          Amount: element.rate,
          Unit: 1,
          NetAmt: element.rate,
          ServiceCharges: this.returnSericeChage(
            element.rate,
            element.serviceCharge
          ),
          scPer: element.serviceCharge ? element.serviceCharge : 0,
          DiscountPercent: element.discount,
          Discount: 0,
          FK_PackageId: 0,
          IsPerformed: 0,
          IsDelete: 0,
          Remarks: "",
          currentAmount: element.rate,
        });
      });

      this.dataSource.data = this.BillDetailArray;
      this.BillDetailArray.forEach((elem, index) => {
        if (elem.DiscountPercent > 0) {
          this.ondiscountPercentage(elem.DiscountPercent, index, 0);
        }
        if (elem.ServiceCharges > 0) {
          this.onserviceChnage(elem.ServiceCharges, index);
        }
        //  else{
        //   elem.DiscountPercent =0;
        //   elem.ServiceCharges =0;

        //  }
      });
      this.paymentDetail(this.BillDetailArray);
      //console.log('db source1' ,this.dataSource.data)
    } else if (
      Stype != 'F' && Stype != 'R' && Stype == 'FUP'
    ) {
      //console.log('db source2' ,  this.GetSreviceArraytwo)
      this.GetSreviceArraytwo.forEach((element) => {
        this.BillDetailArray.push({
          PK_BillDetailId: 0,
          FK_BillId: 0,
          serviceName: element.serviceName,
          maxDiscountLimit: element.maxDiscountLimit,
          FK_ServiceId: element.serviceId,
          isRateEditable: element.isRateEditable,
          Rate: element.rate,
          Amount: element.rate,
          Unit: 1,
          NetAmt: element.rate,
          ServiceCharges: this.returnSericeChage(
            element.rate,
            element.serviceCharge
          ),
          scPer: element.serviceCharge ? element.serviceCharge : 0,
          DiscountPercent: element.discount,
          Discount: 0,
          FK_PackageId: 0,
          IsPerformed: 0,
          IsDelete: 0,
          Remarks: "",
          currentAmount: element.rate,
        });
      });

      this.dataSource.data = this.BillDetailArray;
      this.BillDetailArray.forEach((elem, index) => {
        if (elem.DiscountPercent > 0) {
          this.ondiscountPercentage(elem.DiscountPercent, index, 0);
        }
        if (elem.ServiceCharges > 0) {
          this.onserviceChnage(elem.ServiceCharges, index);
        }
        //  else{
        //   elem.DiscountPercent =0;
        //   elem.ServiceCharges =0;

        //  }
      });
      this.paymentDetail(this.BillDetailArray);
    } else if (Stype == 'F' && Stype != 'R' && Stype != 'FUP') {
      this.GetSreviceArraythree.forEach((element) => {
        this.BillDetailArray.push({
          PK_BillDetailId: 0,
          FK_BillId: 0,
          serviceName: element.serviceName,
          maxDiscountLimit: element.maxDiscountLimit,
          FK_ServiceId: element.serviceId,
          isRateEditable: element.isRateEditable,
          Rate: element.rate,
          Amount: element.rate,
          Unit: 1,
          NetAmt: element.rate,
          ServiceCharges: this.returnSericeChage(
            element.rate,
            element.serviceCharge
          ),
          scPer: element.serviceCharge ? element.serviceCharge : 0,
          DiscountPercent: element.discount,
          Discount: 0,
          FK_PackageId: 0,
          IsPerformed: 0,
          IsDelete: 0,
          Remarks: "",
          currentAmount: element.rate,
        });
      });
      this.dataSource.data = this.BillDetailArray;
      this.BillDetailArray.forEach((elem, index) => {
        if (elem.DiscountPercent > 0) {
          this.ondiscountPercentage(elem.DiscountPercent, index, 0);
        }
        if (elem.ServiceCharges > 0) {
          this.onserviceChnage(elem.ServiceCharges, index);
        }
      });
      this.paymentDetail(this.BillDetailArray);
    }
  }

  getpatiendId(id: number, wlaktype: number) {
    if (id != null && id != undefined && id > 0) {
      if (wlaktype == 1) {
        this.childevent = false;
      }
      this.showspinner = true;
      this.opdvisitService.getpatientdetailsforReciept(id).pipe(takeUntil(this.destroy$)).subscribe(
        (data) => this.patient_succsess(data, wlaktype),
        (err) => this.patient_failed(err)
      );
    }
  }

  patient_succsess(data, w_type) {
    setTimeout(() => this.UhidButton.nativeElement.focus(), 0);
    this.showspinner = false;
    console.log('patient_success: Patient loaded with UHID:', data.pkRegId);
    if (data.pkRegId > 0) {
      this.opdvisitService.successpatient_details(data);
      this.is_editalbe = false;
      if (data.fkIPDID > 0) {
        this.opdvisitService.matclounwidth = 2;
        this.opdvisitService.checkAdmissionId = true;
      } else {
        this.opdvisitService.checkAdmissionId = false;
      }
      // console.log(data);
      if (data.fkReferredbyIdLatest > 0) {
        this.BillingData.FK_ReferredById = data.fkReferredbyIdLatest;

      } else if (data.fkReferredbyId > 0) {
        this.BillingData.FK_ReferredById = data.fkReferredbyId;
      } else {
        this.BillingData.FK_ReferredById = this.billingservice.billserviceConfig?.fK_ReferredById;
      }
      if (data.fkPartyId > 0) {
        this.BillingData.FK_PartyId = data.fkPartyId;
        console.log('patient_success: Party ID from patient data:', data.fkPartyId);
        this.getRateList(this.BillingData.FK_PartyId, 2, null);
      } else {
        this.BillingData.FK_PartyId =
          this.billingservice.billserviceConfig?.fK_PartyId;
        if (!this.BillingData.FK_PartyId) {
          console.log('patient_success: No party ID found, calling getRateList with config');
          this.getRateList(this.BillingData.FK_PartyId, 2, null);
        }
      }
      if (w_type == 1) {
        if (data.fK_DoctorId > 0) {
          this.BillingData.FK_DoctorId = data.fK_DoctorId;
          var doctername = this.doctersSpecData.filter(
            (item) => item.userId == this.BillingData.FK_DoctorId
          );
          this.docterName = doctername[0]?.userName;
          this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
        } else {
          this.BillingData.FK_DoctorId =
            this.billingservice.billserviceConfig?.fK_DoctorId;
        }
      } else if (w_type == 0) {
        this.BillingData.FK_DoctorId = Number(
          this.opdvisitService.apptdetail.fkConsultantId
        );
        // var doctername = this.doctersSpecData.filter(
        //   (item) => item.userId == this.BillingData.FK_DoctorId
        // );
        this.docterName = this.opdvisitService.appoitnmentusername;
        this.getSpeciltiyDatabyuserid(this.BillingData.FK_DoctorId);
      } else {
        this.BillingData.FK_DoctorId =
          this.billingservice.billserviceConfig?.fK_DoctorId;
      }

      this.opdvisitService.patientdetails.pkRegId = data.pkRegId;
      if (
        this.opdvisitService.PatientisExpire === true ||
        data.isExpired == true
      ) {
        this.dashboardService.openSnackBar("This Patient is Expired  ", "OK");
        return;
      }
      // this.getvisitcolorbyPatientid(this.opdvisitService.patientdetails.pkRegId);
      // this.opdvisitService.patiendFullNameForReciept = data.firstName +' ' +data.lastName;
      this.BillingData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;
      this.getpatientlastvisit(
        this.opdvisitService.patientdetails.pkRegId,
        w_type
      );
      this.addDrEmrService(0);
      this.get_recipt(this.BillingData.FK_RegId, 0, 0);

      // Apply automation workflow: department, doctor, category, services
      if (this.automationWorkflow) {
        const applyAutomationFields = () => {
          const wf = this.automationWorkflow!;

          // Bill series + entry type must match category (OPD / IPD / Lab)
          this._applyAutomationBillSeriesFromCategory(wf.category);

          if (this._isIpdCategory(wf.category)) {
            const ipdId = this.opdvisitService.patientdetails?.fkIPDID;
            if (ipdId > 0) {
              this.BillingData.FK_IPDId = ipdId;
            }
          }

          if (this.BillingData.FK_ReferredById != null) {
            this.BillingData.FK_ReferredById = Number(this.BillingData.FK_ReferredById);
          }

          if (!wf.skipDoctor) {
            let matched: any = null;
            if (wf.doctorId) {
              matched = (this.doctersSpecData || []).find(
                (d: any) => d.userId == wf.doctorId
              );
            }
            if (!matched && wf.doctor) {
              const doctorName = wf.doctor.toLowerCase().replace(/^dr\.?\s*/i, '');
              matched = (this.doctersSpecData || []).find(
                (d: any) => {
                  const un = (d.userName || '').toLowerCase().replace(/^dr\.?\s*/i, '');
                  return un.includes(doctorName) || doctorName.includes(un);
                }
              );
            }
            if (matched) {
              this.BillingData.FK_DoctorId = matched.userId;
              this.docterName = matched.userName;
              this.getSpeciltiyDatabyuserid(matched.userId);
              console.log('patient_success: Automation doctor applied:', matched.userName);
            } else {
              console.log('patient_success: Automation doctor not found:', wf.doctor);
            }
          }

          if (wf.category) {
            const catKeyword = wf.category.toLowerCase().trim();
            const matchedCategory = this.dashboardService.categories.find((item: any) => {
              const catName = (item.categoryName || '').toLowerCase().trim();
              if (catName === catKeyword) return true;
              if (catName.includes(catKeyword) || catKeyword.includes(catName)) return true;
              const catFirstWord = catName.split(' ')[0];
              const keyFirstWord = catKeyword.split(' ')[0];
              return catFirstWord.length >= 3 && catFirstWord === keyFirstWord;
            });
            if (matchedCategory) {
              this.onchnagecategory(matchedCategory.pkCategoryId);
              console.log('patient_success: Category matched:', matchedCategory.categoryName);
            }
          }

          if (wf.remarks) {
            this.BillingData.Remarks = wf.remarks;
          }

          let automationSvcs: string[] = [];
          if (wf.services?.length) {
            automationSvcs = wf.services;
          } else if (wf.service) {
            automationSvcs = [wf.service];
          }

          if (automationSvcs.length > 0) {
            const autoSubmitFlag = wf.autoSubmit ?? false;
            const sid = wf.serviceId || null;
            this._runAutomationServiceSelection(automationSvcs, autoSubmitFlag, sid);
          }
        };

        if (this.automationWorkflow.departmentId) {
          this.BillingData.Fk_DrDeptID = this.automationWorkflow.departmentId;
          this.billingservice
            .getall_doctorsbysubspecilityId(this.automationWorkflow.departmentId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data: any) => {
              let list = data || [];
              if (this.authService.masterdata?.isExternal === true) {
                list = list.filter((item: any) => item.isExternal == false);
              }
              this.doctersSpecData = list;
              applyAutomationFields();
            });
        } else {
          applyAutomationFields();
        }
      }
    } else {
      this.opdvisitService.patientdetails.pkRegId = null;
      this.dashboardService.openSnackBar("This Patient is Not Registered  ", "OK")
    }
  }
  patient_failed(err) {
    this.showspinner = false;

    this.opdvisitService.patientdetails.pkRegId = null;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  onchnagebillService(id) {
    //console.log(id);
    var typeid = this.billingservice.billService.filter(
      (item) => item.billSerieseId == id
    );

    if (this.billingservice.lastbillid == null) {
      this.BillingData.FK_BillTypeId = typeid[0].billTypeId;
      this.BillDetailArray = [];
      this.dataSource.data = [];
      // this.paymentDetail(this.BillDetailArray);
      this.totalpay = 0;
      this.servicecharge = 0;
      this.lessDiscount = 0;
      this.netbillamount = 0;
      this.currentpayable = 0;
      this.partyAmount = 0;
      this.copartyAmount = 0;
      this.reciptBlanceAmmount = 0;
    } else {
      this.BillingData.FK_BillTypeId = typeid[0].billTypeId;
    }
  }

  onchnagecategory(id) {
    if (
      this.billingservice.lastbillid == null &&
      this.opdvisitService.checkAdmissionId == false
    ) {
      this.BillingData.FK_CategoryId = id;
      this.BillDetailArray = [];
      this.dataSource.data = [];
      this.paymentDetail(this.BillDetailArray);
      if (this.opdvisitService.patientdetails.pkRegId > 0 && this.billingservice.billserviceConfig.consultationConfigType == 3 &&
        this.BillingData.FK_CategoryId != null && this.LastVisitAllow == "N") {
        this.getdefaultservicebydoctoridcategoryid(this.opdvisitService.patientdetails.pkRegId, 0, this.BillingData.FK_CategoryId, 2);
      }
    } else {
      this.BillingData.FK_CategoryId = id;
    }


  }

  onchnagebillEntryType(id) {
    //console.log(id);
    this.BillingData.FK_BillSerieseId = id;
  }

  submitConsultationBill() {
    //console.log(this.completeBillingObj)
    this.billingservice.addbillingdata(this.completeBillingObj).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => this.success_bill_response(data, this.BillingData),
      (err) => this.err_billing_response(err)
    );
    document.getElementById("SameBillConsultasion").style.display = "none";
  }

  closesConsultationBil() {
    document.getElementById("SameBillConsultasion").style.display = "none";
  }

  closesServicePopUp() {
    document.getElementById("ServicecheckPopUp").style.display = "none";
  }

  clearallServicespopup() {
    if (this.BillDetailArray.length > 0 || this.RemoveServiceArray.length > 0) {
      document.getElementById("ServicecheckPopUp").style.display = "block";
    }
  }

  setfreshReciptdata() {
    if (this.copartyAmount > 0) {
      this.ReciptData.IsCoPayment = 1;
    } else {
      this.ReciptData.IsCoPayment = 0;
    }
    this.ReciptData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;
    this.ReciptData.PaymentDate = this.BillingData.BillDate;
    this.ReciptData.PaymentTime = this.cuurentTime;
    this.ReciptData.CurrencyAmount = parseFloat(this.currentpayable);
    this.ReciptData.AmountINR = parseFloat(this.currentpayable);
    this.ReciptData.PK_ReceiptId = 0;
    this.ReciptData.ReceiptNo = 0;
    this.ReciptData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.ReciptData.FK_CancelledById = 0;
    this.ReciptData.PrintCount = 0;
    this.ReciptData.IsActive = 1;
    this.ReciptData.FK_BillingCompanyId =
      this.authService.selectedbillingcompany;
    this.ReciptData.FK_FinyearId = this.authService.Loggeduser.finyear;
    this.ReciptData.FK_BranchId = this.authService.Loggeduser.branchid;
    this.ReciptData.FK_DepositHeadId = this.BillingData.FK_BillSerieseId;
    this.ReciptData.FK_CurrencyId = 1;
    this.ReciptData.ConvertRetio = 1;
    this.ReciptData.AmountTDS = 0;
    this.ReciptData.AmountDiscount = 0;
    this.ReciptData.AmountDisAllow = 0;
    this.ReciptData.AmountST = 0;
    this.ReciptData.FK_PayTypeId = 1;
    this.ReciptData.ChequeNo = null;
    this.ReciptData.ChequeDate = null;
    this.ReciptData.FK_ChqBankId = null;
    this.ReciptData.RefBankBranch = null;
    this.ReciptData.FK_ClrBankId = null;
    this.ReciptData.FK_DepositTypeId;
    this.ReciptData.FK_DepositTypeId = 3;
    this.ReciptData.IsAdjusted = 1;
    this.ReciptData.FK_AdjustedBillId = this.BillingData.PK_BillId;
    this.ReciptData.UserRemarks = null;
    this.ReciptData.Iscancelled = 0;
    this.ReciptData.RecptGenerateBSWise = "";
    this.ReciptData.FK_DoctorId = this.BillingData.FK_DoctorId;
  }

  // getsummary_url() {
  //   this.dashboardService.getsummary_url().subscribe(
  //     data => this.succesurl(data), err => this.failedurl(err)
  //   )
  // }
  // succesurl(data) {
  //   this.reporturl = data.propertyValue;
  // }
  getPrintInvoice(billid, forAutomation = false, onComplete?: (printed: boolean) => void): void {
    if (billid) {
      const url =
        this.reporturl +
        "OPDBill.aspx?BillId=" +
        billid +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&BillingCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&PrintType=DETAIL&ALLSERVICE=Y&PageHeadWebReport=" +
        this.PageHeader.propertyValue +
        "&QRCode=" +
        this.QrCode.propertyValue;
      const printed = this._openPrintUrl(url, forAutomation);
      if (onComplete) {
        onComplete(printed);
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
      if (onComplete) {
        onComplete(false);
      }
    }
  }
  printTimelineBill(
    type,
    billid,
    id,
    forAutomation = false,
    onComplete?: (printed: boolean) => void
  ): void {

    if (type == 1) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Billing Invoice" &&
          item.printType == "NetramReport"
      );
      if (checkreporttype.length > 0) {
        this.getPrintInvoice(billid, forAutomation, onComplete);
      } else {
        this.printTimelineBillreport(type, billid, id, forAutomation, onComplete);
      }
    } else if (type == 2) {
      let checkreporttypeb = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Bill Cum Receipt" &&
          item.printType == "NetramReport"
      );
      if (checkreporttypeb.length > 0) {
        this.getPrintInvoice(billid, forAutomation, onComplete);
      } else {
        this.printTimelineBillreport(type, billid, id, forAutomation, onComplete);
      }
    } else if (type == 3) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Billing Invoice" &&
          item.printType == "NetramReport"
      );
      if (checkreporttype.length > 0) {
        this.getPrintInvoice(billid, forAutomation, onComplete);
      } else {
        this.printTimelineBillreport(type, billid, id, forAutomation, onComplete);
      }
    } else if (type == 4) {

      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "BillSummary" &&
          item.printType == "WebNetramReport"
      );
      if (checkreporttype.length > 0) {
        this.printTimelineBillreport(type, billid, id, forAutomation, onComplete);
      } else if (onComplete) {
        onComplete(false);
      }
    } else if (onComplete) {
      onComplete(false);
    }
  }
  partydetail: any;
  printTimelineBillreport(
    type,
    billid,
    id,
    forAutomation = false,
    onComplete?: (printed: boolean) => void
  ) {
    if (billid <= 0) {
      this.dashboardService.openSnackBar("Please select bill first", "OK");
      if (onComplete) {
        onComplete(false);
      }
      return;
    }

    this.billingservice.GetPartyDetailByBIllId(billid, 0, 0, 0)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.partydetail = data;
        const user = this.authService.Loggeduser;
        const patient = this.opdvisitService.patientdetails;
        const bill = this.getBillIdobj?.billMasterDtos?.[0];
        const regId = id || patient?.pkRegId || bill?.fK_RegId;

        const basePayload = {
          module: "Billing",
          printType: "WebNetramReport",
          Pk_RegId: regId,
          PRINTDATE: this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
          Pk_BranchId: user.branchid,
          Pk_LoggedUserId: user.userid,
          PrintTime: this.convertTime12Hour(new Date()),
          BILLINGCOMPANYNAME: user.billingcompanyname,
          LINE1: this.branchmansterObj.line1,
          LINE2: this.branchmansterObj.line2,
          LINE3: this.branchmansterObj.line3,
          LINE4: this.branchmansterObj.line4,
          HOSPITALIMAGE: `${window.location.origin}/${this.authService.loginclientlogo}`,
          COMPANYIMAGE: `${window.location.origin}/${this.authService.leftbottomlogosm}`,
          CERTIFICATE1IMAGE: `${window.location.origin}/${this.authService.nabhlogo}`,
          CERTIFICATE2COMPANYIMAGE: "",
          BillId: billid,
          Pk_BillId: billid,
          ReceiptArray: "Y",
          ServiceArray: "Y",
          BillMasterArray: "Y",
          PatientRegistrationArray: "Y",
          PrintHeaderArray: this.PageHeader.propertyValue
        };

        let payload: any = { WebReportPrintMaster: {} };

        if (type === 1 || type === 3) {
          payload.WebReportPrintMaster = {
            ...basePayload,
            printOption: "Billing Invoice"
          };
        } else if (type === 4) {
          payload.WebReportPrintMaster = {
            ...basePayload,
            printOption: "BillSummary",
            AMOUNTPAID: bill.paidAmount,
            AMOUNTPATIENT: this.RecieptDepositedAmmount,
            AMOUNT: this.reciptBlanceAmmount,
            AMOUNTDISCOUNT: this.lessDiscount,
            INSURANCECOMPANY: this.partydetail.insuranceCoName,
            EMPLOYEENAME: this.partydetail.employeeName,
            RELATION: this.partydetail.relation,
            CLAIMNO: this.partydetail.a,
            INSURANCENO: this.partydetail.employeeIPNo,
            SERVICECHARGE: this.servicecharge,
            AMOUNTINWORDS: this.converIntoWord(this.reciptBlanceAmmount)
          };
        } else {
          payload.WebReportPrintMaster = {
            ...basePayload,
            printOption: type === 1 || type === 3 ? "Billing Invoice" : "Bill Cum Receipt",
            MOBILENO: patient?.mobileNo,
            BILLNO: this.customBilNumbver,
            BILLDATE: this.datePipe.transform(bill?.billDate, "dd-MM-yyyy"),
            BILLTIME: bill?.billTime,
            PARTYNAME: bill?.partyName,
            AMOUNTINWORDS: this.converIntoWord(
              type === 1 || type === 3 ? this.netbillamount : this.reciptBlanceAmmount
            ),
            AMOUNTTOTAL: type === 1 || type === 3 ? bill.totalAmt : this.totalpay,
            AMOUNTNET: type === 1 || type === 3 ? bill.netBillAmt : this.netbillamount,
            AMOUNTPAID: bill.paidAmount,
            AMOUNTPATIENT: this.RecieptDepositedAmmount,
            AMOUNT: this.reciptBlanceAmmount,
            AMOUNTDISCOUNT: this.lessDiscount,
            INSURANCECOMPANY: this.partydetail.insuranceCoName,
            EMPLOYEENAME: this.partydetail.employeeName,
            RELATION: this.partydetail.relation,
            CLAIMNO: this.partydetail.a,
            INSURANCENO: this.partydetail.employeeIPNo,
            SERVICECHARGE: this.servicecharge
          };
        }

        this.ipdService.GetWebReportPrint(payload)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (x: any) => {
              if (!x.length) {
                this.dashboardService.openSnackBar("Report Template Not Set", "OK");
                if (onComplete) {
                  onComplete(false);
                }
                return;
              }

              try { this.refreshButton?.nativeElement?.focus(); } catch (_) { /* ignore */ }

              const printContents = x[0].printTemplate;
              localStorage.setItem("templateFile", printContents);

              const printed = this._showPrintHtml(printContents, type != 3, forAutomation);
              if (!printed && onComplete) {
                onComplete(false);
                return;
              }

              if (patient?.emailAddress) {
                const formData = new FormData();
                formData.append("EmailCC", "");
                formData.append("SubjectCustom", type === 1 || type === 3 ? "Billing Invoice" : "Bill Cum Receipt");
                formData.append("EmailType", "CORPORATE DETAIL");
                formData.append("ToEmail", patient.emailAddress);
                formData.append("MessageTemplateCustom", printContents);

                this.billingservice.sendEmail(formData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
                  this.dashboardService.openSnackBar(data.message, "Ok");
                });
              }
              if (onComplete) {
                onComplete(printed);
              }
            },
            () => {
              this.dashboardService.openSnackBar("Api Failed", "OK");
              if (onComplete) {
                onComplete(false);
              }
            }
          );
      }, () => {
        if (onComplete) {
          onComplete(false);
        }
      });
  }


  Doctornamedata(id) {
    return this.opdvisitService.allUserArray.filter(
      (item) => item.userId == id
    )[0]?.userName;
  }
  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.branchMatserService.getBrachMasterItem(id).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    });
  }
  converIntoWord(balanceamount: number) {
    const numWords = require("num-words");
    const amountInWords = numWords(balanceamount);
    return amountInWords.toUpperCase();
  }
  InsuaranceInvoice(billid) {
    if (billid) {
      window.open(
        this.reporturl +
        "OPDBillInsurance.aspx?BillId=" +
        billid +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&BillingCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&PrintType=DETAIL&ALLSERVICE=N&PageHeadWebReport=" +
        this.PageHeader.propertyValue +
        "&QRCode=" +
        this.QrCode.propertyValue
      );
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }

  getBillSummery(PatientId: any, billId: any, billdate: any) {
    if (billId) {
      let sdate = this.datePipe.transform(billdate, "yyyy-MM-dd");
      window.open(
        this.reporturl +
        "OpdBillSummary.aspx?RegID=" +
        PatientId +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&PageHeadWebReport=" +
        this.PageHeader.propertyValue +
        "&BillDate=" +
        sdate
      );
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }
  getWebSticker(billId: any) {
    if (billId) {
      window.open(
        this.reporturl +
        "PatientStickerWithPhoto.aspx?BillId=" +
        billId +
        "&BranchId=" +
        this.authService.Loggeduser.branchid
      );
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }

  failedurl(err) {
    this.dashboardService.openSnackBar("summary api url failed ", "OK");
  }

  print(billid: any): void {
    if (billid) {
      if (this.opdvisitService.patientdetails.pkRegId) {
        let printContents, popupWin;

        printContents = document.getElementById("content").innerHTML;
        popupWin = window.open(
          "",
          "_blank",
          "top=0,left=0,height=100%,width=auto"
        );

        popupWin.document.open();
        popupWin.document.write(`
          <html>
           
        <body onload="window.print()">${printContents}
        </body>
          </html>`);

        popupWin.document.close();
      } else {
        this.dashboardService.openSnackBar("Please Select Patient", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }

  openAddreferedBy() {
    const dialogRef = this.dialog.open(ReferredByComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "390px",
      width: "35%",
      disableClose: true,
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.opdvisitService.personmaster = [];
      this.BillingData.FK_ReferredById = this.opdvisitService.referrebyid;
      this.opdvisitService.getpersonmaster('BILLING', 0);
    });
  }

  dicountReason() {
    this.discountReason = [];
    this.billingservice.getDiscountReason().subscribe(data => this.discountReason_succsess(data), err => this.discountReason_failed(err));

  }
  discountReason_succsess(data) {
    this.discountReason = data.filter(item => item.isActive == true);
    this.ReasonControll();
  }
  discountReason_failed(err) {
    this.dashboardService.openSnackBar("API Failed", "OK");
  }

  addService() {
    if (this.opdvisitService.patientdetails.pkRegId > 0) {
      if (this.BillingData.FK_PartyId > 0) {
        if (this.BillingData.RateType != null &&
          this.BillingData.RateType != ' ' &&
          this.BillingData.RateType != undefined &&
          this.BillingData.RateType != 0) {
          this.ipdService.selectedServiceRow = [];
          const ratetypename = this.billingservice.ratetype.filter(item => item.rateTypeId == this.BillingData.RateType)[0]?.rateType;
          const dialogRef = this.dialog.open(AddPackageComponent, {
            panelClass: "full-width-dialog",
            maxWidth: "100vw !important",
            height: "85%",
            width: "75%",
            data: { id: this.BillingData.FK_PartyId, Type: ratetypename },
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
            if (this.ipdService.selectedServiceRow.length > 0) {

              if (
                this.BillingData.FK_IPDId != null &&
                this.BillingData.FK_IPDId != 0
              ) {
                document.getElementById("IPDPackageModel").style.display = "block";
              } else {
                const packageid =
                  this.ipdService.selectedServiceRow[0].pK_PackageId;
                this.billingservice
                  .GetservicebyPackageId(packageid).pipe(takeUntil(this.destroy$))
                  .subscribe((dataa) => {
                    if (dataa.length > 0) {
                      //in case of packages discount amount pass into 
                      dataa.forEach((item) => {
                        var netamount: number = 0;
                        var discountamount: number = 0;
                        var discountpercent: number = 0;

                        discountpercent = item.discount != null ? item.discount : 0;
                        if (discountpercent != 0) {
                          discountamount = (parseInt(item.amount) * discountpercent) / 100;
                        } else {
                          discountamount = 0;
                        }
                        netamount = parseInt(item.amount) - discountamount;
                        this.BillDetailArray.push({
                          PK_BillDetailId: 0,
                          FK_BillId: 0,
                          serviceName: item.serviceName,
                          maxDiscountLimit: 0,
                          FK_ServiceId: item.fk_ServiceId,
                          isRateEditable: item.isRateEditable,
                          Rate: item.amount,
                          Amount: item.amount,
                          Unit: 1,
                          NetAmt: item.amount,
                          ServiceCharges: this.returnSericeChage(
                            item.rate,
                            item.serviceCharge
                          ),
                          scPer: item.serviceCharge ? item.serviceCharge : 0,
                          DiscountPercent: discountpercent,
                          Discount: discountamount,
                          FK_PackageId: item.fK_PackageId,
                          IsPerformed: item.isSCApplicable,
                          IsDelete: 0,
                          Remarks: "",
                          currentAmount: netamount,
                        });
                      });

                      this.paymentDetail(this.BillDetailArray);

                      this.dataSource.data = this.BillDetailArray;
                    } else {
                      this.dashboardService.openSnackBar(
                        " Service Not Available ",
                        "OK"
                      );
                    }
                  });
              }
            }
          });

        } else {
          this.dashboardService.openSnackBar("Please Select Rate Type", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Please Select Party Name", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Please Enter UHID First", "OK");
    }
  }
  IpdPackageDetail: any = [];
  addnewipdPackage() {
    // overWrite Case
    if (this.flag == 0) {
      // delete package
      this.showspinner = true;
      if (this.BillDetailArray.length > 0) {
        this.RemoveServiceArray = [];
        this.BillDetailArray.forEach((element) => {
          this.RemoveServiceArray.push(element);
        });
      }
      this.billingservice
        .DeleteIpdPackageDetailByIPDId(
          this.opdvisitService.patientdetails.fkIPDID
        ).pipe(takeUntil(this.destroy$))
        .subscribe((item) => {
          this.BillDetailArray = [];
          this.IpdPackageDetail = [];
          var packageobject = {};
          this.billingservice
            .GetservicebyPackageId(
              this.ipdService.selectedServiceRow[0].pK_PackageId
            ).pipe(takeUntil(this.destroy$))
            .subscribe((dataa) => {
              this.showspinner = false;
              if (dataa.length > 0) {
                dataa.forEach((item) => {
                  this.BillDetailArray.push({
                    PK_BillDetailId: 0,
                    FK_BillId: 0,
                    fK_IPDID: this.opdvisitService.patientdetails.fkIPDID,
                    serviceName: item.serviceName,
                    isRateEditable: item.isRateEditable,
                    maxDiscountLimit: 0,
                    FK_ServiceId: item.fk_ServiceId,
                    Rate: item.amount,
                    Amount: item.amount,
                    Unit: 1,
                    NetAmt: item.amount,
                    ServiceCharges: this.returnSericeChage(
                      item.rate,
                      item.serviceCharge ? item.serviceCharge : 0
                    ),
                    scPer: item.serviceCharge ? item.serviceCharge : 0,
                    DiscountPercent: item.discountPer ? item.discountPer : 0,
                    Discount: item.discount,
                    FK_PackageId: item.fK_PackageId,
                    IsPerformed: item.isSCApplicable,
                    IsDelete: 0,
                    Remarks: "",
                    currentAmount: item.amount,
                  });
                });
                //overwrite package detail
                if (this.ipdService.selectedServiceRow.length > 0) {
                  this.IpdPackageDetail.push({
                    PK_TranId: 0,
                    FK_IPDId: this.opdvisitService.patientdetails.fkIPDID,
                    FK_PackageId:
                      this.ipdService.selectedServiceRow[0]?.pK_PackageId,
                    Amount:
                      this.ipdService.selectedServiceRow[0]?.packageAmount,
                    DiscountPer: 0,
                  });
                }

                this.dashboardService.openSnackBar(
                  " Service OverWrite Successfully ",
                  "OK"
                );

                if (this.IpdPackageDetail.length > 0) {
                  packageobject = {
                    IpdPackageDetail: this.IpdPackageDetail,
                  };

                  this.appendPackage(packageobject, 0);
                }
                this.paymentDetail(this.BillDetailArray);
                this.dataSource.data = this.BillDetailArray;
              } else {
                this.dashboardService.openSnackBar(
                  " Service Not Available ",
                  "OK"
                );
              }
              document.getElementById("IPDPackageModel").style.display = "none";
            });
        });
      // Appened Case
    } else if (this.flag == 1) {
      this.IpdPackageDetail = [];
      var packageobject = {};
      this.showspinner = true;
      this.dashboardService.subscriptions = this.billingservice
        .GetservicebyPackageId(
          this.ipdService.selectedServiceRow[0].pK_PackageId
        ).pipe(takeUntil(this.destroy$))
        .subscribe((dataa) => {
          this.showspinner = false;
          if (dataa.length > 0) {
            dataa.forEach((item) => {
              this.BillDetailArray.push({
                PK_BillDetailId: 0,
                FK_BillId: 0,
                fK_IPDID: this.opdvisitService.patientdetails.fkIPDID,
                serviceName: item.serviceName,
                maxDiscountLimit: 0,
                FK_ServiceId: item.fk_ServiceId,
                isRateEditable: item.isRateEditable,
                Rate: item.amount,
                Amount: item.amount,
                Unit: 1,
                NetAmt: item.amount,
                ServiceCharges: this.returnSericeChage(
                  item.rate,
                  item.serviceCharge ? item.serviceCharge : 0
                ),
                scPer: item.serviceCharge ? item.serviceCharge : 0,
                DiscountPercent: item.discountPer ? item.discountPer : 0,
                Discount: item.discount,
                FK_PackageId: item.fK_PackageId,
                IsPerformed: item.isSCApplicable,
                IsDelete: 0,
                Remarks: "",
                currentAmount: item.amount,
              });
              //append package detail
              // this.IpdPackageDetail.push({
              //   "PK_TranId": 0,
              //   "FK_IPDId": this.opdvisitService.patientdetails.fkIPDID,
              //   "FK_PackageId": item.fK_PackageId,
              //   "Amount": item.amount,
              //   "DiscountPer":item.discountPer?item.discountPer: 0,
              // });
            });
            if (this.ipdService.selectedServiceRow.length > 0) {
              this.IpdPackageDetail.push({
                PK_TranId: 0,
                FK_IPDId: this.opdvisitService.patientdetails.fkIPDID,
                FK_PackageId:
                  this.ipdService.selectedServiceRow[0]?.pK_PackageId,
                Amount: this.ipdService.selectedServiceRow[0]?.packageAmount,
                DiscountPer: 0,
              });
            }
            if (this.IpdPackageDetail.length > 0) {
              packageobject = {
                IpdPackageDetail: this.IpdPackageDetail,
              };
              this.appendPackage(packageobject, 0);
            }
            this.paymentDetail(this.BillDetailArray);
            this.dataSource.data = this.BillDetailArray;
          } else {
            this.dashboardService.openSnackBar(" Service Not Available ", "OK");
          }
          document.getElementById("IPDPackageModel").style.display = "none";
        });
    }
  }

  appendPackage(packagedata: any, type: number) {
    this.showspinner = true;
    this.billingservice.InsertIpdPackageDetail(packagedata).pipe(takeUntil(this.destroy$)).subscribe(
      (item) => {
        this.showspinner = false;
        this.getIpdRegistration(this.BillingData.FK_IPDId, type);
      },
      (err) => {
        this.showspinner = false;
        this.dashboardService.openSnackBar(" API Failed ", "OK");
      }
    );
  }

  CancelIpdPackge() {
    this.flag = 0;
    document.getElementById("IPDPackageModel").style.display = "none";
  }
  // corporate details
  addCorporateDetail(billid: any, partyid: any) {
    if (billid > 0) {
      this.ipdService.content.next({});
      if (partyid > 1) {
        const dialogRef = this.dialog.open(CorporateDetailComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "96%",
          width: "95%",
          maxHeight: "100%",
          data: {
            partyip: this.BillingData.FK_PartyId,
            billId: this.getBillId,
            balanceAmount: this.reciptBlanceAmmount - this.copartyAmount,
            ipdId: 0,
            screentype: "Billing",
          },
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {

        });
      } else {
        document.getElementById("CorporateDetailPartyid").style.display =
          "block";
      }
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Bill First or Create Bill",
        "OK"
      );
    }
  }

  addPatientInsurace(billid: any) {
    if (billid > 0) {
      const dialogRef = this.dialog.open(CorporateDetailComponent, {
        // panelClass: "full-width-dialog",
        maxWidth: "95vw",
        // height: "100%",
        width: "100%",
        data: {
          partyip: this.BillingData.FK_PartyId,
          billId: this.getBillId,
          balanceAmount: this.reciptBlanceAmmount,
        },
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => { });
      document.getElementById("CorporateDetailPartyid").style.display = "None";
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Bill First or Create Bill",
        "OK"
      );
    }
  }

  closesPatientInsurace() {
    document.getElementById("CorporateDetailPartyid").style.display = "none";
  }

  getIpdRegistration(event: any, type: number) {

    if (event != null || event != undefined) {
      this.BillingData.FK_IPDId = event;
      var ipdregistrationdata = [];
      ipdregistrationdata = this.opdvisitService.ipdRegistrationDetail.filter(
        (item) => item.pK_IPDId == event
      );

      if (ipdregistrationdata[0].fk_BillId == 0) {

        let checkipdid = this.billingservice.billService.filter(item => item.isIPD == 1);
        if (checkipdid.length > 0) {
          this.BillingData.FK_BillSerieseId = checkipdid[0].billSerieseId;
          this.BillingData.FK_BillTypeId = checkipdid[0].billTypeId;
        } else {
          this.BillingData.FK_BillTypeId = 3;
          this.BillingData.FK_BillSerieseId = this.BillingData.FK_BillTypeId;
        }

        this.BillingData.FK_CategoryId = ipdregistrationdata[0].fK_CategoryId;
        this.BillingData.FK_DoctorId = ipdregistrationdata[0].fK_ConsultantId;
        this.BillingData.FK_ReferredById =
          ipdregistrationdata[0].fK_ReferedById;
        this.BillingData.FK_PartyId = ipdregistrationdata[0].fK_PartyId;
        this.getRateList(
          this.BillingData.FK_PartyId,
          1,
          ipdregistrationdata[0].fK_RateListId
        );
        this.BillingData.RateType = ipdregistrationdata[0].rateType;
        this.BillingData.Remarks = ipdregistrationdata[0].remarks;
        if (type != 0) {
          this.getIpdRegistrationPackge(
            event,
            ipdregistrationdata[0]?.fK_ConsId,
            ipdregistrationdata[0]?.rateType
          );
        }
        if (ipdregistrationdata[0].upgradeAmount > 0) {
          this.getUpgradePackage(
            ipdregistrationdata[0].pK_IPDId,
            ipdregistrationdata[0].upgradeAmount
          );
        }
      } else {
        ipdregistrationdata = [];
        this.dashboardService.openSnackBar(
          " Ipd Registration Already Generate Bill ",
          "OK"
        );
      }
    }
  }

  getIpdRegistrationPackge(ipdid: any, consid: any, ratetype: any) {

    this.billingservice.GetpackagebyIpdId(ipdid).pipe(takeUntil(this.destroy$)).subscribe((dataa) => {
      var netamount: number = 0;
      var discountamount: number = 0;
      var discountpercent: number = 0;
      this.BillDetailArray = [];

      if (dataa.length > 0) {
        dataa.forEach((data) => {
          discountpercent = data.discount != null ? data.discount : 0;
          if (discountpercent != 0) {
            discountamount = (parseInt(data.amount) * discountpercent) / 100;
          } else {
            discountamount = 0;
          }
          netamount = parseInt(data.amount) - discountamount;
          this.checkupgradePackageAmount =
            this.checkupgradePackageAmount + data.amount;
          this.BillDetailArray.push({
            PK_BillDetailId: 0,
            FK_BillId: 0,
            fK_IPDID: data.fK_IPDId,
            serviceName: data.serviceName,
            maxDiscountLimit: 0,
            FK_ServiceId: data.fk_ServiceId,
            isRateEditable: data.isRateEditable,
            Rate: data.amount,
            Amount: data.amount,
            Unit: 1,
            NetAmt: data.amount,
            ServiceCharges: this.returnSericeChage(
              data.amount,
              data.serviceCharge ? data.serviceCharge : 0
            ),
            scPer: data.serviceCharge ? data.serviceCharge : 0,
            DiscountPercent: discountpercent,
            Discount: discountamount,
            FK_PackageId: data.fK_PackageId,
            IsPerformed: 0,
            IsDelete: 0,
            Remarks: "",
            currentAmount: netamount
          });
        });
      }
      if (consid != null && consid != undefined && consid > 0) {
        this.ipdService
          .GetCounselorAdditionalService(consid).pipe(takeUntil(this.destroy$))
          .subscribe((x: any) => {

            if (x.length > 0) {
              x.forEach((data) => {
                var ipnetamount: number = 0;
                var ipdiscountamount: number = 0;
                var ipdiscountpercent: number = 0;
                ipdiscountpercent = data.discount != null ? data.discount : 0;
                if (ipdiscountpercent != 0) {
                  ipdiscountamount = (parseInt(data.amount) * ipdiscountpercent) / 100;
                } else {
                  ipdiscountamount = 0;
                }
                ipnetamount = parseInt(data.amount) - ipdiscountamount;
                switch (ratetype) {
                  case 1: {
                    this.checkupgradePackageAmount =
                      this.checkupgradePackageAmount + data.amount;
                    this.BillDetailArray.push({
                      PK_BillDetailId: 0,
                      FK_BillId: 0,
                      fK_IPDID: ipdid,
                      serviceName: data.serviceName,
                      maxDiscountLimit: 0,
                      FK_ServiceId: data.fK_ServiceId,
                      isRateEditable: data.isRateEditable,
                      Rate: data.amount,
                      Amount: data.amount,
                      Unit: 1,
                      NetAmt: data.amount,
                      ServiceCharges: this.returnSericeChage(
                        data.amount,
                        data.serviceCharge ? data.serviceCharge : 0
                      ),
                      scPer: data.serviceCharge ? data.serviceCharge : 0,
                      DiscountPercent: ipdiscountpercent,
                      Discount: ipdiscountamount,
                      FK_PackageId: 0,
                      IsPerformed: 0,
                      IsDelete: 0,
                      Remarks: "",
                      currentAmount: ipnetamount
                    });
                    break;
                  }
                  case 2: {
                    this.checkupgradePackageAmount =
                      this.checkupgradePackageAmount + data.spAmount;
                    this.BillDetailArray.push({
                      PK_BillDetailId: 0,
                      FK_BillId: 0,
                      fK_IPDID: ipdid,
                      serviceName: data.serviceName,
                      maxDiscountLimit: 0,
                      FK_ServiceId: data.fK_ServiceId,
                      isRateEditable: data.isRateEditable,
                      Rate: data.spAmount,
                      Amount: data.spAmount,
                      Unit: 1,
                      NetAmt: data.spAmount,
                      ServiceCharges: this.returnSericeChage(
                        data.spAmount,
                        data.serviceCharge ? data.serviceCharge : 0
                      ),
                      scPer: data.serviceCharge ? data.serviceCharge : 0,
                      DiscountPercent: ipdiscountpercent,
                      Discount: ipdiscountamount,
                      FK_PackageId: 0,
                      IsPerformed: 0,
                      IsDelete: 0,
                      Remarks: "",
                      currentAmount: ipnetamount
                    });
                    break;
                  }
                  case 3: {
                    this.checkupgradePackageAmount =
                      this.checkupgradePackageAmount + data.spAmount;
                    this.BillDetailArray.push({
                      PK_BillDetailId: 0,
                      FK_BillId: 0,
                      fK_IPDID: ipdid,
                      serviceName: data.serviceName,
                      maxDiscountLimit: 0,
                      FK_ServiceId: data.fK_ServiceId,
                      isRateEditable: data.isRateEditable,
                      Rate: data.spAmount,
                      Amount: data.spAmount,
                      Unit: 1,
                      NetAmt: data.spAmount,
                      ServiceCharges: this.returnSericeChage(
                        data.spAmount,
                        data.serviceCharge ? data.serviceCharge : 0
                      ),
                      scPer: data.serviceCharge ? data.serviceCharge : 0,
                      DiscountPercent: ipdiscountpercent,
                      Discount: ipdiscountamount,
                      FK_PackageId: 0,
                      IsPerformed: 0,
                      IsDelete: 0,
                      Remarks: "",
                      currentAmount: ipnetamount
                    });
                    break;
                  }
                  case 4: {
                    this.checkupgradePackageAmount =
                      this.checkupgradePackageAmount + data.sdAmount;
                    this.BillDetailArray.push({
                      PK_BillDetailId: 0,
                      FK_BillId: 0,
                      fK_IPDID: ipdid,
                      serviceName: data.serviceName,
                      maxDiscountLimit: 0,
                      FK_ServiceId: data.fK_ServiceId,
                      isRateEditable: data.isRateEditable,
                      Rate: data.sdAmount,
                      Amount: data.sdAmount,
                      Unit: 1,
                      NetAmt: data.sdAmount,
                      ServiceCharges: this.returnSericeChage(
                        data.sdAmount,
                        data.serviceCharge ? data.serviceCharge : 0
                      ),
                      scPer: data.serviceCharge ? data.serviceCharge : 0,
                      DiscountPercent: ipdiscountpercent,
                      Discount: ipdiscountamount,
                      FK_PackageId: 0,
                      IsPerformed: 0,
                      IsDelete: 0,
                      Remarks: "",
                      currentAmount: ipnetamount
                    });
                    break;
                  }
                  case 5: {
                    this.checkupgradePackageAmount =
                      this.checkupgradePackageAmount + data.dAmount;
                    this.BillDetailArray.push({
                      PK_BillDetailId: 0,
                      FK_BillId: 0,
                      fK_IPDID: ipdid,
                      serviceName: data.serviceName,
                      maxDiscountLimit: 0,
                      FK_ServiceId: data.fK_ServiceId,
                      isRateEditable: data.isRateEditable,
                      Rate: data.dAmount,
                      Amount: data.dAmount,
                      Unit: 1,
                      NetAmt: data.dAmount,
                      ServiceCharges: this.returnSericeChage(
                        data.dAmount,
                        data.serviceCharge ? data.serviceCharge : 0
                      ),
                      scPer: data.serviceCharge ? data.serviceCharge : 0,
                      DiscountPercent: ipdiscountpercent,
                      Discount: ipdiscountamount,
                      FK_PackageId: 0,
                      IsPerformed: 0,
                      IsDelete: 0,
                      Remarks: "",
                      currentAmount: ipnetamount
                    });
                    break;
                  }
                }
              });
              this.paymentDetail(this.BillDetailArray);
              this.dataSource.data = this.BillDetailArray;
            } else {
              this.paymentDetail(this.BillDetailArray);
              this.dataSource.data = this.BillDetailArray;
            }
        });
      } else {
        this.paymentDetail(this.BillDetailArray);
        this.dataSource.data = this.BillDetailArray;
      }
    });
  }
  // getIpChageById(ipdid: any) {
  //   this.billingservice.getIpChargeByID(ipdid).pipe(takeUntil(this.destroy$)).subscribe((dataa) => {
  //     if (dataa.length > 0) {
  //       dataa.forEach((data) => {
  //         if (data.remarks == null) {
  //           data.remarks = "";
  //         }
  //         this.BillDetailArray.push({
  //           PK_BillDetailId: 0,
  //           FK_BillId: 0,
  //           fK_IPDID: data.fK_IPDID,
  //           serviceName: data.serviceName,
  //           maxDiscountLimit: 0,
  //           FK_ServiceId: data.fK_ServiceId,
  //           isRateEditable: data.isRateEditable,
  //           Rate: data.serviceRate,
  //           Amount: data.amount,
  //           Unit: 1,
  //           NetAmt: data.amount,
  //           ServiceCharges: this.returnSericeChage(
  //             data.amount,
  //             data.serviceCharge
  //           ),
  //           scPer: data.serviceCharge ? data.serviceCharge : 0,
  //           DiscountPercent: data.discountPer,
  //           Discount: data.discountPer,
  //           FK_PackageId: data.fK_PackageId,
  //           IsPerformed: 0,
  //           IsDelete: 0,
  //           Remarks: data.remarks,
  //           currentAmount: data.netAmt,
  //         });
  //       });
  //       this.paymentDetail(this.BillDetailArray);
  //       this.dataSource.data = this.BillDetailArray;
  //     } else {
  //       this.dashboardService.openSnackBar(" Ip Charge Not Available ", "OK");
  //     }
  //   });
  // }

  getUpgradePackage(ipdid: any, upgradeAmount: any) {
    this.billingservice.GetpackageMaster().pipe(takeUntil(this.destroy$)).subscribe((dataa) => {

      if (dataa.length > 0) {
        // this.BillDetailArray=[];
        const upgradepackage = dataa.filter(
          (item) =>
            item.serviceName == "Upgrade package" && item.isActive == true
        );
        if (upgradepackage.length > 0) {
          this.BillDetailArray.push({
            PK_BillDetailId: 0,
            FK_BillId: 0,
            fK_IPDID: ipdid,
            serviceName: "Upgrade Package",
            maxDiscountLimit: 0,
            FK_ServiceId: upgradepackage[0].pK_ServiceId,
            Rate: upgradeAmount,
            Amount: upgradeAmount,
            Unit: 1,
            isRateEditable: false,
            NetAmt: upgradeAmount,
            ServiceCharges: 0,
            scPer: 0,
            DiscountPercent: 0,
            Discount: 0,
            FK_PackageId: 0,
            IsPerformed: 0,
            IsDelete: 0,
            Remarks: "",
            currentAmount: upgradeAmount,
          });
          this.paymentDetail(this.BillDetailArray);
          this.dataSource.data = this.BillDetailArray;
        } else {
          this.dashboardService.openSnackBar(
            " Please Create One Service for Upgrade which Name should be (Upgrade Package) ",
            "OK"
          );
        }
      }
    });
  }
  //patient bill refund code....
  BillRefund(pid: any, billid: any) {
    if (billid) {
      const checkparttype = this.BillingDebitDetail.filter(
        (item) => item.FK_PartyId == 1 || item.fK_PartyId == 1
      );

      if (checkparttype.length > 0) {
        var receiptdata = [];
        this.billingservice
          .getbillingrecipt(
            pid,
            billid,
            0
          ).subscribe((data: any) => {

            receiptdata = data.filter(
              (item) => item.fK_PartyId == 1 && item.isAdjusted == true
            );
            if (receiptdata.length > 0) {
              var checkadjustedAmount = 0;

              this.billingservice.getAdustedDetails(0, billid).pipe(takeUntil(this.destroy$)).subscribe((resp) => {
                if (resp.statusCode) {
                  this.dashboardService.openSnackBar(
                    "Patient No Payment Available",
                    "OK"
                  );
                } else {
                  resp?.forEach((element) => {
                    if (element.fK_PartyId == 1) {
                      checkadjustedAmount =
                        checkadjustedAmount + element.adjustedAmount;
                    }
                  });

                  if (checkadjustedAmount > 0) {
                    var repData = {
                      pid: pid,
                      billId: billid,
                      recipobj: receiptdata,
                      paidAmount: checkadjustedAmount,
                      Billdetail: checkparttype,
                      appprvaldetail: this.billApprovalobject,
                    };

                    const dialogRef = this.dialog.open(BillRefundComponent, {
                      panelClass: "full-width-dialog",
                      maxWidth: "100vw !important",
                      height: "90%",
                      width: "70%",
                      data: repData,
                    });

                    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
                      this.totalrefundamount = result;
                    });
                  } else {
                    this.dashboardService.openSnackBar(
                      "Please paid the Amount after that you Apply for refund",
                      "OK"
                    );
                  }
                }
              });
              // })
            } else {
              this.dashboardService.openSnackBar(
                "Please generate your receipt",
                "OK"
              );
            }
          })

      } else {
        this.dashboardService.openSnackBar(
          "Bill refund only Available for Patient Party/TPA",
          "OK"
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        "Please select bill or Generate new Bill",
        "OK"
      );
    }
  }
  public patientcardmini = false;
  patientCardToggle() {
    //
    if (this.patientcardmini) {
      document.getElementById("patientCardDown").style.display = "block";
      document.getElementById("patientCardUp").style.display = "none";
      this.patientcardmini = false;
    } else {
      document.getElementById("patientCardDown").style.display = "none";
      document.getElementById("patientCardUp").style.display = "block";
      this.patientcardmini = true;
    }
  }
  // Bill Recovery Manager
  billRecoveryManager() {
    const dialogRef = this.dialog.open(BillRecoveryManagerComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "95%",
      width: "90%",
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => { });
  }

  //autocomplete Billing Remark
  // RemarkControll() {

  //   this.RemarkCtrl = new FormControl();
  //   this.filteredRemarkArray = this.RemarkCtrl.valueChanges
  //     .pipe(
  //       startWith(''),
  //       map(cat => cat ? this.filterRemarkfunction(cat) : this.BillingRemarkArray.slice())
  //     );

  // }

  // filterRemarkfunction(name: string) {

  //   const len = Object.keys(name).length;
  //   if (len > 9) {
  //     return this.BillingRemarkArray.filter(co =>
  //       co.helpDescription?.toLowerCase().indexOf(name) === 0);
  //   } else {

  //     return this.BillingRemarkArray.filter(co =>
  //       co.helpDescription?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
  //   }

  // }
  // getRemarkobj(e: any) {
  //   var val = e.option.value;
  //   this.BillingData.Remarks = val.helpDescription;

  // }
  // CheckinputRemark(event: any) {
  //   var checkdata = event.target.value;
  //   if (checkdata == "") {
  //     this.getbillingresonsHelplist();
  //   } else {
  //     this.BillingData.Remarks = checkdata;
  //   }
  // }
  //autocomplete discount reason
  ReasonControll() {

    this.ReasonCtrl = new FormControl();
    this.filteredReasonArray = this.ReasonCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterReasonfunction(cat) : this.discountReason.slice())
      );

  }

  filterReasonfunction(name: string) {

    const len = Object.keys(name).length;
    if (len > 9) {
      return this.discountReason.filter(co =>
        co.popupDescription?.toLowerCase().indexOf(name) === 0);
    } else {

      return this.discountReason.filter(co =>
        co.popupDescription?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }

  }
  getReasonobj(e: any) {

    var val = e.value ? e.value : null;
    this.BillingData.FreeReason = val;
    if (val) {
      this.getResone();
    }

  }
  // CheckinputReason(event: any) {

  //   this.getResone();

  // }
  getbillingRemarks(parameter) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: parameter,
      },
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (result != 0) {
        this.BillingData.Remarks = result;
      }
    });
  }
  disCountHelplist(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        typeid: type,
      },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (result != 0) {
        this.dicountReason();
        this.BillingData.FreeReason = result;
        this.getResone();
      }
    });
  }

  closedialog() {
    this.dialogRef.close();
  }
  //sticker
  printTimeline() {
    if (this.opdvisitService.patientdetails.pkRegId > 0) {
      let payload = {
        WebReportPrintMaster: {
          module: "Registration",
          printOption: "PatientSticker",
          printType: "WebNetramReport",
          PRINTTYPESOCKET: this.opdvisitService.PrintTypeSocket,
          PATIENTNAME:
            this.opdvisitService.patientdetails.initial +
            " " +
            this.opdvisitService.patientdetails.firstName +
            " " +
            this.opdvisitService.patientdetails.lastName,
          MRDNO: this.opdvisitService.patientdetails.pkRegId,
          MobileNo: this.opdvisitService.patientdetails.mobileNo,
          PatientAddress: this.opdvisitService.patientdetails.paddress,
          PRINTDATE: this.datePipe.transform(
            this.authService.localDate,
            "dd-MM-yyyy"
          ),
          PrintTime: this.convertTime12Hour(new Date()),
          PatientAge: this.opdvisitService.patientdetails.ageYear,
          PatientGender: this.opdvisitService.patientdetails.sex,
          PatientAgeAndGender: this.setage1(
            this.opdvisitService.patientdetails.ageYear,
            this.opdvisitService.patientdetails.ageMonth,
            this.opdvisitService.patientdetails.ageDays,
            this.opdvisitService.patientdetails.sex
          ),
          REGDATE: this.datePipe.transform(
            this.opdvisitService.patientdetails.regDate,
            "dd-MM-yyyy"
          ),
          CAREOFNAME: this.opdvisitService.patientdetails.careofName,
        },
      };

      this.ipdService.GetWebReportPrint(payload).pipe(takeUntil(this.destroy$)).subscribe(
        (x: any) => {
          if (x.length > 0) {
            if (this.opdvisitService.PrintTypeSocket > 0) {
              let printContents, popupWin;
              printContents = x[0].printTemplate;
              popupWin = window.open(
                "",
                "_blank",
                "top=0,left=0,height=100%,width=auto"
              );
              popupWin.document.open();
              popupWin.document.write(`
        <html>
         
      <body >${printContents}
      </body>
        </html>`);

              popupWin.document.close();
            } else {
              let printContents, popupWin;

              printContents = x[0].printTemplate;
              popupWin = window.open(
                "",
                "_blank",
                "top=0,left=0,height=100%,width=auto"
              );

              popupWin.document.open();
              popupWin.document.write(`
        <html>
         
      <body onload="window.print()">${printContents}
      </body>
        </html>`);

              popupWin.document.close();
            }
          } else {
            this.dashboardService.openSnackBar("Report Template Not Set", "OK");
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("Api Failed", "OK");
        }
      );
    } else {
      this.dashboardService.openSnackBar("Please Select UHID First", "OK");
    }
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != "") {
      let hour = this.timecheck.split(":")[0];
      let min = this.timecheck.split(":")[1];
      let part = hour >= 12 ? "PM" : "AM";

      min = (min + "").length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + "").length == 1 ? `0${hour}` : hour;

      return `${hour}:${min} ${part}`;
    } else {
      return null;
    }
  }
  getdoctorlistByspecId(id) {
    if (id != undefined) {
      if (id != 0) {
        this.billingservice
          .getall_doctorsbysubspecilityId(id).pipe(takeUntil(this.destroy$))
          .subscribe((x: any) => {

            this.doctersSpecData = [];
            this.doctersSpecData = x;
            var doctername = this.doctersSpecData.filter(
              (item) => item.userId == this.BillingData.FK_DoctorId
            );
            this.docterName = doctername[0]?.userName ? doctername[0]?.userName : null;
          });
      } else {
        this.billingservice
          .getall_doctorsbysubspecilityId(id).pipe(takeUntil(this.destroy$))
          .subscribe((data: any) => {

            this.doctersSpecData = [];
            if (this.authService.masterdata.isExternal === true) {
              this.doctersSpecData = data?.filter(
                (item) => item.isExternal == false
              );
              if (
                this.billingservice.billserviceConfig?.fK_DoctorId > 0 &&
                this.billingservice.billserviceConfig?.fK_DoctorId != null
              ) {
                this.BillingData.FK_DoctorId =
                  this.billingservice.billserviceConfig?.fK_DoctorId;
              } else {
                this.BillingData.FK_DoctorId = this.doctersSpecData[0]?.userId;
              }
            } else {
              this.doctersSpecData = data;
              this.BillingData.FK_DoctorId =
                this.billingservice.billserviceConfig?.fK_DoctorId;
            }
          });
      }
    }
  }

  docterListDisplay() {
    this.filterdoctor = "";
    setTimeout(() => this.doctorlistfocus.nativeElement.focus(), 0);
    document.getElementById("DocterListDisplay").style.display = "block";
  }
  closedocterListDisplay() {
    this.indexvalue = -1;
    this.selectedRowIndex = -1;
    setTimeout(() => this.doctorButton.nativeElement.focus(), 0);
    document.getElementById("DocterListDisplay").style.display = "none";
  }
  Checkinput(event) {
    if (this.docterName == "") {
      this.BillingData.FK_DoctorId = null;
      this.getSpecilityData(0);
    }
  }
  getSpeciltiyDatabyuserid(id) {
    this.billingservice.getSpeciltiyDatabyuserid(id).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.subsepceialdata = x;
      if (this.selectspecId != "") {
        var subspecId = this.subsepceialdata.filter(
          (item) => item.pK_SubSpecialityId == this.selectspecId
        );
        this.BillingData.Fk_DrDeptID = subspecId[0]?.pK_SubSpecialityId;
      } else {
        this.BillingData.Fk_DrDeptID =
          this.subsepceialdata[0]?.pK_SubSpecialityId;
      }

      this.getdoctorlistByspecId(this.subsepceialdata[0]?.pK_SubSpecialityId);
    });
  }
  onchnagedr(id) {
    this.doctorButton.nativeElement.focus();
    this.BillingData.FK_DoctorId = id;
    this.DRdata = this.doctersSpecData.filter((item) => item.userId == id);
    this.docterName = this.DRdata[0].userName;
    if (this.docterName != "") {
      this.getSpeciltiyDatabyuserid(id);
    } else {
      this.getSpecilityData(0);
    }
    if (this.opdvisitService.patientdetails.pkRegId > 0 && this.billingservice.billserviceConfig.consultationConfigType == 2 &&
      this.BillingData.FK_DoctorId != null && this.opdvisitService.checkAdmissionId == false && this.LastVisitAllow == "N") {
      this.BillDetailArray = [];
      this.dataSource.data = [];
      this.paymentDetail(this.BillDetailArray);
      this.getdefaultservicebydoctoridcategoryid(this.opdvisitService.patientdetails.pkRegId, this.BillingData.FK_DoctorId, 0, 1);
    }
    this.closedocterListDisplay();
  }
  getfilterDR(id) {
    this.selectspecId = id;
    this.getdoctorlistByspecId(id);
  }
  CloseEmrService() {
    document.getElementById("servicenotAvailable").style.display = "none";
  }
  getenablebtn() {
    this.tpaServicediable = false;
  }
  tpaService: any = [];
  tpaServicediable: boolean = true;
  addDrEmrService(type) {
    if (this.opdvisitService.patientdetails.pkRegId > 0) {
      if (
        this.billingservice.ratelist.rateListId == null ||
        this.billingservice.ratelist.rateListId == undefined
      ) {
        return this.dashboardService.openSnackBar(
          "Rate List is Required",
          "ok"
        );
      }
      if (
        this.BillingData.RateType == null ||
        this.BillingData.RateType == undefined
      ) {
        return this.dashboardService.openSnackBar(
          "Rate Type is Required",
          "ok"
        );
      }

      this.billingservice
        .getDrEmrServices(
          this.BillingData.RateType,
          this.billingservice.ratelist.rateListId,
          this.opdvisitService.patientdetails.pkRegId,
          this.datePipe.transform(this.BillingData.BillDate, "yyyy-MM-dd")
        ).pipe(takeUntil(this.destroy$))
        .subscribe(
          (x: any) => {

            this.tpaService = [];

            if (x.length > 0 && type == 1) {
              this.tpaServicediable = false;
              this.tpaService = x.filter((rt) => rt.rate < 0);
              if (this.tpaService.length > 0) {
                document.getElementById("servicenotAvailable").style.display =
                  "block";
              }
              const chekservice = x.filter((rt) => rt.rate >= 0);
              chekservice.forEach((element, index) => {
                this.BillDetailArray = this.BillDetailArray.filter(
                  (item) => item.FK_ServiceId !== element.serviceId
                );
                this.BillDetailArray.push({
                  PK_BillDetailId: 0,
                  FK_BillId: 0,
                  serviceName: element.serviceName,
                  maxDiscountLimit: element.maxDiscountLimit,
                  FK_ServiceId: element.serviceId,
                  isRateEditable: element.isRateEditable,
                  Rate: element.rate,
                  Amount: element.rate,
                  Unit: 1,
                  NetAmt: element.rate,
                  ServiceCharges: this.returnSericeChage(
                    element.rate,
                    element.serviceCharge
                  ),
                  scPer: element.serviceCharge ? element.serviceCharge : 0,
                  DiscountPercent: element.discount,
                  Discount: 0,
                  FK_PackageId: 0,
                  IsPerformed: 0,
                  IsDelete: 0,
                  Remarks: "",
                  currentAmount: element.rate,
                });
                //
              });
              this.BillDetailArray = this.BillDetailArray.reduce(
                (unique, o) => {
                  if (
                    !unique.some(
                      (obj) =>
                        obj.serviceName === o.serviceName &&
                        obj.FK_ServiceId === o.FK_ServiceId
                    )
                  ) {
                    unique.push(o);
                  }
                  return unique;
                },
                []
              );

              const index = this.BillDetailArray.filter(
                (list) => list.FK_ServiceId == 0
              );
              if (index.length > 0) {
                this.BillDetailArray.splice(index, 1);
              }

              this.dataSource.data = this.BillDetailArray;

              this.BillDetailArray.forEach((elem, index) => {
                if (elem.DiscountPercent > 0) {
                  this.ondiscountPercentage(elem.DiscountPercent, index, 0);
                }
                if (elem.ServiceCharges > 0) {
                  this.onserviceChnage(elem.ServiceCharges, index);
                }
              });
              this.paymentDetail(this.BillDetailArray);
            } else if (x.length == 0 && type == 0) {
              this.tpaServicediable = true;
            } else if (x.length > 0 && type == 0) {
              this.tpaServicediable = false;
            } else if (x.length == 0 && type == 1) {
              this.tpaServicediable = false;
              this.dashboardService.openSnackBar("Record Not Found", "ok");
            }
          },
          (err) => {
            this.dashboardService.openSnackBar("API Failed", "ok");
          }
        );
    } else {
      this.dashboardService.openSnackBar("Enter UHID First", "ok");
    }
  }

  ApprovalMethod(event) {
    this.Approvalshowdata();
  }

  checktyperequest: number = 1;
  apprvaltypearry: any = [];
  approvalRequestModal(type) {

    this.closeBillModificationRequestApprovedModal();
    this.billingservice.getiolDetail('APPROVALTYPE').subscribe((item: any) => {
      this.apprvaltypearry = [];
      this.apprvaltypearry = item;
      this.checktyperequest = type;
      this.approvalchange.branchid = this.authService.Loggeduser.branchid;
      this.approvalchange.fromdate = this.authService.getServerDate;
      this.approvalchange.todate = this.authService.getServerDate;
      this.approvalchange.status = 0;
      this.approvalchange.type = "Discount";
      this.getALlreqestData(
        this.authService.Loggeduser.branchid,
        this.authService.getServerDate,
        this.authService.getServerDate,
        this.approvalchange.type,
        0,
        0
      );

      document.getElementById("approvalRequestModal").style.display = "block";
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });

  }
  Approvalshowdata() {
    if (
      Date.parse(
        this.datePipe
          .transform(this.approvalchange.todate, "yyyy-MM-dd")
          .toString()
      ) >=
      Date.parse(
        this.datePipe
          .transform(this.approvalchange.fromdate, "yyyy-MM-dd")
          .toString()
      )
    ) {
      this.getALlreqestData(
        this.approvalchange.branchid,
        this.datePipe.transform(this.approvalchange.fromdate, "yyyy-MM-dd"),
        this.datePipe.transform(this.approvalchange.todate, "yyyy-MM-dd"),
        this.approvalchange.type,
        this.approvalchange.status,
        0
      );
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Correct Date Range  ",
        "OK"
      );
    }
  }
  closeApprovalRequestModal() {
    document.getElementById("approvalRequestModal").style.display = "none";
  }
  billCancelobject: billCancelReuest = {};
  disablemodifictionbtn: boolean = true;
  ModifitdataApproved(event: MatCheckboxChange, data): void {

    if (event.checked == true) {
      if (this.approvalchange.type == "Discount") {
        this.billDiscountApprovalRequest(data);
      } else if (this.approvalchange.type == "BillRefund") {
        this.billDiscountApprovalRequest(data);
      } else {
        this.DiscountApprovaldata = {};
        this.disablemodifictionbtn = false;
        this.DiscountApprovaldata.FK_BillID = data.fK_BillID;
        this.DiscountApprovaldata.PK_TranID = data.pK_TranID;
        this.DiscountApprovaldata.reason = data.reason;
      }
    } else {

      this.DiscountApprovaldata = {};
      this.disablemodifictionbtn = true;
    }
  }
  billcancelRequestApproval() {
    let payload = {
      "CancelBill": this.billCancelobject
    }
    this.billingservice.savebillcancel(payload).subscribe((item: any) => {

      if (item.statusCode == 1) {
        this.getlastBill(this.getBillId);
        this.getbills(
          this.dashboardService.selecteddate,
          this.dashboardService.selecteddate
        );
        this.closeApprovalRequestCommentModal();
      } else if (item.statusCode == 1) {
        this.dashboardService.openSnackBar("Request user have only permission", "OK");
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  typeshowcomment: string = "";
  openpopupReject(comment) {
    this.typeshowcomment = comment;

    document.getElementById("RejectRequestCommentModal").style.display =
      "block";


  }
  closeRejectRequestCommentModal() {
    this.DiscountApprovaldata = {};
    document.getElementById("RejectRequestCommentModal").style.display = "none";
  }
  billModificationRequest(event, type, status) {
    if (status == "Approve") {
      status = "Approved";
    }
    this.discountAppproved(event, type, status);
  }
  newDiscountApprovaldata: BillingApprovalChange[] = [];
  DiscountApprovaldata: DiscountApprovalChange = {};
  discountServiceArray: any = [];
  partytpaArray: PartyTpaModel[] = [];
  getpatiendtdData(id: number) {
    if (id != null && id != undefined && id > 0) {
      this.opdvisitService
        .getpatientdetailsforReciept(id).pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          this.getPatientDetailData = data;
          var tdate = null;
          if (data.dob != null) {
            this.getPatientDetailData.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
            this.getages(data.dob);
          } else {
            tdate = new Date(data.regDate);
            this.getPatientDetailData.ageYear = this.getPatientDetailData.ageYear != null ? this.getPatientDetailData.ageYear : 0;
            this.getPatientDetailData.ageMonth = this.getPatientDetailData.ageMonth != null ? this.getPatientDetailData.ageMonth : 0;
            this.getPatientDetailData.ageDays = this.getPatientDetailData.ageDays != null ? this.getPatientDetailData.ageDays : 0;
            tdate.setDate(tdate.getUTCDate() - this.getPatientDetailData.ageDays);
            tdate.setMonth(tdate.getMonth() - this.getPatientDetailData.ageMonth);
            tdate.setFullYear(tdate.getFullYear() - this.getPatientDetailData.ageYear);
            this.getPatientDetailData.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
            this.getDataDiffsAppt(new Date(this.getPatientDetailData.dob), new Date(this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd")));
          }
        });
    }
  }
  getages(selecteddate: string) {

    var oms = selecteddate.split("T");
    let container = oms[0].split("-");
    let selecteddate_converted = container[0] + "/" + container[1] + "/" + container[2];
    let currenttime = this.datePipe.transform(new Date(), "hh:mm:ss");
    let dateofbirth = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");

    let currentdate = this.datePipe.transform(new Date, "yyyy-MM-dd");
    let container2 = currentdate.split("-");
    this.getDataDiffsAppt(new Date(dateofbirth), new Date(currentdate));
  }
  getDataDiffsAppt(start, end) {
    let years: number = 0, months: number = 0, days: number;
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }
    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.getPatientDetailData.ageYear = Math.abs(years);
    this.getPatientDetailData.ageMonth = Math.abs(months);
    this.getPatientDetailData.ageDays = Math.abs(days);


  }
  billDiscountApprovalRequest(data) {
    if (
      this.checktyperequest == 1 &&
      data.approvalType == "Discount" &&
      data.status == "Pending"
    ) {
      this.SelectpatientName = data.patientName;
      this.SelectpatientId = data.patientID;
      this.getpatiendtdData(data.patientID);
      this.newDiscountApprovaldata = [];
      this.DiscountApprovaldata = {};

      if (this.approvalchange.type == "Discount" && data.status == "Pending") {
        this.DiscountApprovaldata.discountreason = data.reason;
        this.DiscountApprovaldata.rdAmount = data.discount;
        this.DiscountApprovaldata.FK_BillID = data.fK_BillID;
        this.DiscountApprovaldata.PK_TranID = data.pK_TranID;
        this.DiscountApprovaldata.reason = data.reason;
        this.newDiscountApprovaldata.push(data);
        this.billDiscountApprovalRequestModal();
        this.billingservice.get_Bill_billId(data.fK_BillID).pipe(takeUntil(this.destroy$)).subscribe(
          (x: any) => {

            this.discountServiceArray = [];
            this.partytpaArray = [];
            let addisedit = x.billDetailDtos.map((xy) => ({
              ...xy,
              isEdit: false,
            }));
            this.discountServiceArray = addisedit;
            this.partytpaArray = x.billDebitDetailDtos;

            this.DiscountApprovaldata.partytpaName =
              this.billingservice.partytpa.filter(
                (item) => item.pkPartyId == this.partytpaArray[0].fK_PartyId
              )[0].partyName;
            this.calucatediscountScreendata(this.discountServiceArray, 0);
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
      }
    } else if (
      this.checktyperequest == 1 &&
      data.approvalType == "BillRefund" &&
      data.status == "Pending"
    ) {
      this.SelectpatientName = data.patientName;
      this.SelectpatientId = data.patientID;
      this.getpatiendtdData(data.patientID);
      this.DiscountApprovaldata.reqAmt = data.reqAmt;
      this.DiscountApprovaldata.FK_BillID = data.fK_BillID;
      this.DiscountApprovaldata.PK_TranID = data.pK_TranID;
      this.DiscountApprovaldata.reason = data.reason;

      this.billRefundApprovalRequestModal();
    }
  }
  ondiscountPercent(e: any, index: number) {

    if (e > 100) {
      this.discountServiceArray[index].disPer = 0;
      this.discountServiceArray[index].discount = 0;
      this.discountServiceArray[index].netAmt = this.discountServiceArray[index].rate;
      this.calucatediscountScreendata(this.discountServiceArray, 1);
      this.dashboardService.openSnackBar(
        "Discount Percent Not more than 100 ",
        "OK"
      );

      this.savediscountbuttonenable = true;
    } else if (e === null || e === undefined || e == "") {
      this.savediscountbuttonenable = true;
      this.discountServiceArray[index].disPer = 0;
      this.discountServiceArray[index].discount = 0;
      this.discountServiceArray[index].netAmt = parseFloat(
        (
          this.discountServiceArray[index].rate -
          parseFloat(this.discountServiceArray[index].discount) +
          parseFloat(this.discountServiceArray[index].serviceCharges)
        ).toFixed(2)
      );

      this.calucatediscountScreendata(this.discountServiceArray, 1);
    } else {
      this.savediscountbuttonenable = false;
      var Newdiscount = (this.discountServiceArray[index].rate * e) / 100;
      this.discountServiceArray[index].discount = Newdiscount;
      this.discountServiceArray[index].netAmt = parseFloat(
        (
          this.discountServiceArray[index].rate -
          parseFloat(this.discountServiceArray[index].discount) +
          parseFloat(this.discountServiceArray[index].serviceCharges)
        ).toFixed(2)
      );
      this.calucatediscountScreendata(this.discountServiceArray, 1);
    }
  }
  ondiscountAmount(e: any, index: number) {

    if (e > this.discountServiceArray[index].rate) {
      this.savediscountbuttonenable = true;
      this.discountServiceArray[index].discount = 0;
      this.discountServiceArray[index].disPer = 0;
      this.discountServiceArray[index].netAmt =
        this.discountServiceArray[index].rate;
      this.dashboardService.openSnackBar(
        "Discount Amount Not more than Current Amount ",
        "OK"
      );
      this.calucatediscountScreendata(this.discountServiceArray, 1);
    } else if (e === null || e === undefined || e == "") {
      this.savediscountbuttonenable = true;
      this.discountServiceArray[index].discount = 0;
      this.discountServiceArray[index].disPer = 0;
      this.discountServiceArray[index].netAmt = parseFloat(
        (
          parseFloat(this.discountServiceArray[index].rate) +
          parseFloat(this.discountServiceArray[index].serviceCharges)
        ).toFixed(2)
      );
      this.calucatediscountScreendata(this.discountServiceArray, 1);
    } else {
      this.savediscountbuttonenable = false;
      this.discountServiceArray[index].discount = parseFloat(e);
      this.discountServiceArray[index].netAmt = parseFloat(
        (
          parseFloat(this.discountServiceArray[index].rate) +
          parseFloat(this.discountServiceArray[index].serviceCharges) -
          parseFloat(e)
        ).toFixed(2)
      );
      const discountper =
        (this.discountServiceArray[index].discount * 100) /
        this.discountServiceArray[index].rate;
      this.discountServiceArray[index].disPer = discountper.toFixed(2);
      this.calucatediscountScreendata(this.discountServiceArray, 1);
    }
  }
  changeStausforEdit(index, type) {
    this.discountServiceArray[index].isEdit = type == 0 ? true : false;
  }
  calucatediscountScreendata(discountServicedata, type) {

    this.DiscountApprovaldata.totalamount = 0;
    this.DiscountApprovaldata.servicecharge = 0;
    this.DiscountApprovaldata.discountamount = 0;
    this.DiscountApprovaldata.gst = 0;
    this.DiscountApprovaldata.netbillamount = 0;

    discountServicedata?.forEach((item) => {
      this.DiscountApprovaldata.totalamount =
        this.DiscountApprovaldata.totalamount + item.rate;
      this.DiscountApprovaldata.servicecharge =
        this.DiscountApprovaldata.servicecharge + item.serviceCharges;
      this.DiscountApprovaldata.discountamount = (
        parseFloat(this.DiscountApprovaldata.discountamount) +
        parseFloat(item.discount)
      ).toFixed(2);
      if (item.gstPer != null) {
        this.DiscountApprovaldata.gst =
          this.DiscountApprovaldata.gst + item.gstPer;
      }

      this.DiscountApprovaldata.netbillamount =
        this.DiscountApprovaldata.netbillamount + item.netAmt;
    });
    // this.DiscountApprovaldata.netbillamount=this.DiscountApprovaldata.netbillamount + this.DiscountApprovaldata.servicecharge;
    if (type == 0) {
      this.DiscountApprovaldata.discountamountpercent = 0;
      this.DiscountApprovaldata.discountamountpercent = (
        (this.DiscountApprovaldata.rdAmount * 100) /
        this.DiscountApprovaldata.totalamount
      ).toFixed(2);
      this.DiscountApprovaldata.updatediscountpercent =
        this.DiscountApprovaldata.discountamountpercent;
    } else {
      for (var i = 0; i < this.partytpaArray.length; i++) {
        if (this.partytpaArray.length == 2) {
          this.partytpaArray[0].amount =
            this.DiscountApprovaldata.netbillamount -
            this.partytpaArray[1].amount;
        } else {
          this.partytpaArray[i].amount =
            this.DiscountApprovaldata.netbillamount;
        }

        this.partytpaArray[i].totalRecovered =
          this.partytpaArray[i].totalRecovered == null
            ? 0
            : this.partytpaArray[i].totalRecovered;
      }
    }

  }
  savediscountbuttonenable: boolean = true;
  updateDiscountdata(percent) {

    if (this.discountServiceArray.length > 0) {
      if (100 >= percent && percent >= 0) {
        this.savediscountbuttonenable = false;
        for (var i = 0; i < this.discountServiceArray.length; i++) {
          this.discountServiceArray[i].disPer = parseFloat(percent);
          this.discountServiceArray[i].discount = parseFloat(
            (
              (this.discountServiceArray[i].rate * parseFloat(percent)) /
              100
            ).toFixed(2)
          );
          this.discountServiceArray[i].netAmt =
            this.discountServiceArray[i].rate +
            this.discountServiceArray[i].serviceCharges -
            this.discountServiceArray[i].discount;
        }
        this.calucatediscountScreendata(this.discountServiceArray, 1);
      } else {
        this.dashboardService.openSnackBar("Enter Correct Value", "ok");
      }
    }
  }
  MakeroundDiscountdata() {
    if (this.discountServiceArray.length > 0) {
      for (var i = 0; i < this.discountServiceArray.length; i++) {
        this.discountServiceArray[i].discount = Math.round(
          this.discountServiceArray[i].discount
        );
        this.discountServiceArray[i].netAmt =
          this.discountServiceArray[i].rate +
          this.discountServiceArray[i].serviceCharges -
          this.discountServiceArray[i].discount;
      }
      this.calucatediscountScreendata(this.discountServiceArray, 1);
    }
  }

  updatebillingApproval(event, type, status) {
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);
    setTimeout(function () {
      button.removeAttribute("disabled");
    }, 1000);
    if (this.DiscountApprovaldata.discountamount > 0) {
      if (this.DiscountApprovaldata.rdAmount >= this.DiscountApprovaldata.discountamount) {
        let payload = {
          ApprovalDetail: {
            IsEdit: true,
            PK_TranID: this.DiscountApprovaldata.PK_TranID,
            FK_BillID: this.DiscountApprovaldata.FK_BillID,
            ApprovalType: type,
            Status: status,
            ApproverNotes: this.DiscountApprovaldata.remarks,
            ApprovalDate: this.authService.getServerDate,
            ApprovalTime: new Date().toTimeString().split(" ")[0],
            RequestUsed: 1
          },
          BillMaster: {
            TotalAmt: this.DiscountApprovaldata.totalamount,
            GSTAmount: this.DiscountApprovaldata.gst,
            DiscountAmt: this.DiscountApprovaldata.discountamount,
            NetBillAmt: this.DiscountApprovaldata.netbillamount,
            FreeReason: this.DiscountApprovaldata.remarks,
          },
          BillDetail: this.discountServiceArray,
          BillDebitDetail: this.partytpaArray,
        };
        this.billingservice.updateBillingApproval(payload).pipe(takeUntil(this.destroy$)).subscribe(
          (x: any) => {
            this.dashboardService.openSnackBar(
              "Successfully Approved Your Request",
              "ok"
            );

            this.getALlreqestData(
              this.authService.Loggeduser.branchid,
              this.authService.getServerDate,
              this.authService.getServerDate,
              this.approvalchange.type,
              0,
              0
            );
            this.closeBillDiscountApprovalRequestModal();
          },
          (err) => {
            this.dashboardService.openSnackBar("API Failed", "ok");
          }
        );
      } else {
        this.dashboardService.openSnackBar(
          "Request discount Amount can't more than discount amount",
          "ok"
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        "Discount Amount More than Zero",
        "ok"
      );
    }
  }

  // discountAppproved(event, type, status) {
  //   const button =
  //     event.srcElement.disabled === undefined
  //       ? event.srcElement.parentElement
  //       : event.srcElement;
  //   button.setAttribute("disabled", true);
  //   setTimeout(function () {
  //     button.removeAttribute("disabled");
  //   }, 1000);
  //   if (status == "Reject" || type == "Modification" || type == "BillRefund" || type == "Cancell") {
  //     if (type == "BillRefund") {
  //       if (
  //         Number(this.DiscountApprovaldata.approvedAmount) >
  //         Number(this.DiscountApprovaldata.reqAmt)
  //       ) {
  //         return this.dashboardService.openSnackBar(
  //           "Approved Amount Can't More than Request Amount",
  //           "ok"
  //         );
  //       } else if (Number(this.DiscountApprovaldata.approvedAmount) <= 0) {
  //         return this.dashboardService.openSnackBar(
  //           "Approved Amount Can't Zero or less than Zero",
  //           "ok"
  //         );
  //       }
  //     }
  //     let payload = {
  //       ApprovalDetail: {
  //         IsEdit: true,
  //         PK_TranID: this.DiscountApprovaldata.PK_TranID,
  //         FK_BillID: this.DiscountApprovaldata.FK_BillID,
  //         ApprovalType: type,
  //         Status: status,
  //         Reason: this.DiscountApprovaldata.reason,
  //         ApproverNotes: this.DiscountApprovaldata.remarks,
  //         ApprovalDate: this.authService.getServerDate,
  //         ApprovalTime: new Date().toTimeString().split(" ")[0],
  //         ApprovedAmount: this.DiscountApprovaldata.approvedAmount,
  //       },
  //     };
  //     this.billingservice.insertBillingApproval(payload).pipe(takeUntil(this.destroy$)).subscribe(
  //       (x: any) => {
  //         if (status == "Reject") {
  //           this.dashboardService.openSnackBar(
  //             "The Request Successfully Rejected.",
  //             "ok"
  //           );
  //         } else {
  //           // this.dashboardService.openSnackBar("Successfully Approved Your Request", "ok");
  //           this.billModificationRequestApprovalModal();
  //         }
  //         this.disablemodifictionbtn = true;
  //         this.closeRejectRequestCommentModal();
  //         this.closeBillreundApprovalRequestModal();
  //         this.getALlreqestData(
  //           this.authService.Loggeduser.branchid,
  //           this.authService.getServerDate,
  //           this.authService.getServerDate,
  //           this.approvalchange.type,
  //           this.approvalchange.status,
  //           0
  //         );
  //         this.closeBillDiscountApprovalRequestModal();
  //       },
  //       (err) => {
  //         if (err.status == 403) {
  //           this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  //         }
  //         else if (err.error.statusCode == 422) {
  //           this.dashboardService.openSnackBar(err.error.message, "OK");
  //         }
  //         else {
  //           this.dashboardService.openSnackBar("API Failed", "OK");
  //         }
  //       }
  //     );
  //   } else {
  //     this.dashboardService.openSnackBar(
  //       "Discount Amount More than Zero",
  //       "ok"
  //     );
  //   }
  // }
  discountAppproved(event: any, type: string, status: string): void {
    const button = event.srcElement?.disabled === undefined
      ? event.srcElement.parentElement
      : event.srcElement;

    button?.setAttribute("disabled", "true");
    setTimeout(() => button?.removeAttribute("disabled"), 1000);

    const data = this.DiscountApprovaldata;
    const approvedAmount = Number(data.approvedAmount);
    const requestedAmount = Number(data.reqAmt);

    // Validate for BillRefund
    if (type === "BillRefund") {
      if (approvedAmount > requestedAmount) {
        this.dashboardService.openSnackBar("Approved Amount Can't More than Request Amount", "ok");
        return;
      }
      if (approvedAmount <= 0) {
        this.dashboardService.openSnackBar("Approved Amount Can't Zero or less than Zero", "ok");
        return;
      }
    }

    // Only proceed for these statuses/types
    const isAllowedStatus = ["Reject", "Modification", "BillRefund", "Cancell", "ReceiptModification"].includes(type);
    if (!isAllowedStatus) {
      this.dashboardService.openSnackBar("Discount Amount More than Zero", "ok");
      return;
    }

    const payload = {
      ApprovalDetail: {
        IsEdit: true,
        PK_TranID: data.PK_TranID,
        FK_BillID: data.FK_BillID,
        ApprovalType: type,
        Status: status,
        Reason: data.reason,
        ApproverNotes: data.remarks,
        ApprovalDate: this.authService.getServerDate,
        ApprovalTime: new Date().toTimeString().split(" ")[0],
        ApprovedAmount: approvedAmount,
      }
    };

    this.billingservice.insertBillingApproval(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (status === "Reject") {
            this.dashboardService.openSnackBar("The Request Successfully Rejected.", "ok");
          } else {
            this.billModificationRequestApprovalModal();
          }

          this.disablemodifictionbtn = true;
          this.closeRejectRequestCommentModal();
          this.closeBillreundApprovalRequestModal();
          this.closeBillDiscountApprovalRequestModal();

          this.getALlreqestData(
            this.authService.Loggeduser.branchid,
            this.authService.getServerDate,
            this.authService.getServerDate,
            this.approvalchange.type,
            this.approvalchange.status,
            0
          );
        },
        error: (err) => {
          if (err.status === 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error?.statusCode === 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      });
  }

  approvalRequestCommentModal() {

    document.getElementById("approvalRequestCommentModal").style.display =
      "block";
  }
  closeApprovalRequestCommentModal() {
    this.billCancelobject = {};
    this.billCancelobject.CancelType = 'Cancel';
    document.getElementById("approvalRequestCommentModal").style.display =
      "none";
  }

  billModificationRequestApprovalModal() {
    document.getElementById(
      "billModificationRequestApprovalModal"
    ).style.display = "block";
  }
  closeBillModificationRequestApprovalModal() {
    document.getElementById(
      "billModificationRequestApprovalModal"
    ).style.display = "none";
  }

  raiseApprovalRequestModal() {
    document.getElementById("raiseApprovalRequestModal").style.display =
      "block";
  }
  closeRaiseApprovalRequestModal() {
    document.getElementById("raiseApprovalRequestModal").style.display = "none";
  }
  raiserefundApprovalRequestModal() {
    document.getElementById("raisereundApprovalRequestModal").style.display =
      "block";
  }
  closeRaiserefundApprovalRequestModal() {
    document.getElementById("raisereundApprovalRequestModal").style.display =
      "none";
  }
  billModificationRequestApprovedModal() {
    document.getElementById(
      "billModificationRequestApprovedModal"
    ).style.display = "block";
  }
  closeBillModificationRequestApprovedModal() {
    this.isselfrequest = false;
    document.getElementById(
      "billModificationRequestApprovedModal"
    ).style.display = "none";
  }

  approvalsModal(index) {
    this.mattabindex = index;
    this.requestDiscountAmount = {};
    this.approvebyName = "";
    this.dashboardService.subscriptions = this.billingservice
      .getRequestStatusdata(
        this.authService.Loggeduser.branchid,
        this.authService.getServerDate,
        this.authService.getServerDate,
        0,
        0,
        this.getBillId
      ).pipe(takeUntil(this.destroy$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            const checkrequest = x.filter((item) => item.status == "Pending");
            if (checkrequest.length > 0) {
              this.dashboardService.openSnackBar(
                "Already pending for " + checkrequest[0].approvalType,
                "ok"
              );
            } else {
              document.getElementById("approvalsModal").style.display = "block";
            }
          } else {
            document.getElementById("approvalsModal").style.display = "block";
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "ok");
        }
      );
  }
  closeApprovalsModal() {
    document.getElementById("approvalsModal").style.display = "none";
  }

  billDiscountApprovalRequestModal() {
    document.getElementById("billDiscountApprovalRequestModal").style.display =
      "block";
  }

  closeBillDiscountApprovalRequestModal() {
    document.getElementById("billDiscountApprovalRequestModal").style.display =
      "none";
  }
  billRefundApprovalRequestModal() {
    document.getElementById("billrefundApprovalRequestModal").style.display =
      "block";
  }
  closeBillreundApprovalRequestModal() {
    document.getElementById("billrefundApprovalRequestModal").style.display =
      "none";
  }
  approvalSearchModal() {
    document.getElementById("approvalSearch").style.display = "block";
  }
  closeApprovalSearchModal() {
    document.getElementById("approvalSearch").style.display = "none";
  }
  billPreview(data) {
    // this.getPrintInvoice(data.fK_BillID);
    this.printTimelineBill(3, data.fK_BillID, data.patientID);
  }
  closeusrDiscountRequestModal() {
    document.getElementById("userDiscountRequestModal").style.display = "none";
  }
  billSummerycheckprint(billid) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/print-receipt/${billid}/${this.opdvisitService.patientdetails.pkRegId}`])
    );

    window.open(url, '_blank');
  }
  checklastlocation(visitid): void {
    if (visitid > 0) {
      this.dashboardService.getlastvisittransfer(this.opdvisitService.patientdetails.pkRegId, visitid).pipe(takeUntil(this.destroy$)).subscribe((item: any) => {
        if (item.length > 0) {
          this.dashboardService.docterEmr.locationId = item[0].fK_PatientLocationId;
          this.dashboardService.docterEmr.isDilated = item[0].isDilated;

        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }
  }
  fillusers(usertypeid: number) {

    var pname =
      this.opdvisitService.patientdetails.firstName +
      " " +
      this.opdvisitService.patientdetails.lastName;
    var pid = this.opdvisitService.getlastvisitid;
    if (this.authService.masterdata.isPatientTransfer == true) {
      if (
        this.dashboardService.docterEmr.locationId == usertypeid &&
        usertypeid == 1
      ) {
        return this.dashboardService.openSnackBar(
          "The Patient Is Already At Reception",
          "Ok"
        );
      }
      if (
        this.dashboardService.docterEmr.locationId == usertypeid &&
        usertypeid == 9
      ) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg11"],
          this.authService.validationMsg["Ok"]
        );
      }
      if (
        this.dashboardService.docterEmr.locationId == usertypeid &&
        usertypeid == 10
      ) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg12"],
          this.authService.validationMsg["Ok"]
        );
      }
      this.open_loader_Dialog();
      // return
      if (usertypeid == 10) {

        if (this.dashboardService.docterEmr.isDilated != 1) {
          this.return_patient(pid, this.dashboardService.docterEmr.locationId, usertypeid);
        } else {
          this.dashboardService.openSnackBar(
            this.authService.validationMsg["dashboardValidMsg.msg13"],
            this.authService.validationMsg["Ok"]
          );
        }
      } else if (usertypeid == 1) {

        this.move_patient_reception(
          pid,
          this.dashboardService.docterEmr.locationId, usertypeid
        );
      } else if (usertypeid == 9) {

        this.move_patient_waiting(
          pid,
          this.dashboardService.docterEmr.locationId, usertypeid
        );
      } else {
        // this.selectedRowIndex = pid;
        //this.dashboardService.showspinner = true;
        this.dashboardService.pid = pid;
        this.dashboardService.pname = pname;
        this.dashboardService.prelocationid = this.dashboardService.docterEmr.locationId;
        this.dashboardService.docterEmr.locationId = usertypeid;
        this.dashboardService.locationid = usertypeid;
        this.get_usertype_list(usertypeid);
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg14"],
        this.authService.validationMsg["Ok"]
      );
    }

  }

  move_patient_waiting(visitid: number, prelocationid: number, currentloc: any) {
    this.openWaitingDialog(visitid);
  }
  openWaitingDialog(visitid: number): void {
    const dialogRef = this.dialog.open(WaitingReasonComponent, {
      panelClass: 'full-width-dialog',

      height: '30%',
      width: '40%',
      data: {
        // remark: remark,
        visitid: visitid,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

      this.dialog.closeAll();
      if (this.dashboardService.waitingreason == true) {
        this.closetrasnferdata();

      }

      //pid = result;
    });
  }
  closetrasnferdata() {
    this.closebutton.nativeElement.click();

  }




  failedopdvisit(err) {
    //this.dialog.closeAll();
    this.dashboardService.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  openDialog(): void {

    const dialogRef = this.dialog.open(PatientMoveDialogComponent, {

      width: '800px',
      data: {
        name: this.dashboardService.pname,
        id: this.dashboardService.pid,
        usertypeid: this.dashboardService.locationid,
        userid: this.authService.Loggeduser.userid,
        prelocationid: this.dashboardService.prelocationid,
        usertype: this.dashboardService.usertypestring,
        patientInfo: this.dashboardService.docterEmr

      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      //  
      // this.selectedRowIndex = -1;

      if (this.dashboardService.popup_cancel != true) {
        this.closetrasnferdata();
        if (result != '0' && result != null) {
          this.ChangeCallStatus(result.roomName, result.loginroomId, 'TRANSFER');
        }
      }
      this.dialog.closeAll();

      //pid = result;
    });
  }
  getusertype() {
    switch (this.dashboardService.locationid) {
      case 3: {
        this.dashboardService.usertypestring = "CD(S)";
        break;
      }
      case 4: {
        this.dashboardService.usertypestring = "AR(S)";
        break;
      }
      case 5: {
        this.dashboardService.usertypestring = "OP(S)";
        break;
      }
      case 6: {
        this.dashboardService.usertypestring = "DOCTOR(S)";
        break;
      }
      case 7: {
        this.dashboardService.usertypestring = "CS(S)";
        break;
      }
      case 8: {
        this.dashboardService.usertypestring = "PR(S)";
        break;
      }
      case 23: {
        this.dashboardService.usertypestring = "PHY(S)";
        break;
      }
    }
  }

  get_usertype_list(usertypeid: number) {
    //  
    if (usertypeid == 6) {
      this.dashboardService.getall_doctors().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
    else if (usertypeid == 5) {
      this.dashboardService.getall_ops().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
    else if (usertypeid == 4) {
      this.dashboardService.getall_ars().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
    else if (usertypeid == 3) {
      this.dashboardService.getall_cds().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
    else if (usertypeid == 7) {
      this.dashboardService.getall_css().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
    else if (usertypeid == 8) {
      this.dashboardService.getall_prs().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
    // physician
    else if (usertypeid == 23) {
      this.dashboardService.getall_physicians().pipe(takeUntil(this.destroy$)).
        subscribe(data => this.success_usertype_list(data), err => this.failed_usertype_list(err));
    }
  }
  success_usertype_list(data) {
    this.dashboardService.usertype_list = data;
    this.dialog.closeAll();
    this.getusertype();
    this.openDialog();
  }

  failed_usertype_list(err) {
    this.dashboardService.pid = null;
    this.dashboardService.pname = null;
    this.dashboardService.locationid = null;
    this.dashboardService.prelocationid = null;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  return_patient(visitid: number, prelocationid: number, currentloc: any) {
    this.dashboardService.getlocationType(visitid, this.authService.Loggeduser.userid, 0, this.authService.Loggeduser.branchid, prelocationid, currentloc, 0).pipe(takeUntil(this.destroy$)).

      subscribe(data => this.success_patient_moved(data),
        err => this.failed_patient_moved(err));
  }
  success_patient_moved(data) {
    this.closetrasnferdata();
    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg15'], this.authService.validationMsg['Ok']);
    this.dialog.closeAll();
    this.ChangeCallStatus(this.authService.Loggeduser.room, this.authService.Loggeduser.roomid, 'RETURN');
  }
  failed_patient_moved(err) {
    this.closetrasnferdata();
    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg16'], this.authService.validationMsg['Ok']);
    this.dialog.closeAll();
  }

  move_patient_reception(visitid: number, prelocationid: number, currentloc) {
    this.dashboardService.getlocationType(visitid, this.authService.Loggeduser.userid, 0, this.authService.Loggeduser.branchid, prelocationid, currentloc, 0).pipe(takeUntil(this.destroy$)).

      subscribe(data => this.success_patient_moved_reception(data),
        err => this.failed_patient_moved_reception(err));
  }
  success_patient_moved_reception(data) {
    this.closetrasnferdata();
    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg17'], this.authService.validationMsg['Ok']);
    this.dialog.closeAll();
    this.ChangeCallStatus(this.authService.Loggeduser.room, this.authService.Loggeduser.roomid, 'TRANSFER');
  }
  failed_patient_moved_reception(err) {
    this.closetrasnferdata();
    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg16'], this.authService.validationMsg['Ok']);
    this.dialog.closeAll();
  }
  ChangeCallStatus(roomName: any, roomid: any, type: any) {

    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
    var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
    var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
    if (queueproty[0]?.propertyValue == 'Y' && queueurl[0]?.propertyValue != null && queueurl[0]?.propertyValue != undefined && queuetoken[0]?.propertyValue != null && queuetoken[0]?.propertyValue != undefined) {
      const headers = new HttpHeaders().set('X-API-KEY', `${queuetoken[0]?.propertyValue}`);
      this.http.get<any>(queueurl[0]?.propertyValue + "Interface/GetVisitcalldetails/" + this.opdvisitService.patientdetails.pkRegId + '/' + this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd") + '/' + this.authService.Loggeduser.branchid, { headers }).pipe(takeUntil(this.destroy$)).subscribe((resp) => {

        if (type == 'CALL' && resp.isCall == 'Y') {
          return this.dashboardService.openSnackBar("Patient Already Called", "OK");
        } else if (type == 'DisConnect' && resp.isCall == 'N') {
          this.dashboardService.openSnackBar("Patient Already Aborted", "OK");
        } else {
          if (resp.fK_VisitId > 0) {
            let queuevisitObj = {
              "PK_VisitId": resp.pK_VisitId,
              "FK_RegID": this.opdvisitService.patientdetails.pkRegId,
              "fk_visitid": resp.fK_VisitId,
              "Remarks": type,
              "RoomName": roomName,
              "Fk_CreatedById": this.authService.Loggeduser.userid,
              "Fk_RoomId": roomid ? roomid : this.authService.Loggeduser.roomid,
              "fk_branchid": this.authService.Loggeduser.branchid,
            }
            this.http.post<any>(queueurl[0]?.propertyValue + "Interface/UpdatePatientCallStatus", queuevisitObj, { headers }).pipe(takeUntil(this.destroy$)).subscribe((resp) => {

              if (type == 'DisConnect') {
                this.dashboardService.openSnackBar("Call aborted successfully", "OK");
              } else if (type == 'CALL') {
                this.dashboardService.openSnackBar("Patient called successfully", "OK");
              }

            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            })
          }

        }
      })

    }
  }
  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }

  formatToHHmm(time: string): string {
    if (!time) return '';

    const isValidTime = /^\d{2}:\d{2}(:\d{2})?$/.test(time);
    if (!isValidTime) return '';

    const date = new Date(`1970-01-01T${time}`);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const paddedHours = hours < 10 ? '0' + hours : hours.toString();
    const paddedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();

    return `${paddedHours}:${paddedMinutes}`;
  }

}
